/* ============================================================
   Bisou Rivage — Framed Wall Planner (page /pages/framed-wall-planner)
   Adapté de la maquette composer-mockup v5.1 → branché Shopify :
   - Catalogue : window.BRPlanner.products (généré en Liquid, variantes réelles)
   - Prix : variantes réelles (cents) · Panier : /cart/add.js
   - Wishlist : window.BisouWishlist (br_wishlist_v1) — fallback interne
   - Remises paliers : codes promo optionnels (cfg.codes) appliqués via /discount/
   - Cadres à leurs cotes extérieures (RÖDALM d'IKEA, 21/10) : A4 32×42 · A3 42×52 · A2 52×72 cm
   - Accroche standard 160 cm. Tout encadré (variantes « sans cadre » exclues).
   Entrées : ?ids={a},{b}&fmt=A4&frame=noir (page produit : le tirage et son compagnon)
   · ?id={handle} (le tirage + un compagnon) · ?vide (bandeau)
   · sans paramètre : le mur composé est gardé ; sinon un diptyque proposé.
     (ALT 15/10/2026, retour Max : plus de place vide, deux petits « + » hors du mur.)
   Suggestions (décision de Max, 16/10/2026) : toujours le même sens, jamais un tirage
   déjà au panier, jamais de hasard. Ordre : coups de cœur, vus récemment (bisou-vus),
   duos de l'équipe (cfg.teamDuos, vide aujourd'hui), puis le catalogue dans son ordre.
   « Autre suggestion » remplace « Au hasard » et suit cet ordre ; le choix d'un tirage
   montre d'abord les coups de cœur, puis les tirages vus récemment.
   ============================================================ */
(function () {
  'use strict';

  var BOOT = window.BRPlanner || {};
  var LANG = BOOT.lang || {};
  function t(key, fallback) {
    var v = LANG[key];
    return (typeof v === 'string' && v) ? v : fallback;
  }
  function tfill(key, fallback, vars) {
    var s = t(key, fallback);
    for (var k in vars) {
      if (Object.prototype.hasOwnProperty.call(vars, k)) {
        s = s.split('{' + k + '}').join(vars[k]);
      }
    }
    return s;
  }
  var CFG = {
    maxFrames: 5,
    /* Le cadre à sa cote extérieure (cm, portrait [l,h]) : le RÖDALM 30 × 40 fait
       32 × 42, le 40 × 50 fait 42 × 52, le 50 × 70 fait 52 × 72 (ikea.com, relevé le
       21/10 ; décision 15 de Max). Le mur, l'écart et le plan d'accrochage se
       comptent sur ces cotes ; `print` garde le format du tirage, qui s'affiche. */
    dims: { A4: [32, 42], A3: [42, 52], A2: [52, 72] },
    print: { A4: [30, 40], A3: [40, 50], A2: [50, 70] },
    formats: ['A2', 'A3', 'A4'],
    frames: [
      { key: 'noir',    label: t('frame_noir', 'Noir'),       sw: '#222222' },
      { key: 'blanc',   label: t('frame_blanc', 'Blanc'),     sw: '#ffffff' },
      { key: 'chene',   label: t('frame_chene', 'Chêne'),     sw: '#b8956a' },
      { key: 'bouleau', label: t('frame_bouleau', 'Bouleau'), sw: '#d4c4a8' }
    ],
    satLevels: [0, 9, 17, 25, 33],
    hangLine: 160, drillDrop: 3, gap: 7, margin: 5,
    /* Calibrage des mockups. Mesuré le 02/09/2026 sur six produits, trois
       artistes et deux résolutions de toile (4000x3200 et 2500x2000) : les
       mockups sortent d'un pipeline régulier, le cadre occupe TOUJOURS la même
       fraction de la toile — à 0,3 % près — et il y est centré.
       Valeurs en PORTRAIT [largeur, hauteur] ; le paysage est la transposée.
       Sans ce calibrage, `object-fit: contain` laissait le cadre flotter dans sa
       boîte : A4 −21 %, A3 −15 %, A2 −13 %, et pas du même montant d'un format
       à l'autre. Le mur vu n'avait donc ni les bonnes tailles relatives ni le
       bon écart — alors que le plan d'accrochage, lui, est calculé sur les
       boîtes et reste juste. Voir mockupFill(). */
    mockup: { A4: [0.7801, 0.8213], A3: [0.8386, 0.8388], A2: [0.8627, 0.9565] },
    /* Le panier dans la langue de la page : /en/cart depuis l'anglais */
    cartUrl: ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart',
    defaultWall: { w: 200, h: 250 }
  };
  /* name = libellé affiché, traduit (aussi dans la propriété de panier, voir compoCartName) */
  var DISPO = [
    { n: 1, label: '1 cadre', name: t('compo_name_1', 'un seul tirage') },
    { n: 2, label: '2 cadres (diptyque)', name: t('compo_name_2', 'diptyque') },
    { n: 3, label: '3 cadres (triptyque)', name: t('compo_name_3', 'triptyque') },
    { n: 4, label: '4 cadres (tétraptyque)', name: t('compo_name_4', 'tétraptyque') },
    { n: 5, label: '5 cadres (pentaptyque)', name: t('compo_name_5', 'pentaptyque') }
  ];
  var FRAME_KEYS = CFG.frames.map(function (f) { return f.key; });
  var GHOST = [42, 52];

  /* ---------- catalogue depuis les produits Liquid ---------- */
  function norm(s) {
    s = (s || '').toLowerCase().normalize('NFD');
    var out = '';
    for (var i = 0; i < s.length; i++) { var c = s.charCodeAt(i); if (c < 768 || c > 879) out += s.charAt(i); }
    return out;
  }
  /* Les variantes arrivent dans la langue du visiteur : depuis la traduction
     des produits (25/10), la page anglaise reçoit « Black frame », « Unframed »,
     voire « A2 – black frame, 50 × 70 cm » en une seule option. Sans les mots
     anglais, aucune variante n'était reconnue et le mur restait vide.
     Même chose en espagnol (« Marco negro » ; « blanco » contient déjà
     « blanc ») et en japonais (「ブラックフレーム」) : le japonais se lit avant
     norm(), dont la décomposition sépare ブ et バ de leur signe sonore. */
  function frameOf(v) {
    var j = String(v || '');
    v = norm(v);
    if (/sans|unframed|no frame|sin marco/.test(v) || /フレームなし/.test(j)) return 'sans';
    if (/noir|black|negro/.test(v) || /ブラック/.test(j)) return 'noir';
    if (/blanc|white/.test(v) || /ホワイト/.test(j)) return 'blanc';
    if (/chene|\boak\b|roble/.test(v) || /オーク/.test(j)) return 'chene';
    if (/bouleau|birch|abedul/.test(v) || /バーチ/.test(j)) return 'bouleau';
    return null;
  }
  function fmtOf(v) {
    v = norm(v);
    if (/a2/.test(v)) return 'A2';
    if (/a3/.test(v)) return 'A3';
    if (/a4/.test(v)) return 'A4';
    return null;
  }
  var CAT = [];
  var catById = {};
  (BOOT.products || []).forEach(function (p) {
    var map = {}; // fmt -> frame -> {vid, price(cents), img, av}
    (p.vars || []).forEach(function (v) {
      var opts = [v.o1, v.o2, v.o3];
      var fr = null, fm = null;
      opts.forEach(function (o) {
        if (!fr) fr = frameOf(o);
        if (!fm) fm = fmtOf(o);
      });
      if (!fr || !fm || fr === 'sans') return;       // tout encadré
      if (!map[fm]) map[fm] = {};
      map[fm][fr] = { vid: v.id, price: v.p, img: v.img || p.thumb, av: v.av };
    });
    var fmts = CFG.formats.filter(function (k) { return map[k]; });
    if (!fmts.length) return;                         // produit sans variantes encadrées
    var cols = (p.cols || []).slice();
    var filterMap = (BOOT.cfg && BOOT.cfg.filters) || {};
    Object.keys(filterMap).forEach(function (handle) {
      if (handle !== '_all' && filterMap[handle].indexOf(p.h) > -1 && cols.indexOf(handle) < 0) cols.push(handle);
    });
    var tags = p.tags || [];
    var item = {
      id: p.h, title: p.t, url: p.url, vendor: p.vendor || '', tags: tags,
      /* Le Liquid résout l'édition (métachamp custom.br_edition_type, puis balise
         edition-ouverte, puis balise historique open) et envoie un booléen. Le test
         par sous-chaîne sur les balises ne sert plus que de repli. */
      open: (typeof p.open === 'boolean') ? p.open : tags.some(function (tag) { return norm(tag).indexOf('open') > -1; }),
      orient: p.orient, thumb: p.thumb, cols: cols, map: map, fmts: fmts,
      /* L'artiste vient du métaobjet `custom.artiste_reference`, résolu en
         Liquid. `product.vendor` vaut « Bisou Rivage » sur tous les tirages :
         le filtre « artiste » interrogeait donc une colonne constante. */
      artist: p.art || '', artistPic: p.apic || ''
    };
    item.vendor = item.artist || item.vendor;
    CAT.push(item); catById[p.h] = item;
  });

  /* ---------- wishlist globale (ou fallback même clé) ---------- */
  var WL = window.BisouWishlist || (function () {
    var KEY = 'br_wishlist_v1';
    function read() { try { var d = JSON.parse(localStorage.getItem(KEY)); return d && Array.isArray(d.items) ? d.items : []; } catch (e) { return []; } }
    function write(items) { try { localStorage.setItem(KEY, JSON.stringify({ v: 1, items: items })); } catch (e) {} }
    return {
      read: read,
      has: function (h) { return read().some(function (i) { return i.h === h; }); },
      toggle: function (d) {
        var items = read();
        if (items.some(function (i) { return i.h === d.h; })) { write(items.filter(function (i) { return i.h !== d.h; })); return false; }
        items.push(d); write(items); return true;
      }
    };
  })();

  /* ---------- état ---------- */
  var uidSeq = 1;
  var state = {
    frames: [],                 // {uid, id(handle), fmt, frame, x, y}
    region: { w: 160, h: 110 },
    scale: 'auto',
    wall: { w: CFG.defaultWall.w, h: CFG.defaultWall.h },
    /* Pas de teinte par défaut : les cadres flottent sur la page (v4, 21/10 : ni
       greige ni blanc). La v3 posait un greige chaud (#e9e5e0) sur un mur dessiné. */
    wallColor: { h: 35, s: 0, hex: null },
    wallColorSet: false,        // le visiteur a choisi la couleur lui-même
    sel: null,
    piece: null,               // la pièce choisie (null = « Mur uni »)
    targetCount: 3,
    previewMode: 'normal',
    rotated: false,
    largeZoom: 1.8,
    fsRestoreScale: null,
    ghosts: [],
    touched: false,             // le visiteur a composé lui-même (sinon on repart des coups de cœur)
    gap: CFG.gap,
    align: 'center',
    hang: CFG.hangLine,
    wallConfigured: false,
    tab: 'limited', filter: 'all', collection: 'all', artist: 'all',
    colsD: 4, colsM: 2,
    pickerTarget: null,
    pickerCols: 2,
    pickerFilter: 'all', pickerEdition: 'all', pickerCollection: 'all', pickerArtist: 'all'
  };
  /* Rien n'est retenu d'une visite à l'autre (Max, 28/10 : « ça a retenu mon mur, ça m'intéresse pas ») :
     on arrive toujours sur le mur uni, avec les réglages de départ. Les anciennes sauvegardes s'effacent. */
  try { localStorage.removeItem('br_planner_v2'); localStorage.removeItem('br_planner_v1'); } catch (e) {}

  /* ---------- le mur gardé pour le retour (v3, 21/10) ----------
     Un clic vers la fiche d'un tirage (son cartel, son titre, « Voir le tirage »)
     garde le mur tel qu'il est, pour cet onglet et cette adresse : au retour, le
     ?ids= de la fiche d'origine ne le remplace plus par les deux tirages de départ. */
  var BACK = 'br_planner_back';
  function keepForBack() {
    try {
      sessionStorage.setItem(BACK, JSON.stringify({
        q: window.location.search, touched: !!state.touched,
        frames: state.frames.map(function (f) { return { id: f.id, fmt: f.fmt, frame: f.frame }; })
      }));
    } catch (e) {}
  }
  function takeBack() {
    try {
      var d = JSON.parse(sessionStorage.getItem(BACK));
      sessionStorage.removeItem(BACK);
      if (!d || d.q !== window.location.search || !Array.isArray(d.frames)) return null;
      var fr = d.frames.filter(function (f) {
        return f && catById[f.id] && fmtsAvail(f.id).indexOf(f.fmt) > -1 && frameAvail(f.id, f.fmt).indexOf(f.frame) > -1;
      }).slice(0, CFG.maxFrames);
      return fr.length ? { frames: fr, touched: !!d.touched } : null;
    } catch (e) { return null; }
  }

  /* ---------- helpers ---------- */
  var root = document.getElementById('BRPlanner');
  if (!root || !CAT.length) return;
  function $(s) { return root.querySelector(s); }
  function $$(s) { return root.querySelectorAll(s); }
  function el(t, c) { var e = document.createElement(t); if (c) e.className = c; return e; }
  function dimsCm(fmt, orient) { var b = CFG.dims[fmt]; return orient === 'h' ? [b[1], b[0]] : [b[0], b[1]]; }
  /* Fraction de la toile du mockup réellement occupée par le cadre. Le mockup
     paysage est le portrait pivoté : on transpose. Un format inconnu rend
     [1, 1], ce qui redonne exactement l'ancien comportement. */
  function mockupFill(fmt, orient) {
    var m = CFG.mockup[fmt];
    if (!m) return [1, 1];
    return orient === 'h' ? [m[1], m[0]] : [m[0], m[1]];
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function entry(f) { var c = catById[f.id]; return (c.map[f.fmt] || {})[f.frame] || null; }
  function priceOf(f) { var e = entry(f); return e ? e.price : 0; }
  /* La fiche du tirage, dans le format et la finition qu'il a sur le mur */
  function ficheUrl(f) {
    var c = catById[f.id], e = entry(f);
    if (!c || !c.url) return '';
    return e && e.vid ? c.url + (c.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + e.vid : c.url;
  }
  function imgOf(f) { var e = entry(f); return e ? e.img : catById[f.id].thumb; }
  function frameAvail(id, fmt) {
    var c = catById[id]; var m = c.map[fmt] || c.map[c.fmts[0]];
    return FRAME_KEYS.filter(function (k) { return m && m[k]; });
  }
  function fmtsAvail(id) { return catById[id].fmts; }
  function currentGap() { return state.gap || CFG.gap; }
  function onWall(id) { return state.frames.some(function (f) { return f.id === id; }); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    /* 28/10 (c28b-prix-devise-favoris-cac) : hors euro, écrit comme les cartes de la boutique (« ¥17,100 »,
       « $109.00 »), pas dans la langue de la page (« 17 100 JPY », « 109 $US ») ; en euro, rien ne change */
    if (cur !== 'EUR') {
      try { return new Intl.NumberFormat('en', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { /* repli */ }
    }
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cur, maximumFractionDigits: (cents % 100 ? 2 : 0) }).format(cents / 100); }
    catch (e) { return tfill('price_fallback', '{amount} €', { amount: (cents / 100).toFixed(0) }); }
  }
  /* 27/10 : le CDN lit la première largeur (« width=720&width=480 » servait 720 aux vignettes du choix).
     Une largeur différente est remplacée ; la même reste ajoutée : le cadre garde l'adresse que la section précharge. */
  function imgUrl(src, w) {
    if (!src) return '';
    var m = /([?&])width=(\d+)/.exec(src);
    if (m && m[2] !== String(w)) return src.replace(m[0], m[1] + 'width=' + w);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function hslToHex(h, s, l) {
    s /= 100; l /= 100;
    var k = function (n) { return (n + h / 30) % 12; }, a = s * Math.min(l, 1 - l);
    var f = function (n) { return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1))); };
    return '#' + [f(0), f(8), f(4)].map(function (x) { return Math.round(x * 255).toString(16).padStart(2, '0'); }).join('');
  }
  function wallHex() {
    if (state.wallColor.hex && /^#[0-9a-f]{6}$/i.test(state.wallColor.hex)) return state.wallColor.hex;
    var sat = CFG.satLevels[state.wallColor.s] || 0;
    if (!sat) return '#ffffff';
    return hslToHex(state.wallColor.h, sat, 96 - state.wallColor.s * 3.2);
  }
  /* La palette du mur (v4-7 de Max, 21/10) : un clic sur la pastille ouvre des
     propositions et un champ pour sa couleur à soi ; le curseur et les − + restent.
     RAL Classic : valeurs sRGB 8 bits du tableau « All colours defined in RAL
     Classic » de Wikipedia (List of RAL colours, lu le 21/10/2026), qui cite
     ral-farben.de. Rendu approché à l'écran. Pantone n'a pas de table libre :
     on entre son code hexadécimal. */
  var WALL_SWATCHES = [
    [t('planner.wall_none', 'Sans couleur'), ''],
    [t('planner.wall_offwhite', 'Blanc cassé'), '#f2eee6'],
    [t('planner.wall_linen', 'Lin'), '#e7ddcc'],
    [t('planner.wall_greige', 'Greige'), '#d8d0c3'],
    [t('planner.wall_sand', 'Sable'), '#e3cfb0'],
    [t('planner.wall_sage', 'Sauge'), '#c7d1bf'],
    [t('planner.wall_seafoam', 'Vert d’eau'), '#cfe0da'],
    [t('planner.wall_mist', 'Bleu brume'), '#cbd6de'],
    [t('planner.wall_powder', 'Rose poudré'), '#ead3cc'],
    [t('planner.wall_terracotta', 'Terracotta'), '#c98a6b'],
    [t('planner.wall_night', 'Bleu nuit'), '#2f3b4c'],
    [t('planner.wall_charcoal', 'Anthracite'), '#3a3d40']
  ];
  var RAL = ' ' +
    '1000cdba88 1001d0b084 1002d2aa6d 1003f9a800 1004e49e00 1005cb8e00 1006e29000 1007e88c00 1011af804f 1012ddaf27 ' +
    '1013e3d9c6 1014ddc49a 1015e6d2b5 1016f1dd38 1017f6a950 1018faca30 1019a48f7a 1020a08f65 1021f6b600 1023f7b500 ' +
    '1024ba8f4c 1026ffff00 1027a77f0e 1028ff9b00 1032e2a300 1033f99a1c 1034eb9c52 1035908370 103680643f 1037f09200 ' +
    '2000d56f00 2001b6481c 2002bc3823 2003f17829 2004de5306 2005ff4b11 2007ffb700 2008e86b22 2009da530a 2010cc5d29 ' +
    '2011dd6e0f 2012d1654e 20138f3e26 3000a42821 3001982323 3002982222 3003841922 3004691b23 300558181f 30073d2022 ' +
    '3009663029 3011772424 3012c2856d 3013952e25 3014c97375 3015d7a0a6 3016a43c30 3017c8545d 3018c43e4a 3020b81d13 ' +
    '3022cc6955 3024ff2a24 3026ff2620 3027a9263d 3028c92b26 3031a43338 30326e1c24 3033a2392e 4001836083 40028c3c4b ' +
    '4003c4608c 4004641d39 40057b679a 4006913073 400747243c 4008874b83 40099d8592 4010bb3e77 4011716287 40126d6b7f ' +
    '5000384e6f 50011d4c64 50021e367b 5003263855 50041a1e28 5005005187 5007426a8c 50082d3a44 50092d5e78 5010004e7c ' +
    '50111e2b3d 50122e88b6 5013223053 5014687c96 50150b7bb0 5017005a8c 50181b8b8c 50190f5d84 502000414b 5021007577 ' +
    '50222b2c5a 50234a688d 50246792ac 50252c697c 50261b2f52 60003b7460 6001316834 60022d5a27 60034e533b 6004084442 ' +
    '6005114232 60063b392e 60072a3222 600836342a 600927362a 6010486f38 6011697d58 6012303d3a 60137a765a 6014464135 ' +
    '60153c3d36 6016006a4c 601753803f 6018599a39 6019b7ceac 602036422f 6021879a77 6022393327 6024008450 60255a6e3b ' +
    '6026005f4e 602780bab5 6028305442 602900703c 60321c8051 603348877f 60347cadac 6035134d24 603607584b 6037008c27 ' +
    '603800b612 70007b888e 70018e969d 70027f7863 7003787769 70049b9b9b 70056b6e6b 7006756a5e 7008725f3c 70095c6058 ' +
    '7010585c56 701153595d 7012585d5e 7013565044 7015505359 7016383e42 7021303234 70224c4a44 70237f8076 702446494f ' +
    '7026384345 7030918e85 70315d686d 7032b4b0a1 70337e8274 703490886f 7035c5c7c4 7036979392 70377a7b7a 7038afb1a9 ' +
    '70396a665e 7040989ea1 70428e9291 70434f5250 7044b6b3a8 70458e9295 70467f868a 7047c8c8c7 7048807b73 8000866a3e ' +
    '800199632b 8002774d3e 80037c4b27 80048a4931 80076d462b 80086f4a25 8011583827 801264332b 8014483526 80155d2f27 ' +
    '80164b2b20 8017432f29 80193d3635 80221a1719 8023a05729 8024765038 8025735847 80284f3a2a 80297d4031 9001e9e0d2 ' +
    '9002d7d5cb 9003ecece7 90042b2b2c 90050e0e10 9006a1a1a0 9007878581 9010f1ece1 901127292b 9012fffde6 9016f1f0ea ' +
    '90172a292a 9018c8cbc4 9022858583 9023797b7a ';
  /* « #e8dccb », « e8dccb », « #edc », « RAL 9010 », « ral9010 » ou « 9010 ».
     Rend { hex, label } ; { pantone: true } pour un code Pantone ; null sinon. */
  function parseWallCode(txt) {
    var s = String(txt || '').trim().toLowerCase();
    if (!s) return null;
    var m = s.match(/^(?:ral\s*)?(\d{4})$/);
    if (m) {
      var at = RAL.indexOf(' ' + m[1]);
      return at < 0 ? null : { hex: '#' + RAL.substr(at + 5, 6), label: 'RAL ' + m[1] };
    }
    m = s.match(/^#?([0-9a-f]{3}|[0-9a-f]{6})$/);
    if (m) {
      var h = m[1].length === 3 ? m[1].replace(/./g, '$&$&') : m[1];
      return { hex: '#' + h, label: '#' + h.toUpperCase() };
    }
    if (/pantone|pms|^\d{2}-\d{4}|^\d{3,4}\s*[cu]$/.test(s)) return { pantone: true };
    return null;
  }
  function matchFormat(id, orient, targetH) {
    var best = null, bd = 1e9;
    fmtsAvail(id).forEach(function (k) {
      var h = dimsCm(k, orient)[1], d = Math.abs(h - targetH);
      if (d < bd) { bd = d; best = k; }
    });
    return best || fmtsAvail(id)[0];
  }
  function compoName() {
    var n = state.frames.length;
    if (!n) return root.dataset.titleEmpty || t('title_empty', 'Côte à côte');
    if (n === 1) return t('compo_title_one', 'Votre tirage');
    for (var i = 0; i < DISPO.length; i++) if (DISPO[i].n === n) return tfill('compo_title', 'Votre {name}', { name: DISPO[i].name });
    return t('compo_title_generic', 'Votre composition');
  }
  /* Valeur de la propriété « Composition » de la ligne de panier, que le client lit dans
     le panier et au paiement : dans sa langue (25/10). En français, la même qu'avant :
     « diptyque (2 cadres) » ; un seul cadre : « tirage (1 cadre) ». */
  function compoCartName() {
    var n = state.frames.length;
    if (n === 1) return t('cart_compo_one', 'tirage (1 cadre)');
    for (var i = 0; i < DISPO.length; i++) if (DISPO[i].n === n) return tfill('cart_compo_n', '{name} ({n} cadres)', { name: DISPO[i].name, n: n });
    return tfill('cart_compo_n', '{name} ({n} cadres)', { name: 'composition', n: n });
  }
  /* ---------- crans de lot ----------
     Les codes promo ont disparu. À leur place, deux remises AUTOMATIQUES créées
     dans l'admin Shopify : elles s'appliquent seules, se voient dans le panier,
     et valent quel que soit le chemin d'achat — y compris pour qui n'ouvre
     jamais le composeur.
     `on` reste faux tant que le réglage de thème n'est pas coché. Tant qu'il
     l'est, la page n'annonce AUCUN avantage : c'est la garde qui manquait quand
     les champs code portaient les libellés « -5% », ce qui faisait afficher une
     remise que Shopify n'appliquait jamais. */
  var TIERS = (function () {
    var cfg = (BOOT.cfg && BOOT.cfg.tiers) || {};
    var seen = {}, out = [];
    (cfg.steps || []).forEach(function (s) {
      var q = parseInt(s && s.qty, 10);
      if (!(q >= 2) || seen[q]) return;
      seen[q] = 1;
      out.push({ qty: q, kind: s.kind || 'service', pct: parseInt(s.pct, 10) || 0 });
    });
    out.sort(function (a, b) { return a.qty - b.qty; });
    return { on: !!cfg.on, steps: out };
  })();

  /* La remise d'ensemble (Max, 21/10) : un pourcentage sur tout l'ensemble, qui
     grimpe avec le nombre de tirages. Réglages de la section, éteints par
     défaut ; « on » seulement quand la vraie remise automatique existe dans
     Shopify. L'aperçu ne s'allume que sur un thème non publié (l'ALT), avec la
     mention « aperçu » : jamais sur le thème en ligne. Quand elle est allumée,
     elle prend la jauge ; sinon la jauge garde les crans du réglage du thème. */
  var ENSEMBLE = (function () {
    var cfg = (BOOT.cfg && BOOT.cfg.ensemble) || {};
    var seen = {}, out = [];
    (cfg.steps || []).forEach(function (s) {
      var q = parseInt(s && s.qty, 10), p = parseInt(s && s.pct, 10);
      if (!(q >= 2) || !(p > 0 && p < 100) || seen[q]) return;
      seen[q] = 1;
      out.push({ qty: q, kind: 'ensemble', pct: p });
    });
    out.sort(function (a, b) { return a.qty - b.qty; });
    var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    var preview = !cfg.on && !!cfg.preview && !!role && role !== 'main';
    return { on: (!!cfg.on || preview) && out.length > 0, preview: preview, steps: out };
  })();
  if (ENSEMBLE.on) TIERS = { on: true, steps: ENSEMBLE.steps, preview: ENSEMBLE.preview };

  function tierLabel(s) {
    if (!s) return '';
    if (s.kind === 'ensemble') return tfill('tier_ensemble', '−{pct} % sur l’ensemble', { pct: s.pct });
    if (s.kind === 'shipping') return t('tier_shipping', 'Livraison offerte');
    if (s.kind === 'discount') return tfill('tier_discount', 'Le {n}ᵉ cadre à −{pct} %', { n: s.qty, pct: s.pct });
    return t('tier_service', 'Plan d’accrochage et gabarits offerts');
  }

  /* Le cran atteint (le plus haut), le cran suivant, et l'économie en centimes.
     Le cran « discount » reproduit ce que fait Shopify sur une remise « Achetez
     X obtenez Y » : la réduction tombe sur le tirage éligible LE MOINS CHER, pas
     sur le dernier posé. Approximation assumée : si le panier contient déjà
     d'autres tirages, Shopify calculera sur l'ensemble — le panier, lui, dira
     toujours la vérité. */
  function tierState() {
    var n = state.frames.length;
    var st = { on: TIERS.on, n: n, reached: null, next: null, save: 0 };
    if (!TIERS.on || !TIERS.steps.length) return st;
    for (var i = 0; i < TIERS.steps.length; i++) {
      var s = TIERS.steps[i];
      if (n >= s.qty) st.reached = s;
      else if (!st.next) st.next = s;
    }
    if (st.reached && st.reached.kind === 'discount' && st.reached.pct > 0) {
      var prices = [];
      state.frames.forEach(function (f) { var p = priceOf(f); if (p > 0) prices.push(p); });
      if (prices.length) {
        prices.sort(function (a, b) { return a - b; });
        st.save = Math.round(prices[0] * st.reached.pct / 100);
      }
    }
    if (st.reached && st.reached.kind === 'ensemble') {
      var all = state.frames.reduce(function (sum, f) { return sum + priceOf(f); }, 0);
      st.save = Math.round(all * st.reached.pct / 100);
    }
    return st;
  }

  /* ---------- échelle ---------- */
  var PXCM = 1;
  /* Le cartel sous chaque cadre : son écart au cadre et sa hauteur (deux lignes), en px */
  var CAP_GAP = 6, CAP_H = 32;
  /* Le bas du cadre le plus bas, en cm */
  function capLow() {
    var low = 0;
    state.frames.forEach(function (f) { low = Math.max(low, f.y + dimsCm(f.fmt, catById[f.id].orient)[1]); });
    return low;
  }
  /* Ce qui manque sous le cadre le plus bas pour poser son cartel, en px. « Mon mur »
     garde ses vraies cotes : ses cartels se règlent un par un (capFit). */
  function capShortfall(H) {
    if (state.rotated || !state.frames.length || state.scale === 'real') return 0;
    return Math.max(0, CAP_GAP + CAP_H - (H - capLow()) * PXCM);
  }
  function regionDims() { return state.scale === 'real' ? [state.wall.w, state.wall.h] : [state.region.w, state.region.h]; }

  /* v4 (21/10, Max : « seulement si on vient dessiner un mur […] au crayon, avec
     les mesures ») : en « Mon mur », le mur est un croquis au crayon de couleur
     (style v4-9) : contour bleu doublé, un peu tremblé, la couleur choisie en
     hachures claires, une ligne de sol et ses deux cotes. Du SVG, aucune image ;
     redessiné seulement quand ses cotes, sa taille ou sa couleur changent. */
  var sketchKey = '';
  /* Le mur en px, et où poser ses cotes (27/10) : sur un mur bas ou étroit, les
     cadres remontent contre le bord et couvraient la cote (« 200 cm » caché sur un
     mur de 200 x 150). La cote de largeur passe alors en bas, celle de hauteur à
     droite, si la place y est libre ; chaque chiffre se pose au milieu du plus long
     passage que les cadres laissent libre sur sa ligne. */
  function sketchDims(W, H) {
    var w = Math.round(W * PXCM), h = Math.round(H * PXCM), top = h, bot = 0, left = w, right = 0, R = [];
    state.frames.forEach(function (f) {
      var e = dimsCm(f.fmt, catById[f.id].orient);
      var r = { t: f.y * PXCM, b: (f.y + e[1]) * PXCM + CAP_GAP + CAP_H, l: f.x * PXCM, r: (f.x + e[0]) * PXCM };
      R.push(r);
      top = Math.min(top, r.t); bot = Math.max(bot, r.b); left = Math.min(left, r.l); right = Math.max(right, r.r);
    });
    var m = 16, room = 14;
    var low = top < m + room && bot < h - m - room, east = left < m + room && right < w - m - room;
    var ty = low ? h - m - 4 : m, lx = east ? w - m : m;
    var y0 = low ? m : m + 10, y1 = low ? h - m - 14 : h - m;
    /* le milieu du plus long passage libre de [a0, a1], hors des intervalles pris */
    function freeMid(a0, a1, taken) {
      taken.sort(function (p, q) { return p[0] - q[0]; });
      var best = [a0, a0], at = a0;
      taken.forEach(function (k) {
        if (k[0] > at && k[0] - at > best[1] - best[0]) best = [at, Math.min(k[0], a1)];
        at = Math.max(at, k[1]);
      });
      if (a1 - at > best[1] - best[0]) best = [at, a1];
      return best[1] - best[0] >= 60 ? Math.round((best[0] + best[1]) / 2) : Math.round((a0 + a1) / 2);
    }
    var tx = freeMid(m, w - m, R.filter(function (r) { return r.t < ty + 9 && r.b > ty - 9; }).map(function (r) { return [r.l - 6, r.r + 6]; }));
    var ly = freeMid(y0, y1, R.filter(function (r) { return r.l < lx + 9 && r.r > lx - 9; }).map(function (r) { return [r.t - 6, r.b + 6]; }));
    /* 27/10 (Max : « une ligne qui donne la hauteur, sur le côté droit, avec un
       grand truc ») : la cote du sol au centre de la composition — le repère que
       layoutReal() pose sur la hauteur d'accrochage —, lue sur les cadres tels
       qu'ils sont (un cadre glissé la fait bouger). Dans la bande libre à droite
       des cadres ; à côté de la cote de hauteur du mur si celle-ci est à droite. */
    var hang = null;
    if (R.length) {
      var cTop = Infinity, cBot = -Infinity;
      state.frames.forEach(function (f) { var e = dimsCm(f.fmt, catById[f.id].orient); cTop = Math.min(cTop, f.y); cBot = Math.max(cBot, f.y + e[1]); });
      /* le « + » posé à droite du dernier cadre (même calcul que renderSideAdds) : la cote passe après lui */
      var plusR = right, sb = sideAddsOn() && document.querySelector('#brpCanvasShell .brp-side-add');
      if (sb) {
        var lf = state.frames[state.frames.length - 1], ld = dimsCm(lf.fmt, catById[lf.id].orient), lr = (lf.x + ld[0]) * PXCM, size = sb.offsetWidth || 32, room = w - lr;
        var air = window.innerWidth >= 1100 ? Math.round(Math.max(24, Math.min(44, ld[1] * PXCM * .45))) : 10;
        if (room >= size + air) plusR = Math.max(right, lr + Math.min((room - size) / 2, Math.max(air, currentGap() * PXCM)) + size);
      }
      var hx = Math.round(Math.max(right + 30, plusR + 30, w - 56));
      if (east) hx = Math.min(hx, w - m - 34);
      /* mur bas : le « + » arrive contre le bord droit ; la cote se serre contre le bord plutôt que de toucher le « + » */
      hx = Math.min(hx, Math.max(w - 24, Math.min(plusR + 14, w - 10)));
      /* la ligne du centre ne part que de 40 px avant la cote : elle ne croise pas le « + » posé à côté du dernier cadre */
      hang = { x: hx, y: Math.round((cTop + cBot) / 2 * PXCM), cm: H - (cTop + cBot) / 2, from: Math.round(Math.max(right + 4, plusR + 8, hx - 40)) };
      /* mur étroit : la cote passe sous des cadres ; elle s'interrompt sur eux et sur leurs noms */
      hang.cuts = R.filter(function (r) { return r.l - 6 < hx && r.r + 6 > hx; }).map(function (r) { return [Math.round(r.t - 6), Math.round(r.b + 6)]; });
    }
    return { w: w, h: h, cmW: W, cmH: H, hex: wallHex(), ty: ty, lx: lx, y0: y0, y1: y1, tx: tx, ly: ly, hang: hang };
  }
  function renderSketch(canvas, d) {
    var svg = document.getElementById('brpSketch');
    if (!d) { if (svg) svg.style.display = 'none'; return; }
    var hg = d.hang;
    var key = [d.w, d.h, d.cmW, d.cmH, d.hex, d.ty, d.lx, d.tx, d.ly, hg ? [hg.x, hg.y, hg.cm, hg.from, hg.cuts.join(';')].join(',') : ''].join('|');
    if (svg && key === sketchKey) { svg.style.display = ''; return; }
    sketchKey = key;
    if (!svg) {
      svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.id = 'brpSketch';
      svg.setAttribute('class', 'br-sketch');
      svg.setAttribute('aria-hidden', 'true');
      canvas.insertBefore(svg, canvas.firstChild);
    }
    var w = d.w, h = d.h, o = 1, m = 16, ink = '#4a5f80', paper = '#fbf9f4';
    /* la ligne de la cote de largeur (ty), celle de la hauteur (lx) et sa course (y0 → y1) */
    var ty = d.ty, lx = d.lx, y0 = d.y0, y1 = d.y1;
    var c = d.hex && d.hex.toLowerCase() !== '#ffffff' ? d.hex : '';
    var box = 'x="' + o + '" y="' + o + '" width="' + (w - 2 * o) + '" height="' + (h - 2 * o) + '"';
    var label = function (x, y, txt, rot) {
      return '<text x="0" y="0" transform="translate(' + x + ' ' + y + ')' + (rot ? ' rotate(-90)' : '') + '" text-anchor="middle" dominant-baseline="central"' +
        ' stroke="' + paper + '" stroke-width="6" stroke-linejoin="round" paint-order="stroke">' + esc(txt) + '</text>';
    };
    svg.style.display = '';
    svg.setAttribute('width', w);
    svg.setAttribute('height', h);
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    svg.innerHTML =
      '<defs>' +
        '<filter id="brpSkPencil" x="-3%" y="-3%" width="106%" height="106%">' +
          '<feTurbulence type="fractalNoise" baseFrequency="0.022" numOctaves="1" seed="11" result="n"/>' +
          '<feDisplacementMap in="SourceGraphic" in2="n" scale="2.2" xChannelSelector="R" yChannelSelector="G"/>' +
        '</filter>' +
        '<filter id="brpSkGrain" x="0" y="0" width="100%" height="100%">' +
          '<feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="1" seed="4"/>' +
          '<feColorMatrix values="0 0 0 0 .3  0 0 0 0 .28  0 0 0 0 .25  .11 0 0 0 0"/>' +
        '</filter>' +
        (c ? '<pattern id="brpSkHatch" width="7" height="7" patternUnits="userSpaceOnUse" patternTransform="rotate(-38)">' +
          '<line x1="0" y1="3.5" x2="7" y2="3.5" stroke="' + c + '" stroke-width="2" stroke-linecap="round"/></pattern>' : '') +
      '</defs>' +
      '<rect ' + box + ' fill="' + (c || paper) + '"' + (c ? ' fill-opacity=".38"' : '') + '/>' +
      (c ? '<rect ' + box + ' fill="url(#brpSkHatch)" fill-opacity=".6" filter="url(#brpSkPencil)"/>' : '') +
      '<rect x="0" y="0" width="' + w + '" height="' + h + '" filter="url(#brpSkGrain)"/>' +
      /* 27/10 (Max, grand mur : « les lignes ont l'air pas droites en haut, il y a des
         endroits c'est un peu buggé ») : le trait tremblé et le second contour de
         biais cassaient les bords par endroits. Les bords, le sol et les cotes sont
         maintenant des traits droits, calés au pixel (un trait de 1 px sur une
         demi-coordonnée) ; le crayon ne reste que dans la couleur du mur. */
      '<g fill="none" stroke="' + ink + '" shape-rendering="crispEdges">' +
        '<rect x=".5" y=".5" width="' + (w - 1) + '" height="' + (h - 1) + '" stroke-width="1"/>' +
        '<path d="M0 ' + (h - 1) + 'H' + w + '" stroke-width="2"/>' +
        '<g stroke-width="1" opacity=".7">' +
          '<path d="M' + m + ' ' + (ty + .5) + 'H' + (w - m) + '" stroke-dasharray="4 3"/>' +
          '<path d="M' + (m + .5) + ' ' + (ty - 5) + 'v11M' + (w - m - .5) + ' ' + (ty - 5) + 'v11"/>' +
          '<path d="M' + (lx + .5) + ' ' + y0 + 'V' + y1 + '" stroke-dasharray="4 3"/>' +
          '<path d="M' + (lx - 5) + ' ' + (y0 + .5) + 'h11M' + (lx - 5) + ' ' + (y1 - .5) + 'h11"/>' +
        '</g>' +
      '</g>' +
      '<g fill="' + ink + '">' +
        label(d.tx, ty + .5, Math.round(d.cmW) + ' cm') +
        label(lx + .5, d.ly, Math.round(d.cmH) + ' cm', true) +
      '</g>' +
      sketchHang(hg, w, h, ink);
  }
  /* La cote d'accrochage : un trait plein du sol au centre, la ligne du centre en
     tirets jusqu'aux cadres, et une grande étiquette pleine posée sur le trait. */
  function sketchHang(hg, w, h, ink) {
    if (!hg || hg.y > h - 30) return '';
    var x = hg.x + .5, pw = 92, ph = 38, py = Math.round((hg.y + h) / 2);
    if (h - hg.y < ph + 24) py = Math.max(ph / 2 + 4, hg.y - ph / 2 - 10);
    var px = Math.max(pw / 2 + 4, Math.min(w - pw / 2 - 4, x));
    /* le trait, interrompu sur les cadres qu'il croise ; l'étiquette dans le plus long passage libre */
    var segs = [], at = hg.y;
    hg.cuts.slice().sort(function (a, b) { return a[0] - b[0]; }).forEach(function (c) {
      if (c[1] <= at || c[0] >= h - 2) return;
      if (c[0] > at) segs.push([at, c[0]]);
      at = Math.max(at, c[1]);
    });
    if (at < h - 2) segs.push([at, h - 2]);
    if (hg.cuts.length) {
      var best = null;
      segs.forEach(function (s) { var a = Math.max(s[0], hg.y + 12); if (s[1] - a >= ph + 12 && (!best || s[1] - a > best[1] - best[0])) best = [a, s[1]]; });
      if (best) py = Math.round((best[0] + best[1]) / 2);
    }
    var line = segs.map(function (s) { return 'M' + x + ' ' + s[0] + 'V' + s[1]; }).join('');
    return '<g class="br-sketch__hang" shape-rendering="crispEdges">' +
        (hg.from < x - 8 ? '<path d="M' + hg.from + ' ' + (hg.y + .5) + 'H' + (x + 7) + '" stroke="' + ink + '" stroke-width="1" stroke-dasharray="5 4" fill="none"/>' : '') +
        '<path d="' + line + 'M' + (x - 7) + ' ' + (hg.y + .5) + 'h14" stroke="' + ink + '" stroke-width="2" fill="none"/>' +
      '</g>' +
      '<path d="M' + x + ' ' + (hg.y + 1) + 'l-4.5 9h9z" fill="' + ink + '"/>' +
      '<g transform="translate(' + px + ' ' + py + ')">' +
        '<rect x="' + (-pw / 2) + '" y="' + (-ph / 2) + '" width="' + pw + '" height="' + ph + '" rx="7" fill="' + ink + '"/>' +
        '<text y="-3" text-anchor="middle" fill="#fff" style="font:600 17px/1 Archivo,sans-serif;letter-spacing:0">' + esc(cmTxt(hg.cm)) + '</text>' +
        '<text y="12" text-anchor="middle" fill="#fff" fill-opacity=".85" style="font:500 10px/1 Archivo,sans-serif;letter-spacing:.02em">' + esc(t('hang_cote_caption', 'du sol au centre')) + '</text>' +
      '</g>';
  }

  /* ---------- Côte à côte dans une vraie pièce (essai LABO cote-a-cote-scenes-2-labo du 26/10, porté sur l'ALT par b27-cac-pieces le 28/10) ----------
     Max, 25/10 : « Et ya pas moyen de mettre aussi les scenes 3d dans le cote a cote simulateur ».
     Le choix « Pièce » : « Mur uni » (par défaut, comme aujourd'hui) ou une scène 3D validée. En
     pièce, la composition s'accroche sur le mur de la scène, à l'échelle réelle, par l'homographie
     du kit (mise-en-situation-blender/scenes-vente/_cote-a-cote/Sxx/mur.json) : la pièce vide,
     l'ombre de chaque format déplacée sous son cadre (multiply), la lumière du mur sur les cadres
     (multiply), puis ce qui passe devant le mur. Les images sont des fichiers du thème
     (assets/cac-piece-*, voir roomSrc) ; la géométrie est ici.
     Le plan de perçage ne change pas : il reste en centimètres, sur la composition. */
  var ROOMS = [{"id":"S01","n":["Salon","Living room"],"img":[2400,2400],"web":0.666667,"hf":[11.42857156,1.21953587e-12,1199.999959,-6.19500965e-13,-11.42857371,2174.40022,-6.462543804e-14,1.723345014e-14,1],"hm":[11.35879843,-5.644223124e-11,1200,1.524392194e-13,-11.35879788,2164.980532,-3.703628921e-14,6.924175809e-14,1],"zone":[-105.6,105.6,105.8,190.6],"exclus":[],"c":[0,137.76],"m":{"A4-H":["ombre-A4-H",[382,0,2018,1420],[0,137.76]],"A3-H":["ombre-A3-H",[382,0,2018,1420],[0,137.76]],"A2-H":["ombre-A2-H",[382,0,2018,1420],[0,137.76]],"A4-V":["ombre-A4-V",[382,0,2018,1420],[0,137.76]],"A3-V":["ombre-A3-V",[382,0,2018,1420],[0,137.76]],"A2-V":["ombre-A2-V",[382,0,2018,1420],[0,137.76]]}},{"id":"S02","n":["Chambre","Bedroom"],"img":[2400,2400],"web":0.666667,"hf":[11.42857221,-1.641744465e-13,1200.000095,-2.316439384e-13,-11.42857184,2712.571466,3.215953899e-14,-7.718289357e-15,1],"hm":[11.33899709,4.297207188e-12,1200.000068,4.892742312e-12,-11.33899698,2700.031058,1.473621072e-14,1.646611372e-13,1],"zone":[-105.8,105.8,116.3,235],"exclus":[],"c":[0,153.35],"m":{"A4-H":["ombre-A4-H",[382,144,2018,1778],[0,153.35]],"A3-H":["ombre-A3-H",[382,144,2018,1778],[0,153.35]],"A2-H":["ombre-A2-H",[382,144,2018,1778],[0,153.35]],"A4-V":["ombre-A4-V",[382,144,2018,1778],[0,153.35]],"A3-V":["ombre-A3-V",[382,144,2018,1778],[0,153.35]],"A2-V":["ombre-A2-V",[382,144,2018,1778],[0,153.35]]}},{"id":"S03","n":["Entrée","Hallway"],"img":[2400,2400],"web":0.666667,"hf":[11.42857362,-6.495935576e-13,1200.00004,1.397853939e-14,-11.42857361,1987.076527,5.939716373e-14,-2.013463177e-15,1],"hm":[11.32814059,-2.929936201e-11,1200,-1.27787232e-13,-11.32814002,1973.015861,1.119194567e-13,-1.327009218e-13,1],"zone":[-105.9,105.9,95.2,174.2],"exclus":[],"c":[0,132.2],"m":{"A4-H":["ombre-A4-H",[384,0,2016,1292],[0,132.2]],"A3-H":["ombre-A3-H",[384,0,2016,1292],[0,132.2]],"A2-H":["ombre-A2-H",[384,0,2016,1292],[0,132.2]],"A4-V":["ombre-A4-V",[384,0,2016,1292],[0,132.2]],"A3-V":["ombre-A3-V",[384,0,2016,1292],[0,132.2]],"A2-V":["ombre-A2-V",[384,0,2016,1292],[0,132.2]]}},{"id":"S04","n":["Salle à manger","Dining room"],"img":[2400,2400],"web":0.666667,"hf":[11.42857552,0.000001564173328,685.7142169,5.789777626e-14,-11.42857613,1995.541399,-2.470832985e-14,2.016494385e-9,1],"hm":[11.34248635,-9.665139716e-11,689.5881278,-1.862161636e-13,-11.34248565,1983.48876,-3.688463213e-14,-1.611995034e-13,1],"zone":[-60.8,150.8,88,174.9],"exclus":[],"c":[45,120.01],"g":{"A4-H":[[-39.8,104,"ombres-formats/A4-H-00",[-340,-340,1056,1622],0],[-25.7,104,"ombres-formats/A4-H-01",[-340,-340,1216,1622]],[-11.5,104,"ombres-formats/A4-H-02",[-340,-340,1376,1622]],[2.6,104,"ombres-formats/A4-H-03",[-340,-340,1536,1622]],[16.7,104,"ombres-formats/A4-H-04",[62,-340,1696,1622]],[30.9,104,"ombres-formats/A4-H-05",[222,-340,1858,1622]],[45,104,"ombres-formats/A4-H-06",[382,-340,2018,1622]],[59.1,104,"ombres-formats/A4-H-07",[542,-340,2178,1622]],[73.3,104,"ombres-formats/A4-H-08",[704,-340,2338,1622]],[87.4,104,"ombres-formats/A4-H-09",[864,-340,2740,1622]],[101.5,104,"ombres-formats/A4-H-10",[1024,-340,2740,1622]],[115.7,104,"ombres-formats/A4-H-11",[1184,-340,2740,1622]],[129.8,104,"ombres-formats/A4-H-12",[1344,-340,2966,1622]],[-39.8,117.7,"ombres-formats/A4-H-13",[-340,-340,1056,1466],0],[-25.7,117.7,"ombres-formats/A4-H-14",[-340,-340,1216,1466]],[-11.5,117.7,"ombres-formats/A4-H-15",[-340,-340,1376,1466]],[2.6,117.7,"ombres-formats/A4-H-16",[-340,-340,1536,1466]],[16.7,117.7,"ombres-formats/A4-H-17",[62,-340,1696,1466]],[30.9,117.7,"ombres-formats/A4-H-18",[222,-340,1858,1466]],[45,117.7,"ombres-formats/A4-H-19",[382,-340,2018,1466]],[59.1,117.7,"ombres-formats/A4-H-20",[542,-340,2178,1466]],[73.3,117.7,"ombres-formats/A4-H-21",[704,-340,2338,1466]],[87.4,117.7,"ombres-formats/A4-H-22",[864,-340,2740,1466]],[101.5,117.7,"ombres-formats/A4-H-23",[1024,-340,2740,1466]],[115.7,117.7,"ombres-formats/A4-H-24",[1184,-340,2740,1466]],[129.8,117.7,"ombres-formats/A4-H-25",[1344,-340,2966,1466]],[-39.8,131.4,"ombres-formats/A4-H-26",[-340,-340,1056,1310],0],[-25.7,131.4,"ombres-formats/A4-H-27",[-340,-340,1216,1310]],[-11.5,131.4,"ombres-formats/A4-H-28",[-340,-340,1376,1310]],[2.6,131.4,"ombres-formats/A4-H-29",[-340,-340,1536,1310]],[16.7,131.4,"ombres-formats/A4-H-30",[62,-340,1696,1310]],[30.9,131.4,"ombres-formats/A4-H-31",[222,-340,1858,1310]],[45,131.4,"ombres-formats/A4-H-32",[382,-340,2018,1310]],[59.1,131.4,"ombres-formats/A4-H-33",[542,-340,2178,1310]],[73.3,131.4,"ombres-formats/A4-H-34",[704,-340,2338,1310]],[87.4,131.4,"ombres-formats/A4-H-35",[864,-340,2740,1310]],[101.5,131.4,"ombres-formats/A4-H-36",[1024,-340,2740,1310]],[115.7,131.4,"ombres-formats/A4-H-37",[1184,-340,2740,1310]],[129.8,131.4,"ombres-formats/A4-H-38",[1344,-340,2966,1310]],[-39.8,145.2,"ombres-formats/A4-H-39",[-340,-340,1056,1154],0],[-25.7,145.2,"ombres-formats/A4-H-40",[-340,-340,1216,1154]],[-11.5,145.2,"ombres-formats/A4-H-41",[-340,-340,1376,1154]],[2.6,145.2,"ombres-formats/A4-H-42",[-340,-340,1536,1154]],[16.7,145.2,"ombres-formats/A4-H-43",[62,-340,1696,1154]],[30.9,145.2,"ombres-formats/A4-H-44",[222,-340,1858,1154]],[45,145.2,"ombres-formats/A4-H-45",[382,-340,2018,1154]],[59.1,145.2,"ombres-formats/A4-H-46",[542,-340,2178,1154]],[73.3,145.2,"ombres-formats/A4-H-47",[704,-340,2338,1154]],[87.4,145.2,"ombres-formats/A4-H-48",[864,-340,2740,1154]],[101.5,145.2,"ombres-formats/A4-H-49",[1024,-340,2740,1154]],[115.7,145.2,"ombres-formats/A4-H-50",[1184,-340,2740,1154]],[129.8,145.2,"ombres-formats/A4-H-51",[1344,-340,2966,1154]],[-39.8,158.9,"ombres-formats/A4-H-52",[-340,-226,1056,998],0],[-25.7,158.9,"ombres-formats/A4-H-53",[-340,-226,1216,998]],[-11.5,158.9,"ombres-formats/A4-H-54",[-340,-226,1376,998]],[2.6,158.9,"ombres-formats/A4-H-55",[-340,-226,1536,998]],[16.7,158.9,"ombres-formats/A4-H-56",[62,-226,1696,998]],[30.9,158.9,"ombres-formats/A4-H-57",[222,-226,1858,998]],[45,158.9,"ombres-formats/A4-H-58",[382,-226,2018,998]],[59.1,158.9,"ombres-formats/A4-H-59",[542,-226,2178,998]],[73.3,158.9,"ombres-formats/A4-H-60",[704,-226,2338,998]],[87.4,158.9,"ombres-formats/A4-H-61",[864,-226,2740,998]],[101.5,158.9,"ombres-formats/A4-H-62",[1024,-226,2740,998]],[115.7,158.9,"ombres-formats/A4-H-63",[1184,-226,2740,998]],[129.8,158.9,"ombres-formats/A4-H-64",[1344,-226,2966,998]]],"A3-H":[[-34.5,109.2,"ombres-formats/A3-H-00",[-340,-340,1116,1562],0],[-20.1,109.2,"ombres-formats/A3-H-01",[-340,-340,1280,1562]],[-5.6,109.2,"ombres-formats/A3-H-02",[-340,-340,1444,1562]],[8.8,109.2,"ombres-formats/A3-H-03",[-340,-340,1608,1562]],[23.3,109.2,"ombres-formats/A3-H-04",[136,-340,1772,1562]],[37.8,109.2,"ombres-formats/A3-H-05",[300,-340,1936,1562]],[52.2,109.2,"ombres-formats/A3-H-06",[464,-340,2100,1562]],[66.7,109.2,"ombres-formats/A3-H-07",[628,-340,2264,1562]],[81.2,109.2,"ombres-formats/A3-H-08",[792,-340,2740,1562]],[95.6,109.2,"ombres-formats/A3-H-09",[956,-340,2740,1562]],[110.1,109.2,"ombres-formats/A3-H-10",[1120,-340,2740,1562]],[124.6,109.2,"ombres-formats/A3-H-11",[1286,-340,2966,1562]],[-34.5,124,"ombres-formats/A3-H-12",[-340,-340,1116,1394],0],[-20.1,124,"ombres-formats/A3-H-13",[-340,-340,1280,1394]],[-5.6,124,"ombres-formats/A3-H-14",[-340,-340,1444,1394]],[8.8,124,"ombres-formats/A3-H-15",[-340,-340,1608,1394]],[23.3,124,"ombres-formats/A3-H-16",[136,-340,1772,1394]],[37.8,124,"ombres-formats/A3-H-17",[300,-340,1936,1394]],[52.2,124,"ombres-formats/A3-H-18",[464,-340,2100,1394]],[66.7,124,"ombres-formats/A3-H-19",[628,-340,2264,1394]],[81.2,124,"ombres-formats/A3-H-20",[792,-340,2740,1394]],[95.6,124,"ombres-formats/A3-H-21",[956,-340,2740,1394]],[110.1,124,"ombres-formats/A3-H-22",[1120,-340,2740,1394]],[124.6,124,"ombres-formats/A3-H-23",[1286,-340,2966,1394]],[-34.5,138.8,"ombres-formats/A3-H-24",[-340,-340,1116,1226],0],[-20.1,138.8,"ombres-formats/A3-H-25",[-340,-340,1280,1226]],[-5.6,138.8,"ombres-formats/A3-H-26",[-340,-340,1444,1226]],[8.8,138.8,"ombres-formats/A3-H-27",[-340,-340,1608,1226]],[23.3,138.8,"ombres-formats/A3-H-28",[136,-340,1772,1226]],[37.8,138.8,"ombres-formats/A3-H-29",[300,-340,1936,1226]],[52.2,138.8,"ombres-formats/A3-H-30",[464,-340,2100,1226]],[66.7,138.8,"ombres-formats/A3-H-31",[628,-340,2264,1226]],[81.2,138.8,"ombres-formats/A3-H-32",[792,-340,2740,1226]],[95.6,138.8,"ombres-formats/A3-H-33",[956,-340,2740,1226]],[110.1,138.8,"ombres-formats/A3-H-34",[1120,-340,2740,1226]],[124.6,138.8,"ombres-formats/A3-H-35",[1286,-340,2966,1226]],[-34.5,153.7,"ombres-formats/A3-H-36",[-340,-226,1116,1058],0],[-20.1,153.7,"ombres-formats/A3-H-37",[-340,-226,1280,1058]],[-5.6,153.7,"ombres-formats/A3-H-38",[-340,-226,1444,1058]],[8.8,153.7,"ombres-formats/A3-H-39",[-340,-226,1608,1058]],[23.3,153.7,"ombres-formats/A3-H-40",[136,-226,1772,1058]],[37.8,153.7,"ombres-formats/A3-H-41",[300,-226,1936,1058]],[52.2,153.7,"ombres-formats/A3-H-42",[464,-226,2100,1058]],[66.7,153.7,"ombres-formats/A3-H-43",[628,-226,2264,1058]],[81.2,153.7,"ombres-formats/A3-H-44",[792,-226,2740,1058]],[95.6,153.7,"ombres-formats/A3-H-45",[956,-226,2740,1058]],[110.1,153.7,"ombres-formats/A3-H-46",[1120,-226,2740,1058]],[124.6,153.7,"ombres-formats/A3-H-47",[1286,-226,2966,1058]]],"A2-H":[[-23.8,115,"ombres-formats/A2-H-00",[-340,-340,1238,1496],0],[-10,115,"ombres-formats/A2-H-01",[-340,-340,1394,1496]],[3.7,115,"ombres-formats/A2-H-02",[-340,-340,1550,1496]],[17.5,115,"ombres-formats/A2-H-03",[70,-340,1706,1496]],[31.2,115,"ombres-formats/A2-H-04",[226,-340,1862,1496]],[45,115,"ombres-formats/A2-H-05",[382,-340,2018,1496]],[58.8,115,"ombres-formats/A2-H-06",[538,-340,2174,1496]],[72.5,115,"ombres-formats/A2-H-07",[694,-340,2330,1496]],[86.3,115,"ombres-formats/A2-H-08",[850,-340,2740,1496]],[100,115,"ombres-formats/A2-H-09",[1006,-340,2740,1496]],[113.8,115,"ombres-formats/A2-H-10",[1162,-340,2966,1496]],[-23.8,126,"ombres-formats/A2-H-11",[-340,-340,1238,1372],0],[-10,126,"ombres-formats/A2-H-12",[-340,-340,1394,1372]],[3.7,126,"ombres-formats/A2-H-13",[-340,-340,1550,1372]],[17.5,126,"ombres-formats/A2-H-14",[70,-340,1706,1372]],[31.2,126,"ombres-formats/A2-H-15",[226,-340,1862,1372]],[45,126,"ombres-formats/A2-H-16",[382,-340,2018,1372]],[58.8,126,"ombres-formats/A2-H-17",[538,-340,2174,1372]],[72.5,126,"ombres-formats/A2-H-18",[694,-340,2330,1372]],[86.3,126,"ombres-formats/A2-H-19",[850,-340,2740,1372]],[100,126,"ombres-formats/A2-H-20",[1006,-340,2740,1372]],[113.8,126,"ombres-formats/A2-H-21",[1162,-340,2966,1372]],[-23.8,136.9,"ombres-formats/A2-H-22",[-340,-340,1238,1248],0],[-10,136.9,"ombres-formats/A2-H-23",[-340,-340,1394,1248]],[3.7,136.9,"ombres-formats/A2-H-24",[-340,-340,1550,1248]],[17.5,136.9,"ombres-formats/A2-H-25",[70,-340,1706,1248]],[31.2,136.9,"ombres-formats/A2-H-26",[226,-340,1862,1248]],[45,136.9,"ombres-formats/A2-H-27",[382,-340,2018,1248]],[58.8,136.9,"ombres-formats/A2-H-28",[538,-340,2174,1248]],[72.5,136.9,"ombres-formats/A2-H-29",[694,-340,2330,1248]],[86.3,136.9,"ombres-formats/A2-H-30",[850,-340,2740,1248]],[100,136.9,"ombres-formats/A2-H-31",[1006,-340,2740,1248]],[113.8,136.9,"ombres-formats/A2-H-32",[1162,-340,2966,1248]],[-23.8,147.9,"ombres-formats/A2-H-33",[-340,-226,1238,1124],0],[-10,147.9,"ombres-formats/A2-H-34",[-340,-226,1394,1124]],[3.7,147.9,"ombres-formats/A2-H-35",[-340,-226,1550,1124]],[17.5,147.9,"ombres-formats/A2-H-36",[70,-226,1706,1124]],[31.2,147.9,"ombres-formats/A2-H-37",[226,-226,1862,1124]],[45,147.9,"ombres-formats/A2-H-38",[382,-226,2018,1124]],[58.8,147.9,"ombres-formats/A2-H-39",[538,-226,2174,1124]],[72.5,147.9,"ombres-formats/A2-H-40",[694,-226,2330,1124]],[86.3,147.9,"ombres-formats/A2-H-41",[850,-226,2740,1124]],[100,147.9,"ombres-formats/A2-H-42",[1006,-226,2740,1124]],[113.8,147.9,"ombres-formats/A2-H-43",[1162,-226,2966,1124]]],"A4-V":[[-44.8,109,"ombres-formats/A4-V-00",[-340,-340,1000,1564],0],[-29.8,109,"ombres-formats/A4-V-01",[-340,-340,1170,1564]],[-14.9,109,"ombres-formats/A4-V-02",[-340,-340,1338,1564]],[0.1,109,"ombres-formats/A4-V-03",[-340,-340,1508,1564]],[15.1,109,"ombres-formats/A4-V-04",[44,-340,1678,1564]],[30,109,"ombres-formats/A4-V-05",[212,-340,1848,1564]],[45,109,"ombres-formats/A4-V-06",[382,-340,2018,1564]],[60,109,"ombres-formats/A4-V-07",[552,-340,2188,1564]],[74.9,109,"ombres-formats/A4-V-08",[722,-340,2356,1564]],[89.9,109,"ombres-formats/A4-V-09",[892,-340,2740,1564]],[104.9,109,"ombres-formats/A4-V-10",[1062,-340,2740,1564]],[119.8,109,"ombres-formats/A4-V-11",[1230,-340,2740,1564]],[134.8,109,"ombres-formats/A4-V-12",[1400,-340,2966,1564]],[-44.8,124,"ombres-formats/A4-V-13",[-340,-340,1000,1394],0],[-29.8,124,"ombres-formats/A4-V-14",[-340,-340,1170,1394]],[-14.9,124,"ombres-formats/A4-V-15",[-340,-340,1338,1394]],[0.1,124,"ombres-formats/A4-V-16",[-340,-340,1508,1394]],[15.1,124,"ombres-formats/A4-V-17",[44,-340,1678,1394]],[30,124,"ombres-formats/A4-V-18",[212,-340,1848,1394]],[45,124,"ombres-formats/A4-V-19",[382,-340,2018,1394]],[60,124,"ombres-formats/A4-V-20",[552,-340,2188,1394]],[74.9,124,"ombres-formats/A4-V-21",[722,-340,2356,1394]],[89.9,124,"ombres-formats/A4-V-22",[892,-340,2740,1394]],[104.9,124,"ombres-formats/A4-V-23",[1062,-340,2740,1394]],[119.8,124,"ombres-formats/A4-V-24",[1230,-340,2740,1394]],[134.8,124,"ombres-formats/A4-V-25",[1400,-340,2966,1394]],[-44.8,138.9,"ombres-formats/A4-V-26",[-340,-340,1000,1226],0],[-29.8,138.9,"ombres-formats/A4-V-27",[-340,-340,1170,1226]],[-14.9,138.9,"ombres-formats/A4-V-28",[-340,-340,1338,1226]],[0.1,138.9,"ombres-formats/A4-V-29",[-340,-340,1508,1226]],[15.1,138.9,"ombres-formats/A4-V-30",[44,-340,1678,1226]],[30,138.9,"ombres-formats/A4-V-31",[212,-340,1848,1226]],[45,138.9,"ombres-formats/A4-V-32",[382,-340,2018,1226]],[60,138.9,"ombres-formats/A4-V-33",[552,-340,2188,1226]],[74.9,138.9,"ombres-formats/A4-V-34",[722,-340,2356,1226]],[89.9,138.9,"ombres-formats/A4-V-35",[892,-340,2740,1226]],[104.9,138.9,"ombres-formats/A4-V-36",[1062,-340,2740,1226]],[119.8,138.9,"ombres-formats/A4-V-37",[1230,-340,2740,1226]],[134.8,138.9,"ombres-formats/A4-V-38",[1400,-340,2966,1226]],[-44.8,153.9,"ombres-formats/A4-V-39",[-340,-226,1000,1056],0],[-29.8,153.9,"ombres-formats/A4-V-40",[-340,-226,1170,1056]],[-14.9,153.9,"ombres-formats/A4-V-41",[-340,-226,1338,1056]],[0.1,153.9,"ombres-formats/A4-V-42",[-340,-226,1508,1056]],[15.1,153.9,"ombres-formats/A4-V-43",[44,-226,1678,1056]],[30,153.9,"ombres-formats/A4-V-44",[212,-226,1848,1056]],[45,153.9,"ombres-formats/A4-V-45",[382,-226,2018,1056]],[60,153.9,"ombres-formats/A4-V-46",[552,-226,2188,1056]],[74.9,153.9,"ombres-formats/A4-V-47",[722,-226,2356,1056]],[89.9,153.9,"ombres-formats/A4-V-48",[892,-226,2740,1056]],[104.9,153.9,"ombres-formats/A4-V-49",[1062,-226,2740,1056]],[119.8,153.9,"ombres-formats/A4-V-50",[1230,-226,2740,1056]],[134.8,153.9,"ombres-formats/A4-V-51",[1400,-226,2966,1056]]],"A3-V":[[-39.5,114.2,"ombres-formats/A3-V-00",[-340,-340,1060,1506],0],[-25.5,114.2,"ombres-formats/A3-V-01",[-340,-340,1218,1506]],[-11.4,114.2,"ombres-formats/A3-V-02",[-340,-340,1378,1506]],[2.7,114.2,"ombres-formats/A3-V-03",[-340,-340,1538,1506]],[16.8,114.2,"ombres-formats/A3-V-04",[62,-340,1698,1506]],[30.9,114.2,"ombres-formats/A3-V-05",[222,-340,1858,1506]],[45,114.2,"ombres-formats/A3-V-06",[382,-340,2018,1506]],[59.1,114.2,"ombres-formats/A3-V-07",[542,-340,2178,1506]],[73.2,114.2,"ombres-formats/A3-V-08",[702,-340,2338,1506]],[87.3,114.2,"ombres-formats/A3-V-09",[862,-340,2740,1506]],[101.4,114.2,"ombres-formats/A3-V-10",[1022,-340,2740,1506]],[115.5,114.2,"ombres-formats/A3-V-11",[1182,-340,2740,1506]],[129.6,114.2,"ombres-formats/A3-V-12",[1342,-340,2966,1506]],[-39.5,125.7,"ombres-formats/A3-V-13",[-340,-340,1060,1376],0],[-25.5,125.7,"ombres-formats/A3-V-14",[-340,-340,1218,1376]],[-11.4,125.7,"ombres-formats/A3-V-15",[-340,-340,1378,1376]],[2.7,125.7,"ombres-formats/A3-V-16",[-340,-340,1538,1376]],[16.8,125.7,"ombres-formats/A3-V-17",[62,-340,1698,1376]],[30.9,125.7,"ombres-formats/A3-V-18",[222,-340,1858,1376]],[45,125.7,"ombres-formats/A3-V-19",[382,-340,2018,1376]],[59.1,125.7,"ombres-formats/A3-V-20",[542,-340,2178,1376]],[73.2,125.7,"ombres-formats/A3-V-21",[702,-340,2338,1376]],[87.3,125.7,"ombres-formats/A3-V-22",[862,-340,2740,1376]],[101.4,125.7,"ombres-formats/A3-V-23",[1022,-340,2740,1376]],[115.5,125.7,"ombres-formats/A3-V-24",[1182,-340,2740,1376]],[129.6,125.7,"ombres-formats/A3-V-25",[1342,-340,2966,1376]],[-39.5,137.2,"ombres-formats/A3-V-26",[-340,-340,1060,1244],0],[-25.5,137.2,"ombres-formats/A3-V-27",[-340,-340,1218,1244]],[-11.4,137.2,"ombres-formats/A3-V-28",[-340,-340,1378,1244]],[2.7,137.2,"ombres-formats/A3-V-29",[-340,-340,1538,1244]],[16.8,137.2,"ombres-formats/A3-V-30",[62,-340,1698,1244]],[30.9,137.2,"ombres-formats/A3-V-31",[222,-340,1858,1244]],[45,137.2,"ombres-formats/A3-V-32",[382,-340,2018,1244]],[59.1,137.2,"ombres-formats/A3-V-33",[542,-340,2178,1244]],[73.2,137.2,"ombres-formats/A3-V-34",[702,-340,2338,1244]],[87.3,137.2,"ombres-formats/A3-V-35",[862,-340,2740,1244]],[101.4,137.2,"ombres-formats/A3-V-36",[1022,-340,2740,1244]],[115.5,137.2,"ombres-formats/A3-V-37",[1182,-340,2740,1244]],[129.6,137.2,"ombres-formats/A3-V-38",[1342,-340,2966,1244]],[-39.5,148.7,"ombres-formats/A3-V-39",[-340,-226,1060,1114],0],[-25.5,148.7,"ombres-formats/A3-V-40",[-340,-226,1218,1114]],[-11.4,148.7,"ombres-formats/A3-V-41",[-340,-226,1378,1114]],[2.7,148.7,"ombres-formats/A3-V-42",[-340,-226,1538,1114]],[16.8,148.7,"ombres-formats/A3-V-43",[62,-226,1698,1114]],[30.9,148.7,"ombres-formats/A3-V-44",[222,-226,1858,1114]],[45,148.7,"ombres-formats/A3-V-45",[382,-226,2018,1114]],[59.1,148.7,"ombres-formats/A3-V-46",[542,-226,2178,1114]],[73.2,148.7,"ombres-formats/A3-V-47",[702,-226,2338,1114]],[87.3,148.7,"ombres-formats/A3-V-48",[862,-226,2740,1114]],[101.4,148.7,"ombres-formats/A3-V-49",[1022,-226,2740,1114]],[115.5,148.7,"ombres-formats/A3-V-50",[1182,-226,2740,1114]],[129.6,148.7,"ombres-formats/A3-V-51",[1342,-226,2966,1114]]],"A2-V":[[-33.8,125,"ombres-formats/A2-V-00",[-340,-340,1124,1384],0],[-19.5,125,"ombres-formats/A2-V-01",[-340,-340,1286,1384]],[-5.1,125,"ombres-formats/A2-V-02",[-340,-340,1450,1384]],[9.2,125,"ombres-formats/A2-V-03",[-340,-340,1612,1384]],[23.5,125,"ombres-formats/A2-V-04",[138,-340,1774,1384]],[37.8,125,"ombres-formats/A2-V-05",[300,-340,1936,1384]],[52.2,125,"ombres-formats/A2-V-06",[464,-340,2100,1384]],[66.5,125,"ombres-formats/A2-V-07",[626,-340,2262,1384]],[80.8,125,"ombres-formats/A2-V-08",[788,-340,2740,1384]],[95.1,125,"ombres-formats/A2-V-09",[950,-340,2740,1384]],[109.5,125,"ombres-formats/A2-V-10",[1114,-340,2740,1384]],[123.8,125,"ombres-formats/A2-V-11",[1276,-340,2966,1384]],[-33.8,137.9,"ombres-formats/A2-V-12",[-340,-226,1124,1238],0],[-19.5,137.9,"ombres-formats/A2-V-13",[-340,-226,1286,1238]],[-5.1,137.9,"ombres-formats/A2-V-14",[-340,-226,1450,1238]],[9.2,137.9,"ombres-formats/A2-V-15",[-340,-226,1612,1238]],[23.5,137.9,"ombres-formats/A2-V-16",[138,-226,1774,1238]],[37.8,137.9,"ombres-formats/A2-V-17",[300,-226,1936,1238]],[52.2,137.9,"ombres-formats/A2-V-18",[464,-226,2100,1238]],[66.5,137.9,"ombres-formats/A2-V-19",[626,-226,2262,1238]],[80.8,137.9,"ombres-formats/A2-V-20",[788,-226,2740,1238]],[95.1,137.9,"ombres-formats/A2-V-21",[950,-226,2740,1238]],[109.5,137.9,"ombres-formats/A2-V-22",[1114,-226,2740,1238]],[123.8,137.9,"ombres-formats/A2-V-23",[1276,-226,2966,1238]]]}},{"id":"S05","n":["Cuisine","Kitchen"],"img":[2400,2400],"web":0.666667,"hf":[11.4285767,0.000001737591484,1241.142518,-1.477033912e-13,-11.4285766,2146.64927,6.129715332e-14,2.23933449e-9,1],"hm":[11.34571561,-1.536306585e-11,1240.728005,-4.442777548e-13,-11.34571363,2135.711223,-6.480724332e-14,-3.856298776e-14,1],"zone":[-109.4,102.2,110,188.2],"exclus":[[-93.4,-69.4,114,134],[-109.4,-91.4,146,150],[-89.4,-65.4,146,150],[-57.4,-49.4,146,150],[-47.4,-39.4,146,148],[-83.4,-67.4,150,176],[-101.4,-93.4,154,166],[-109.4,-107.4,158,166]],"c":[30,147],"m":{"A4-H":["ombre-A4-H",[764,0,2398,1286],[30,147]],"A3-H":["ombre-A3-H",[764,0,2398,1286],[30,147]],"A2-H":["ombre-A2-H",[764,0,2398,1286],[30,147]],"A4-V":["ombre-A4-V",[764,0,2398,1286],[30,147]],"A3-V":["ombre-A3-V",[764,0,2398,1286],[30,147]],"A2-V":["ombre-A2-V",[764,0,2398,1286],[30,147]]}},{"id":"S06","n":["Bureau","Study"],"img":[2400,2400],"web":0.666667,"hf":[11.42857221,2.588139788e-13,1199.999891,-6.717591961e-14,-11.42857175,2213.696705,2.839309472e-14,2.184084209e-15,1],"hm":[11.33899709,4.447787509e-11,1199.999865,7.189422992e-13,-11.3389982,2200.708521,1.138730136e-13,4.620146137e-14,1],"zone":[-105.8,105.8,93,194.1],"exclus":[],"c":[0,134.95],"m":{"A4-H":["ombre-A4-H",[382,0,2018,1488],[0,134.95]],"A3-H":["ombre-A3-H",[382,0,2018,1488],[0,134.95]],"A2-H":["ombre-A2-H",[382,0,2018,1488],[0,134.95]],"A4-V":["ombre-A4-V",[382,0,2018,1488],[0,134.95]],"A3-V":["ombre-A3-V",[382,0,2018,1488],[0,134.95]],"A2-V":["ombre-A2-V",[382,0,2018,1488],[0,134.95]]}},{"id":"S07","p":"s07b","n":["Chalet","Chalet"],"img":[2400,2400],"web":0.666667,"hf":[7.244126875,4.496517767e-7,1272.441138,-1.069821092e-13,-7.244126797,2228.22488,2.003061243e-14,1.864633019e-10,1],"hm":[7.179486711,-5.871791779e-11,1271.794799,-1.160289141e-10,-7.179486566,2219.692386,-1.537203048e-13,-6.083261661e-14,1],"zone":[-177.1,157.1,62,255],"exclus":[[100.9,156.9,62,256]],"c":[-45,115],"m":{"A4-H":["ombre-A4-H",[430,660,1466,1696],[-45,145]],"A3-H":["ombre-A3-H",[430,660,1466,1696],[-45,145]],"A2-H":["ombre-A2-H",[430,660,1466,1696],[-45,145]],"A4-V":["ombre-A4-V",[430,660,1466,1696],[-45,145]],"A3-V":["ombre-A3-V",[430,660,1466,1696],[-45,145]],"A2-V":["ombre-A2-V",[430,660,1466,1696],[-45,145]]}},{"id":"S10","n":["Couloir","Corridor"],"img":[2400,2400],"web":0.666667,"hf":[8.360205651,5.405835437e-7,2872.041605,-1.766225136e-13,-8.360204792,2286.826759,-7.960832366e-15,2.240657868e-10,1],"hm":[8.27423108,1.192426869e-12,2854.846687,-2.503884126e-13,-8.274230601,2275.650051,1.583313598e-14,2.929130157e-14,1],"zone":[-340,-55,60,240],"exclus":[],"c":[-200,145],"m":{"A4-H":["ombre-A4-H",[604,480,1796,1672],[-200,145]],"A3-H":["ombre-A3-H",[604,480,1796,1672],[-200,145]],"A2-H":["ombre-A2-H",[604,480,1796,1672],[-200,145]],"A4-V":["ombre-A4-V",[604,480,1796,1672],[-200,145]],"A3-V":["ombre-A3-V",[604,480,1796,1672],[-200,145]],"A2-V":["ombre-A2-V",[604,480,1796,1672],[-200,145]]}}];
  /* Les images des pièces sont des fichiers du thème, à plat : cac-piece-<id>-<nom>.webp (<p> à la place de <id> si
     la pièce en porte un : le chalet refait du 28/10 sert cac-piece-s07b-*) ; les ombres de la
     grille (ombres-formats/A2-H-00) deviennent cac-piece-<id>-grille-A2-H-00.webp. data-cac-rooms porte le
     dossier des fichiers du thème (asset_url sans le nom). */
  var ROOM_BASE = root.getAttribute('data-cac-rooms') || '';
  var ROOM_V = '20261028-1544'; /* à changer à chaque pose d'images de pièces (le CDN ne purge pas une adresse sans version) */
  function roomSrc(id, f) { return ROOM_BASE + 'cac-piece-' + ((roomById(id) || {}).p || id.toLowerCase()) + '-' + f.replace('ombres-formats/', 'grille-') + '.webp?v=' + ROOM_V; }
  var ROOM_EN = /^en/i.test(document.documentElement.getAttribute('lang') || '');
  var PG = null;
  function roomById(id) { for (var i = 0; i < ROOMS.length; i++) if (ROOMS[i].id === id) return ROOMS[i]; return null; }
  function hApply(h, x, z) { var w = h[6] * x + h[7] * z + h[8]; return [(h[0] * x + h[1] * z + h[2]) / w, (h[3] * x + h[4] * z + h[5]) / w]; }
  function uniqSorted(a) { var o = []; a.forEach(function (v) { if (o.indexOf(v) < 0) o.push(v); }); return o.sort(function (p, q) { return p - q; }); }
  function nearestOf(list, v) { var b = list[0]; list.forEach(function (x) { if (Math.abs(x - v) < Math.abs(b - v)) b = x; }); return b; }
  function pieceKey(f) { return f.fmt + '-' + (catById[f.id].orient === 'h' ? 'H' : 'V'); }
  /* La boîte de la composition (cadres et place vide), en cm de la mise en page */
  function compoBox() {
    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    function add(x, y, w, h) { x0 = Math.min(x0, x); y0 = Math.min(y0, y); x1 = Math.max(x1, x + w); y1 = Math.max(y1, y + h); }
    state.frames.forEach(function (f) { var d = dimsCm(f.fmt, catById[f.id].orient); add(f.x, f.y, d[0], d[1]); });
    ghostRects().forEach(function (g) { add(g.x, g.y, g.w, g.h); });
    if (!isFinite(x0)) { x0 = 0; y0 = 0; x1 = GHOST[0]; y1 = GHOST[1]; }
    return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
  }
  /* Le centre de la composition sur le mur : celui du cadre de la scène, ramené dans la zone
     d'accrochage ; les places exclues (l'étagère de la cuisine) la font glisser au plus près.
     La place exacte : un bord de la zone ou d'une exclusion, à une demi-largeur (chercher de 1 cm
     en 1 cm pouvait rater la seule place). Vraiment bloquée : `libre` est la plus grande place
     libre à cette hauteur, et la composition s'y centre, sans sortir de la zone, plutôt que de
     rester sur l'exclusion. */
  /* La zone du kit, ramenée à la partie visible de l'image (3 % de marge) : ce qui dépasse de la
     photo ne se voit pas, donc ne compte pas comme de la place. */
  function visZone(room) {
    if (room._vz) return room._vz;
    var z = room.zone.slice(), H = room.hf, W = room.img[0], Hh = room.img[1], m = 0.03;
    var cx = (z[0] + z[1]) / 2, cz = (z[2] + z[3]) / 2;
    function yAt(v) { return hApply(H, cx, v)[1]; }
    function xAt(v) { return hApply(H, v, cz)[0]; }
    function cut(a, b, ok) { for (var i = 0; i < 40; i++) { var mid = (a + b) / 2; if (ok(mid)) a = mid; else b = mid; } return a; }
    if (!(yAt(z[3]) >= m * Hh)) z[3] = cut(cz, z[3], function (v) { return yAt(v) >= m * Hh; });
    if (!(yAt(z[2]) <= (1 - m) * Hh)) z[2] = cut(cz, z[2], function (v) { return yAt(v) <= (1 - m) * Hh; });
    if (!(xAt(z[0]) >= m * W)) z[0] = cut(cx, z[0], function (v) { return xAt(v) >= m * W; });
    if (!(xAt(z[1]) <= (1 - m) * W)) z[1] = cut(cx, z[1], function (v) { return xAt(v) <= (1 - m) * W; });
    room._vz = z; return z;
  }
  function placeCompo(room, b) {
    var z = visZone(room), zw = z[1] - z[0], zh = z[3] - z[2];
    var cx = room.c[0], cz = room.c[1];
    var fitsW = b.w <= zw + 0.01, fitsH = b.h <= zh + 0.01, blocked = false, libre = zw;
    /* trop large : la composition part du bord gauche de la place ; les cadres qui dépassent à droite
       sont « en trop » (grisés, une croix pour les retirer d'un geste) */
    cx = fitsW ? Math.max(z[0] + b.w / 2, Math.min(z[1] - b.w / 2, cx)) : z[0] + b.w / 2;
    cz = fitsH ? Math.max(z[2] + b.h / 2, Math.min(z[3] - b.h / 2, cz)) : z[3] - b.h / 2;
    if (room.exclus.length && fitsW && fitsH) {
      var lo = cz - b.h / 2, hi = cz + b.h / 2;
      var ex = room.exclus.filter(function (e) { return lo < e[3] && hi > e[2]; });
      var hit = function (x) {
        var l = x - b.w / 2, r = x + b.w / 2;
        return ex.some(function (e) { return l < e[1] - 0.01 && r > e[0] + 0.01; });
      };
      if (hit(cx)) {
        var best = null, c0 = cx, cands = [z[0] + b.w / 2, z[1] - b.w / 2];
        ex.forEach(function (e) { cands.push(e[0] - b.w / 2, e[1] + b.w / 2); });
        cands.forEach(function (x) {
          if (x - b.w / 2 >= z[0] - 0.01 && x + b.w / 2 <= z[1] + 0.01 && !hit(x) &&
            (best === null || Math.abs(x - c0) < Math.abs(best - c0))) best = x;
        });
        if (best !== null) cx = best;
        else {
          blocked = true;
          var segs = [[z[0], z[1]]];
          ex.forEach(function (e) {
            var out = [];
            segs.forEach(function (g) {
              if (e[1] <= g[0] || e[0] >= g[1]) { out.push(g); return; }
              if (e[0] > g[0]) out.push([g[0], e[0]]);
              if (e[1] < g[1]) out.push([e[1], g[1]]);
            });
            segs = out;
          });
          var big = segs.reduce(function (p, q) { return q[1] - q[0] > p[1] - p[0] ? q : p; }, [cx, cx]);
          libre = big[1] - big[0];
          if (libre > 0) cx = Math.max(z[0] + b.w / 2, Math.min(z[1] - b.w / 2, (big[0] + big[1]) / 2));
        }
      }
    }
    return { cx: cx, cz: cz, fits: fitsW && fitsH && !blocked, wide: !fitsW || blocked, high: !fitsH, zw: zw, zh: zh, bloquee: blocked, libre: libre };
  }
  /* Un rectangle de la mise en page (cm) sur le mur de la pièce : bord gauche, haut et centre, en
     cm du mur. Mur à lames (chalet) : le centre se pose sur la rangée la plus proche. */
  function pieceWall(x, y, w, h, key) {
    var b = PG.b, room = PG.room;
    var xl = PG.cx - b.w / 2 + (x - b.x), zt = PG.cz + b.h / 2 - (y - b.y);
    if (room.lames && room.g && key && room.g[key]) {
      var rows = uniqSorted(room.g[key].map(function (e) { return e[1]; })), vz = visZone(room);
      var sous = rows.filter(function (r) { return r + h / 2 <= vz[3] + 0.5; });
      var zc = sous.length ? nearestOf(sous, zt - h / 2) : Math.min(zt, vz[3]) - h / 2;
      zt = zc + h / 2;
    }
    return { xl: xl, zt: zt, cx: xl + w / 2, cz: zt - h / 2 };
  }
  function n6(v) { return Math.abs(v) < 1e-9 ? 0 : +v.toFixed(6); }
  /* La matrice d'un élément de w × h cm (à PXCM px le cm) posé sur la face des cadres */
  function pieceMatrix(x, y, w, h, key) {
    var q = pieceWall(x, y, w, h, key), H = PG.room.hf, s = PG.s, P = PXCM;
    var a = s * H[0] / P, b = -s * H[1] / P, c = s * (H[0] * q.xl + H[1] * q.zt + H[2]);
    var d = s * H[3] / P, e = -s * H[4] / P, f = s * (H[3] * q.xl + H[4] * q.zt + H[5]);
    var g = H[6] / P, hh = -H[7] / P, i = H[6] * q.xl + H[7] * q.zt + H[8];
    /* le cadrage du téléphone : l'image commence à (ox, oy) */
    var T = PG.ox * s, U = PG.oy * s;
    a -= T * g; b -= T * hh; c -= T * i; d -= U * g; e -= U * hh; f -= U * i;
    return 'matrix3d(' + [a / i, d / i, 0, g / i, b / i, e / i, 0, hh / i, 0, 0, 1, 0, c / i, f / i, 0, 1].map(n6).join(',') + ')';
  }
  /* Les quatre coins d'un rectangle du mur, en px affichés */
  function pieceQuad(q, d) {
    var H = PG.room.hf, s = PG.s;
    return [[q.xl, q.zt], [q.xl + d[0], q.zt], [q.xl + d[0], q.zt - d[1]], [q.xl, q.zt - d[1]]].map(function (p) {
      var u = hApply(H, p[0], p[1]); return [(u[0] - PG.ox) * s, (u[1] - PG.oy) * s];
    });
  }
  /* Les cartes d'ombre d'un cadre et leur poids (règle ombres.pose du kit) : une carte par format,
     ou la grille ombres.formats (sans les places melange: false ; deux colonnes et deux rangées,
     poids linéaires en cm ; mur à lames : la rangée utilisable la plus proche, en x seulement). */
  function shadowMaps(room, key, cx, cz) {
    if (room.m) { var m = room.m[key]; return m ? [{ file: m[0], box: m[1], a: m[2], w: 1 }] : []; }
    var L = (room.g && room.g[key]) || [];
    var U = L.filter(function (e) { return e[4] !== 0; });
    if (!U.length) U = L;
    if (!U.length) return [];
    var rows = uniqSorted(U.map(function (e) { return e[1]; }));
    function inRow(z) { return U.filter(function (e) { return e[1] === z; }).sort(function (p, q) { return p[0] - q[0]; }); }
    function xPair(row, wz) {
      var n = row.length;
      if (n === 1 || cx <= row[0][0]) return [{ e: row[0], w: wz }];
      if (cx >= row[n - 1][0]) return [{ e: row[n - 1], w: wz }];
      for (var i = 0; i < n - 1; i++) {
        if (cx >= row[i][0] && cx <= row[i + 1][0]) {
          var t = (cx - row[i][0]) / (row[i + 1][0] - row[i][0]);
          return [{ e: row[i], w: wz * (1 - t) }, { e: row[i + 1], w: wz * t }];
        }
      }
      return [{ e: row[0], w: wz }];
    }
    var picks = [];
    if (room.lames || rows.length === 1) picks = xPair(inRow(nearestOf(rows, cz)), 1);
    else if (cz <= rows[0]) picks = xPair(inRow(rows[0]), 1);
    else if (cz >= rows[rows.length - 1]) picks = xPair(inRow(rows[rows.length - 1]), 1);
    else {
      for (var j = 0; j < rows.length - 1; j++) {
        if (cz >= rows[j] && cz <= rows[j + 1]) {
          var tz = (cz - rows[j]) / (rows[j + 1] - rows[j]);
          picks = xPair(inRow(rows[j]), 1 - tz).concat(xPair(inRow(rows[j + 1]), tz));
          break;
        }
      }
    }
    return picks.filter(function (p) { return p.w > 0.002; }).map(function (p) {
      return { file: p.e[2], box: p.e[3], a: [p.e[0], p.e[1]], w: p.w };
    });
  }
  /* fit() en pièce : la pièce entière dans la place du mur, et PXCM = un cm de la face des cadres */
  function fitPiece(room) {
    var stage = $('#brpStage'), viewport = $('#brpViewport'), shell = $('#brpCanvasShell'), canvas = $('#brpCanvas');
    var fs = root.classList.contains('br-fs'), app = root.classList.contains('brp-app'), mobile = window.innerWidth < 900;
    var availW = (viewport.clientWidth || stage.clientWidth) - (fs ? 20 : 0);
    var availH;
    if (fs) availH = (app && viewport.clientHeight) ? viewport.clientHeight - 6 : window.innerHeight - (mobile ? 68 : 38);
    else if (app) availH = Math.max(160, (viewport.clientHeight || Math.round(window.innerHeight * 0.5)) - 6);
    else availH = Math.max(400, window.innerHeight * 0.58);
    var tiers = $('#brpTiers'), minTop = -Infinity;
    if (!fs && tiers && tiers.getClientRects().length) {
      var vTop = viewport.getBoundingClientRect().top, over = tiers.getBoundingClientRect().bottom + 10 - vTop;
      if (over > 0) { availH = Math.max(160, availH - over); minTop = vTop + over; }
    }
    var ar = room.img[0] / room.img[1];
    var Dw = Math.round(Math.max(120, Math.min(availW, availH * ar))), Dh = Math.round(Dw / ar);
    var b = compoBox(), pl = placeCompo(room, b), s = Dw / room.img[0], ox = 0, oy = 0;
    /* Au téléphone (< 750 px), la pièce prend toute la largeur, comme le mur uni : un cadrage en
       largeur autour du mur et de la composition : les cadres deux fois plus grands que dans la
       pièce entière, la composition au plus sur 60 % de la largeur et 77 % de la hauteur. L'ordinateur
       (plus bas) : une bande 16:10 au plus autour de la composition. */
    if (window.innerWidth < 750) {
      var k = [[pl.cx - b.w / 2, pl.cz + b.h / 2], [pl.cx + b.w / 2, pl.cz + b.h / 2], [pl.cx + b.w / 2, pl.cz - b.h / 2], [pl.cx - b.w / 2, pl.cz - b.h / 2]]
        .map(function (p) { return hApply(room.hf, p[0], p[1]); });
      var kx0 = Math.min.apply(null, k.map(function (p) { return p[0]; })), kx1 = Math.max.apply(null, k.map(function (p) { return p[0]; }));
      var ky0 = Math.min.apply(null, k.map(function (p) { return p[1]; })), ky1 = Math.max.apply(null, k.map(function (p) { return p[1]; }));
      var cW = Math.round(availW), cH = Math.round(Math.max(Dh, availH));
      var cw = Math.min(room.img[0], Math.max(cW * room.img[1] / (2 * Dh), (kx1 - kx0) / 0.6, (ky1 - ky0) * 1.3 * cW / cH));
      s = cW / cw;
      var ch = Math.min(room.img[1], cH / s);
      ox = Math.max(0, Math.min(room.img[0] - cw, (kx0 + kx1) / 2 - cw / 2));
      oy = Math.max(0, Math.min(room.img[1] - ch, (ky0 + ky1) / 2 - ch / 2));
      Dw = cW; Dh = Math.round(ch * s);
    }
    else if (!fs) {
      var cW2 = Math.round(Math.min(availW, availH * 1.6)), cH2 = Math.round(availH);
      var s2 = Math.max(cH2 / room.img[1], cW2 / room.img[0]), cw2 = Math.min(room.img[0], cW2 / s2), ch2 = Math.min(room.img[1], cH2 / s2);
      var k2 = [[pl.cx - b.w / 2, pl.cz + b.h / 2], [pl.cx + b.w / 2, pl.cz - b.h / 2]].map(function (p) { return hApply(room.hf, p[0], p[1]); });
      var ax0 = Math.min(k2[0][0], k2[1][0]), ax1 = Math.max(k2[0][0], k2[1][0]), ay0 = Math.min(k2[0][1], k2[1][1]), ay1 = Math.max(k2[0][1], k2[1][1]);
      /* la bande montre déjà toute la largeur de la pièce : une composition trop large (cadres en
         trop) y tient aussi bien que dans la pièce entière, sans que la scène rétrécisse d'un coup */
      var pleineLargeur = cw2 >= room.img[0] - 1;
      if (cW2 > Dw + 8 && ((ax1 - ax0) <= cw2 * 0.92 || pleineLargeur) && (ay1 - ay0) <= ch2 * 0.84) {
        s = s2;
        ox = Math.max(0, Math.min(room.img[0] - cw2, (ax0 + ax1) / 2 - cw2 / 2));
        oy = Math.max(0, Math.min(room.img[1] - ch2, (ay0 + ay1) / 2 - ch2 * 0.45));
        Dw = Math.round(cw2 * s); Dh = Math.round(ch2 * s);
      }
    }
    PG = { room: room, s: s, ox: ox, oy: oy, b: b, cx: pl.cx, cz: pl.cz, pl: pl, w: Dw, h: Dh };
    var p0 = hApply(room.hf, pl.cx, pl.cz), p1 = hApply(room.hf, pl.cx + 1, pl.cz);
    PXCM = Math.max(0.05, Math.abs(p1[0] - p0[0]) * PG.s);
    shell.style.marginBottom = '';
    canvas.style.width = Dw + 'px'; canvas.style.height = Dh + 'px';
    shell.style.width = Dw + 'px'; shell.style.height = Dh + 'px';
    canvas.style.transformOrigin = 'top left'; canvas.style.transform = 'none';
    canvas.classList.remove('is-float', 'is-sketch', 'is-white');
    canvas.classList.add('is-piece');
    canvas.style.background = '';
    renderSketch(canvas, null);
    stage.style.backgroundColor = '';
    if (stage.parentElement) stage.parentElement.style.backgroundColor = '';
    root.classList.add('cac-en-piece');
    snapShell(shell, minTop);
  }
  var roomEl = null, roomTop = null, roomSig = '';
  function px(v) { return (Math.round(v * 10) / 10) + 'px'; }
  /* Les cadres qui ne tiennent pas dans la place du mur (Max, 27/10 : « plus simple de les retirer, pas
     un texte qui dise « Attention, il y en a une de trop » ») : grisés, avec une croix pour les retirer
     d'un geste. Un seul cadre trop grand reste tel quel : on change son format. */
  function pieceTrop() {
    var out = {}, room = PG.room, z = visZone(room), n = state.frames.length;
    if (PG.pl.fits || n < 2) return out;
    state.frames.forEach(function (f) {
      var d = dimsCm(f.fmt, catById[f.id].orient), q = pieceWall(f.x, f.y, d[0], d[1], pieceKey(f));
      var l = q.xl, r = q.xl + d[0], t = q.zt, bo = q.zt - d[1];
      /* en largeur seulement : un cadre trop haut ne se règle pas en en retirant un */
      var dehors = l < z[0] - 0.5 || r > z[1] + 0.5;
      if (!dehors && PG.pl.bloquee) dehors = room.exclus.some(function (e) { return l < e[1] - 0.5 && r > e[0] + 0.5 && bo < e[3] - 0.5 && t > e[2] + 0.5; });
      if (dehors) out[f.uid] = q;
    });
    /* tout dépasse (trop haut) : la croix sur le dernier seulement */
    var ids = Object.keys(out);
    if (ids.length >= n) { var last = state.frames[n - 1].uid, keep = {}; keep[last] = out[last]; out = keep; }
    return out;
  }
  function roomTrop(trop) {
    var h = '', lab = t('room_remove', ROOM_EN ? 'Remove this frame' : 'Retirer ce cadre');
    state.frames.forEach(function (f) {
      if (!trop[f.uid]) return;
      var d = dimsCm(f.fmt, catById[f.id].orient), Q = pieceQuad(trop[f.uid], d);
      /* un cadre hors de l'image n'a pas de croix (il apparaît quand on en retire un autre) ; sinon la
         croix au milieu de ce qu'on voit du cadre grisé (au coin de l'image, elle se lisait « fermer ») */
      if (Q[0][0] > PG.w - 24 || Q[1][0] < 24 || Q[2][1] < 24 || Q[0][1] > PG.h - 24) return;
      var cxp = (Math.max(Q[0][0], 0) + Math.min(Q[1][0], PG.w)) / 2, cyp = (Math.max(Q[0][1], 0) + Math.min(Q[3][1], PG.h)) / 2;
      cxp = Math.max(18, Math.min(PG.w - 18, cxp)); cyp = Math.max(18, Math.min(PG.h - 18, cyp));
      h += '<button type="button" class="cac-room__retirer" data-cac-act="retirer" data-uid="' + f.uid + '" aria-label="' + lab + '" title="' + lab + '" style="left:' + px(cxp) + ';top:' + px(cyp) + '">' +
        '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 4l8 8M12 4l-8 8"/></svg></button>';
    });
    return h;
  }
  /* Le contour des cadres, pour la lumière du mur : en px de l'image affichée (sans le cadrage) */
  function piecePath() {
    var tx = PG.ox * PG.s, ty = PG.oy * PG.s;
    return state.frames.map(function (f) {
      var d = dimsCm(f.fmt, catById[f.id].orient), Q = pieceQuad(pieceWall(f.x, f.y, d[0], d[1], pieceKey(f)), d);
      return 'M' + Q.map(function (p) { return (p[0] + tx).toFixed(1) + ' ' + (p[1] + ty).toFixed(1); }).join('L') + 'Z';
    }).join('');
  }
  /* Pendant le glisser : la lumière suit les cadres, l'ombre du cadre déplacé se cache ; tout se
     redessine au lâcher (sinon un rectangle sombre restait sur le mur à l'ancienne place). */
  function pieceDrag(uid) {
    if (!PG || !roomEl || !roomTop) return;
    var lum = roomTop.querySelector('.cac-room__lumiere');
    if (lum) { var p = 'path(\'' + piecePath() + '\')'; lum.style.clipPath = p; lum.style.webkitClipPath = p; }
    Array.prototype.forEach.call(roomEl.querySelectorAll('.cac-room__ombre[data-uid="' + uid + '"]'), function (o) { o.style.visibility = 'hidden'; });
    roomSig = '';
  }
  function renderRoom() {
    var canvas = $('#brpCanvas'), frames = $('#brpFrames');
    if (!PG) {
      if (roomEl) roomEl.hidden = true;
      if (roomTop) roomTop.hidden = true;
      roomSig = '';
      return;
    }
    var room = PG.room, s = PG.s;
    if (!roomEl) {
      roomEl = el('div', 'cac-room'); roomEl.setAttribute('aria-hidden', 'true');
      canvas.insertBefore(roomEl, frames);
    }
    if (!roomTop) {
      roomTop = el('div', 'cac-room-top');
      canvas.appendChild(roomTop);
      roomTop.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cac-act]'); if (!b) return;
        e.stopPropagation();
        if (b.dataset.cacAct === 'retirer' && state.frames.length > 1) removeFrame(+b.dataset.uid);
      });
    }
    roomEl.hidden = false; roomTop.hidden = false;
    /* l'image entière, décalée du cadrage du téléphone (ox, oy) */
    var box = 'left:' + px(-PG.ox * s) + ';top:' + px(-PG.oy * s) + ';width:' + px(room.img[0] * s) + ';height:' + px(room.img[1] * s);
    var html = '<img class="cac-room__piece" src="' + roomSrc(room.id, 'piece') + '" alt="" draggable="false" decoding="async" style="' + box + '">';
    state.frames.forEach(function (f) {
      var d = dimsCm(f.fmt, catById[f.id].orient), key = pieceKey(f);
      var q = pieceWall(f.x, f.y, d[0], d[1], key);
      var c0 = hApply(room.hm, q.cx, q.cz);
      shadowMaps(room, key, q.cx, q.cz).forEach(function (m) {
        var c1 = hApply(room.hm, m.a[0], m.a[1]), du = c0[0] - c1[0], dv = c0[1] - c1[1], bx = m.box;
        html += '<img class="cac-room__ombre" data-uid="' + f.uid + '" src="' + roomSrc(room.id, m.file) + '" alt="" draggable="false" decoding="async" style="left:' +
          px((bx[0] + du - PG.ox) * s) + ';top:' + px((bx[1] + dv - PG.oy) * s) + ';width:' + px((bx[2] - bx[0]) * s) + ';height:' + px((bx[3] - bx[1]) * s) +
          (m.w < 0.998 ? ';opacity:' + m.w.toFixed(3) : '') + '">';
      });
    });
    var path = piecePath(), trop = pieceTrop();
    Array.prototype.forEach.call($$('#brpFrames .br-frame[data-uid]'), function (fe) { fe.classList.toggle('cac-trop', !!trop[fe.dataset.uid]); });
    var ww = Math.round(room.img[0] * room.web), wh = Math.round(room.img[1] * room.web);
    var top = (path ? '<img class="cac-room__lumiere" src="' + roomSrc(room.id, 'lumiere') + '" alt="" draggable="false" decoding="async" style="' + box + ';clip-path:path(\'' + path + '\');-webkit-clip-path:path(\'' + path + '\')">' : '') +
      '<svg class="cac-room__devant" style="' + box + '" viewBox="0 0 ' + ww + ' ' + wh + '" preserveAspectRatio="none" aria-hidden="true" focusable="false">' +
        '<defs><mask id="cacDevant" maskUnits="userSpaceOnUse" x="0" y="0" width="' + ww + '" height="' + wh + '">' +
          '<image href="' + roomSrc(room.id, 'devant') + '" width="' + ww + '" height="' + wh + '" preserveAspectRatio="none"/></mask></defs>' +
        '<image href="' + roomSrc(room.id, 'piece') + '" width="' + ww + '" height="' + wh + '" preserveAspectRatio="none" mask="url(#cacDevant)"/>' +
      '</svg>' + roomTrop(trop);
    var sig = html + top;
    if (sig === roomSig) return;
    roomSig = sig;
    roomEl.innerHTML = html;
    roomTop.innerHTML = top;
  }
  /* Le choix « Pièce », en tête du volet du mur (au téléphone, l'onglet Mur de la piste A) */
  function renderPieces() {
    Array.prototype.forEach.call($$('#cacPieces [data-piece]'), function (b) {
      var on = (b.dataset.piece || null) === state.piece;
      b.classList.toggle('on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  function setPiece(id) {
    state.piece = id && roomById(id) ? id : null;
    renderPieces(); fit(); renderFrames(); renderLeader();
  }
  function buildPieces() {
    var body = document.getElementById('brpWallBody');
    if (!body || !ROOMS.length || document.getElementById('cacPieces')) return;
    var g = el('div', 'br-wgroup cac-pieces'); g.id = 'cacPieces';
    var lbl = el('span', 'br-lbl'); lbl.textContent = t('room_label', ROOM_EN ? 'Room' : 'Pièce');
    g.appendChild(lbl);
    var row = el('div', 'cac-pieces__row');
    row.setAttribute('role', 'radiogroup'); row.setAttribute('aria-label', lbl.textContent);
    [{ id: '', n: ['Mur uni', 'Plain wall'] }].concat(ROOMS).forEach(function (r) {
      var b = el('button', 'cac-piece'); b.type = 'button';
      b.setAttribute('role', 'radio'); b.dataset.piece = r.id;
      b.innerHTML = (r.id ? '<img src="' + roomSrc(r.id, 'vignette') + '" alt="" loading="lazy" draggable="false">' : '<i class="cac-piece__uni" aria-hidden="true"></i>') +
        '<span>' + esc(t('room_' + (r.id || 'uni'), ROOM_EN ? r.n[1] : r.n[0])) + '</span>';
      row.appendChild(b);
    });
    row.addEventListener('click', function (e) { var b = e.target.closest('[data-piece]'); if (b) setPiece(b.dataset.piece || null); });
    g.appendChild(row);
    body.insertBefore(g, body.firstChild);
    var qp = (new URLSearchParams(window.location.search).get('piece') || '').toUpperCase();
    if (qp === 'UNI') state.piece = null;
    else if (roomById(qp)) state.piece = qp;
    renderPieces();
  }

  var PIECE_Q = (new URLSearchParams(window.location.search).get('piece') || '').toUpperCase();
  function fit() {
    if (PIECE_Q) { state.piece = PIECE_Q === 'UNI' ? null : (roomById(PIECE_Q) ? PIECE_Q : state.piece); PIECE_Q = ''; }
    renderPieces();
    if (state.piece && roomById(state.piece)) { fitPiece(roomById(state.piece)); return; }
    PG = null; $('#brpCanvas').classList.remove('is-piece'); root.classList.remove('cac-en-piece');
    var stage = $('#brpStage'), viewport = $('#brpViewport'), shell = $('#brpCanvasShell'), canvas = $('#brpCanvas');
    var d = regionDims(), W = d[0], H = d[1];
    var fs = root.classList.contains('br-fs');
    var mobile = window.innerWidth < 900;
    var displayW = state.rotated ? H : W, displayH = state.rotated ? W : H;
    var availW = (viewport.clientWidth || stage.clientWidth) - (fs ? 20 : 0);
    if (sideAddsOn()) availW -= 2 * sideAddSpace();
    if (mobile && state.previewMode === 'large' && !fs) availW *= state.largeZoom;
    /* En mode « un seul écran », la scène occupe la hauteur que le flex lui
       laisse : on la mesure au lieu de prendre 58 % de la fenêtre. Le repli
       garde l'ancien calcul tant que la mise en page n'est pas faite. */
    var app = root.classList.contains('brp-app');
    var availH;
    /* En plein écran du mode « un seul écran », la scène est une couche fixe
       avec ses propres marges : on mesure la place que le flex laisse au
       viewport au lieu de soustraire des constantes devinées. */
    if (fs) availH = (app && viewport.clientHeight) ? viewport.clientHeight - 6 : window.innerHeight - (mobile ? 68 : 38);
    else if (app) availH = Math.max(160, (viewport.clientHeight || Math.round(window.innerHeight * 0.5)) - 6);
    else availH = Math.max(400, window.innerHeight * 0.58);
    if (mobile && state.previewMode === 'large' && !fs && !app) availH = window.innerHeight;
    /* 27/10 (Max, grand mur) : la rangée des remises, posée en haut de la scène,
       passait sur le bord haut du mur dessiné. Sur « Mon mur », le mur laisse leur
       hauteur au-dessus de lui, et pas plus : il descend d'autant (snapShell). */
    var tiers = $('#brpTiers'), minTop = -Infinity;
    if (state.scale === 'real' && !fs && tiers && tiers.getClientRects().length) {
      var vTop = viewport.getBoundingClientRect().top, over = tiers.getBoundingClientRect().bottom + 10 - vTop;
      if (over > 0) { availH = Math.max(160, availH - over); minTop = vTop + over; }
    }
    PXCM = Math.min(availW / displayW, availH / displayH);
    if (!isFinite(PXCM) || PXCM <= 0) PXCM = 1;
    /* Les cartels passent sous les cadres : s'il n'y a pas leur place sur le mur,
       le mur s'allonge vers le bas d'autant, pour qu'ils restent dessus même quand
       c'est la largeur qui borne ; il ne rétrécit que si le mur allongé ne tient
       plus dans la hauteur. */
    var need = capShortfall(H);
    if (need > 0) {
      PXCM = Math.min(PXCM, Math.max(40, availH - CAP_GAP - CAP_H) / capLow());
      if (!isFinite(PXCM) || PXCM <= 0) PXCM = 1;
      need = capShortfall(H);
    }
    var extra = need > 0 ? Math.ceil(need) : 0;
    shell.style.marginBottom = '';
    canvas.style.width = Math.round(W * PXCM) + 'px';
    canvas.style.height = Math.round(H * PXCM + extra) + 'px';
    shell.style.width = Math.round(displayW * PXCM) + 'px';
    shell.style.height = Math.round(displayH * PXCM + extra) + 'px';
    canvas.style.transformOrigin = 'top left';
    canvas.style.transform = state.rotated
      ? 'translateX(' + Math.round(H * PXCM) + 'px) rotate(90deg)'
      : 'none';
    /* v4 (21/10, Max : « il y a deux fonds ») : un seul fond. En « Centré », le mur
       n'est plus dessiné : la couleur choisie teinte toute la scène et les cadres
       flottent dessus ; sans couleur, ils flottent sur la page. « Mon mur » garde
       son mur, à ses cotes. */
    var floating = state.scale !== 'real';
    var tint = floating && wallHex() !== '#ffffff' ? wallHex() : '';
    /* c28 (Max, 28/10 : « quand on arrive sur un mur uni, gris […] notre gris qui traîne un peu de partout ») :
       tant que le visiteur n'a pas choisi sa couleur, le mur uni prend le gris de la page (celui d'« Autre
       suggestion », 6 % d'encre sur blanc). En sombre et chocolat, le fond du thème reste. */
    if (!tint && floating && !state.wallColorSet && !document.documentElement.classList.contains('br-sombre')) tint = '#f1f1f1';
    canvas.classList.toggle('is-float', floating);
    canvas.classList.toggle('is-sketch', !floating);
    canvas.style.background = '';
    renderSketch(canvas, floating ? null : sketchDims(W, H));
    /* la scène, et le bloc qui la porte : sans lui, sa marge restait blanche autour */
    stage.style.backgroundColor = tint;
    if (stage.parentElement) stage.parentElement.style.backgroundColor = tint;
    root.classList.toggle('cac-teinte', !!tint);
    canvas.classList.toggle('is-white', wallHex() === '#ffffff' && state.scale !== 'real');
    snapShell(shell, minTop);
  }
  /* 27/10 : la scène, centrée, tombait souvent sur un demi-pixel (x 467,5) ; les
     traits du mur s'y étalaient sur deux pixels gris. On la décale de moins d'un
     pixel de l'écran pour que ses bords tombent juste. */
  function snapShell(shell, minTop) {
    shell.style.translate = '';
    var r = shell.getBoundingClientRect(), k = window.devicePixelRatio || 1;
    var top = Math.max(r.top, minTop);
    var dx = Math.round(r.left * k) / k - r.left, dy = Math.round(top * k) / k - r.top;
    if (Math.abs(dx) > .01 || Math.abs(dy) > .01) shell.style.translate = dx.toFixed(3) + 'px ' + dy.toFixed(3) + 'px';
  }
  function clampFrame(f) {
    var o = catById[f.id].orient, d = dimsCm(f.fmt, o), r = regionDims();
    f.x = Math.max(0, Math.min(f.x, r[0] - d[0]));
    f.y = Math.max(0, Math.min(f.y, r[1] - d[1]));
  }

  /* ---------- layout aligné ---------- */
  function sizes() { return state.frames.map(function (f) { return dimsCm(f.fmt, catById[f.id].orient); }); }
  function ghostRects() {
    return state.ghosts || [];
  }
  function layoutAuto() {
    var n = state.frames.length, gap = currentGap(), M = CFG.margin;
    var S = sizes();
    /* Plus de place vide à côté des cadres (« un gros + qui gâche tout ») : ajouter
       passe par les petits « + » hors du mur. Une seule place, quand le mur est vide. */
    var pending = n ? 0 : 1;
    var ghostSize = n ? S[S.length - 1].slice() : GHOST.slice();
    var all = S.slice();
    for (var gi = 0; gi < pending; gi++) all.push(ghostSize.slice());
    if (!all.length) all.push(GHOST.slice());
    var totW = all.reduce(function (s, d) { return s + d[0]; }, 0) + gap * (all.length - 1);
    var totH = Math.max.apply(null, all.map(function (d) { return d[1]; }));
    /* v4 (21/10, Max : « ça peut rester flottant ») : en « Centré », plus de mur
       dessiné ; les cadres flottent. La marge (CFG.margin, 5 cm) ne garde que
       l'ombre des cadres, et la hauteur d'une place A3 (GHOST) ne vaut plus que
       pour le mur vide : elle faisait flotter une rangée d'A4 dans un mur trop
       haut, et rapetissait tout. */
    var minH = n ? 0 : GHOST[1];
    var rowTop = M + (Math.max(totH, minH) - totH) / 2;
    /* L'alignement vertical : centré par défaut, ou tous les bords hauts sur la
       même ligne, ou tous les bords bas. C'est un choix de composition réel —
       une rangée alignée par le haut n'a pas le même caractère qu'une rangée
       centrée — et il vaut pour les places vides comme pour les cadres. */
    function alignY(h) {
      if (state.align === 'top') return rowTop;
      if (state.align === 'bottom') return rowTop + (totH - h);
      return rowTop + (totH - h) / 2;
    }
    var x = M;
    state.frames.forEach(function (f, i) { f.x = x; f.y = alignY(S[i][1]); x += S[i][0] + gap; });
    state.ghosts = [];
    for (var j = 0; j < pending; j++) {
      state.ghosts.push({ x: x, y: alignY(ghostSize[1]), w: ghostSize[0], h: ghostSize[1] });
      x += ghostSize[0] + gap;
    }
    state.region = { w: totW + 2 * M, h: Math.max(totH, minH) + 2 * M };
  }
  function layoutReal() {
    state.ghosts = [];
    var n = state.frames.length; if (!n) return;
    var S = sizes(), W = state.wall.w, H = state.wall.h, gap = currentGap();
    var hangTop = Math.max(0, H - (state.hang || CFG.hangLine));
    var avail = Math.max(40, W - 4);
    var rows = [], cur = [], curW = 0;
    for (var i = 0; i < n; i++) {
      var w = S[i][0], add = (cur.length ? gap : 0) + w;
      if (cur.length && curW + add > avail) { rows.push(cur); cur = []; curW = 0; }
      cur.push(i); curW += (cur.length > 1 ? gap : 0) + w;
    }
    if (cur.length) rows.push(cur);
    var rowH = rows.map(function (r) { return Math.max.apply(null, r.map(function (i) { return S[i][1]; })); });
    var rowGap = Math.max(gap, 10);
    var totalH = rowH.reduce(function (a, b) { return a + b; }, 0) + rowGap * (rows.length - 1);
    var y = Math.max(2, hangTop - totalH / 2);
    if (y + totalH > H - 2) y = Math.max(2, H - 2 - totalH);
    rows.forEach(function (row, ri) {
      var rW = row.reduce(function (s, i) { return s + S[i][0]; }, 0) + gap * (row.length - 1);
      var x = Math.max(2, (W - rW) / 2);
      row.forEach(function (i) {
        var f = state.frames[i];
        var dy = state.align === 'top' ? 0 : state.align === 'bottom' ? (rowH[ri] - S[i][1]) : (rowH[ri] - S[i][1]) / 2;
        f.x = x; f.y = y + dy; x += S[i][0] + gap;
      });
      y += rowH[ri] + rowGap;
    });
    /* Quand la composition est plus haute ou plus large que le mur, les rangees
       continuaient au-dela du mur : a l'ecran les cadres passaient par-dessus le
       texte et les boutons de la page, et le plan imprimait des cotes
       impossibles — clou a -45 cm du sol sur un mur de 80 x 200, a -185 cm sur
       un mur de 60 x 60. On ramene chaque cadre dans le mur. La composition se
       chevauche alors visiblement, ce qui dit la verite au visiteur, et chaque
       cote imprimee reste percable. Sur un mur ou tout tient, sans effet. */
    state.frames.forEach(clampFrame);
  }
  function relayout() { if (state.scale === 'real') layoutReal(); else layoutAuto(); }
  function reorderFromPositions() {
    var items = state.frames.map(function (f) {
      var w = dimsCm(f.fmt, catById[f.id].orient)[0];
      return { f: f, cx: f.x + w / 2 };
    });
    items.sort(function (a, b) { return a.cx - b.cx; });
    state.frames = items.map(function (it) { return it.f; });
  }

  /* ---------- render ---------- */
  /* La place d'un cartel (reprise v3, 21/10). Centré sous son cadre, il s'arrête à
     mi-chemin du cartel voisin et au bord d'un cadre voisin qui descend à sa
     hauteur ; dessous, au cadre de la rangée suivante (« Mon mur » : l'écart entre
     rangées est une vraie cote du plan, il ne bouge pas) et, sur « Mon mur », au
     bas du mur. Rend la largeur permise en px et les lignes : 2 (titre et
     artiste), 1 (le titre seul) ou 0 (pas de cartel : le panneau garde son lien
     et « Voir le tirage »). */
  var CAP_LINE = 16, CAP_PAD = 3, CAP_MIN2 = 64, CAP_MIN1 = 44;
  function capFit(f) {
    var P = PXCM, d = dimsCm(f.fmt, catById[f.id].orient), r = regionDims();
    var cx = (f.x + d[0] / 2) * P, top = (f.y + d[1]) * P + CAP_GAP;
    for (var lines = 2; lines > 0; lines--) {
      var bot = top + (lines > 1 ? CAP_H : CAP_LINE);
      if (state.scale === 'real' && bot > r[1] * P) continue;
      var L = 0, R = r[0] * P, ok = true;
      state.frames.forEach(function (g) {
        if (g === f) return;
        var e = dimsCm(g.fmt, catById[g.id].orient);
        var x0 = g.x * P, x1 = (g.x + e[0]) * P, gcx = (x0 + x1) / 2, gtop = (g.y + e[1]) * P + CAP_GAP;
        if (g.y * P < bot && gtop - CAP_GAP > top) {
          if (x1 <= cx) L = Math.max(L, x1 + CAP_PAD);
          else if (x0 >= cx) R = Math.min(R, x0 - CAP_PAD);
          else ok = false;
        }
        if (gtop < bot && gtop + CAP_H > top) {
          if (Math.abs(gcx - cx) < 1) ok = false;
          else if (gcx < cx) L = Math.max(L, (gcx + cx + CAP_PAD) / 2);
          else R = Math.min(R, (gcx + cx - CAP_PAD) / 2);
        }
      });
      var w = ok ? Math.min(2 * Math.min(cx - L, R - cx), Math.max(70, (d[0] + currentGap()) * P)) : 0;
      if (w >= (lines > 1 ? CAP_MIN2 : CAP_MIN1)) return { w: w, lines: lines };
    }
    return { w: 0, lines: 0 };
  }
  function renderFrames() {
    var wrap = $('#brpFrames'); wrap.innerHTML = '';
    state.frames.forEach(function (f) {
      var c = catById[f.id], d2 = dimsCm(f.fmt, c.orient);
      var d = el('div', 'br-frame' + (state.sel === f.uid ? ' sel' : ''));
      d.style.width = (d2[0] * PXCM) + 'px'; d.style.height = (d2[1] * PXCM) + 'px';
      if (PG) { d.style.transformOrigin = '0 0'; d.style.transform = pieceMatrix(f.x, f.y, d2[0], d2[1], pieceKey(f)); }
      else d.style.transform = 'translate(' + (f.x * PXCM) + 'px,' + (f.y * PXCM) + 'px)';
      d.dataset.uid = f.uid;
      var img = new Image();
      /* v6 (22/10) : le cadre est le sujet de la page, il passe avant tout le reste */
      img.fetchPriority = 'high';
      img.src = imgUrl(imgOf(f), 720); img.alt = c.title;
      /* La boîte est aux vraies cotes du cadre : 30x40, 40x50, 50x70. Le mockup,
         lui, vit sur une toile 4:5 où le cadre est centré et n'occupe qu'une
         fraction connue de la surface — mesurée et constante, cf. CFG.mockup.
         On dimensionne donc la toile pour que le CADRE coïncide avec la boîte :
         la marge transparente et l'ombre débordent proprement à l'extérieur.
         Avant ce calcul, 'contain' calait l'IMAGE sur la boîte, et le cadre y
         flottait de 13 à 21 % selon le format — pas du même montant d'un format
         à l'autre. L'écart vu entre deux cadres n'était donc ni l'écart réglé ni
         celui du plan d'accrochage, qui lui a toujours été juste.
         Le ratio du cadre mesuré dans le mockup s'écarte de 1 % du ratio réel :
         caler les deux axes sur la boîte étire l'image d'autant. C'est le bon
         arbitrage — 1 % sur une photo est invisible, 15 % sur une cote ne l'est
         pas. */
      var fill = mockupFill(f.fmt, c.orient);
      img.style.position = 'absolute';
      img.style.width = (100 / fill[0]).toFixed(3) + '%';
      img.style.height = (100 / fill[1]).toFixed(3) + '%';
      img.style.left = (50 - 50 / fill[0]).toFixed(3) + '%';
      img.style.top = (50 - 50 / fill[1]).toFixed(3) + '%';
      img.decoding = 'async'; img.draggable = false;
      d.appendChild(img);
      /* 26/10 (Max) : au survol d'un cadre, « Voir le tirage » ouvre sa fiche
         dans un nouvel onglet. Ordinateur seulement (CSS, 1 100 px et souris) ;
         le lien garde son geste pour lui : il ne prend ni ne glisse le cadre. */
      var vUrl = ficheUrl(f);
      if (vUrl) {
        /* cadre étroit (5 cadres à 1 440 px) : la pastille, plus large que lui,
           couvrait son bas et prenait le clic du réglage ; elle n'y garde que sa flèche */
        var v = el('a', 'br-frame-view' + (d2[0] * PXCM < 150 ? ' br-frame-view--mini' : ''));
        v.href = vUrl; v.target = '_blank'; v.rel = 'noopener';
        var vTxt = $('#brpPopView');
        v.textContent = (vTxt && vTxt.textContent.trim()) || t('view', 'Voir le tirage');
        v.title = v.textContent;
        v.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
        v.addEventListener('click', function (e) { e.stopPropagation(); keepForBack(); });
        d.appendChild(v);
      }
      d.addEventListener('pointerdown', onPointerDown);
      d.addEventListener('click', function () {
        if (window.innerWidth < 900 && state.previewMode === 'large') {
          state.sel = f.uid;
          refreshStage();
        }
      });
      wrap.appendChild(d);
      /* Le cartel (v3, 21/10 — Max : « on peut pas voir le tirage et cliquer dessus
         pour aller direct dessus ») : le titre et l'artiste sous le cadre, comme au
         mur d'une galerie ; c'est un lien vers la fiche. Le mur est gardé pour le
         retour (voir keepForBack). */
      var room = !state.rotated && c.url && !PG ? capFit(f) : null;
      if (room && room.lines) {
        var cap = el('a', 'br-frame-cap');
        cap.href = ficheUrl(f);
        /* 23/10 (Max) : la fiche s'ouvre à côté, la composition reste ouverte ici */
        cap.target = '_blank'; cap.rel = 'noopener';
        cap.dataset.uid = f.uid;
        cap.style.left = ((f.x + d2[0] / 2) * PXCM) + 'px';
        cap.style.top = ((f.y + d2[1]) * PXCM + CAP_GAP) + 'px';
        cap.style.maxWidth = Math.floor(room.w) + 'px';
        cap.innerHTML = '<b>' + esc(c.title) + '</b>' + (c.artist && room.lines > 1 ? '<span>' + esc(c.artist) + '</span>' : '');
        cap.addEventListener('click', keepForBack);
        wrap.appendChild(cap);
      }
    });
    ghostRects().forEach(function (g) {
      var d = el('button', 'br-ghost');
      d.type = 'button';
      d.style.width = (g.w * PXCM) + 'px'; d.style.height = (g.h * PXCM) + 'px';
      if (PG) { d.style.transformOrigin = '0 0'; d.style.transform = pieceMatrix(g.x, g.y, g.w, g.h, ''); }
      else d.style.transform = 'translate(' + (g.x * PXCM) + 'px,' + (g.y * PXCM) + 'px)';
      /* La place vide portait un « + » muet. Elle dit maintenant ce qu'elle
         attend — c'est la moitié de la consigne, posée là où on clique. */
      d.innerHTML = '<span>+</span><i>' + esc(t('ghost_add', 'Ajouter')) + '</i>';
      d.title = t('ghost_add_title', 'Ajouter un tirage');
      d.addEventListener('click', function () { openPicker('new'); });
      wrap.appendChild(d);
    });
    renderRoom();
    renderSideAdds();
    renderWhy();
    $('#brpTitle').textContent = compoName();
    renderPop();
  }

  /* ---------- un seul petit « + », à droite du dernier tirage ----------
     (20/10, R3 de Max : « il n'y en a qu'un seul de plus ») Il dit qu'on peut
     ajouter un tirage, là où le suivant arrivera, sans poser de place vide sur le
     mur. Il est centré sur la hauteur du dernier cadre : aligné sur les tirages,
     quels que soient l'alignement, le format ou l'affichage (Centré, Mon mur). */
  function sideAddsOn() {
    var n = state.frames.length;
    return n > 0 && n < CFG.maxFrames && !state.rotated;
  }
  function sideAddSpace() { return window.innerWidth < 750 ? 30 : 50; }
  function renderSideAdds() {
    var shell = $('#brpCanvasShell'), b = shell && shell.querySelector('.brp-side-add');
    if (!b) return;
    /* en pièce, trop large : pas de « + » (il couvrait le dernier cadre) */
    var on = sideAddsOn() && !(PG && PG.pl.wide);
    b.hidden = !on;
    if (!on) return;
    var f = state.frames[state.frames.length - 1], d = dimsCm(f.fmt, catById[f.id].orient);
    if (PG) {
      var qq = pieceQuad(pieceWall(f.x, f.y, d[0], d[1], pieceKey(f)), d), bs = b.offsetWidth || 32;
      b.style.left = Math.round(Math.min(PG.w - bs - 4, qq[1][0] + Math.max(8, currentGap() * PXCM / 2))) + 'px';
      b.style.right = 'auto';
      b.style.top = Math.round((qq[1][1] + qq[2][1]) / 2) + 'px';
      return;
    }
    var right = (f.x + d[0]) * PXCM, size = b.offsetWidth || 32;
    var room = shell.clientWidth - right;
    /* Sur le mur, au milieu de ce qui reste à droite du dernier cadre (jamais plus
       loin qu'un écart entre cadres) ; s'il n'y a pas la place, juste au bord du mur */
    /* À l'ordinateur, de l'air autour du « + » (Max, 26/10 : « trop collé ») ;
       à côté des petits cadres d'un grand mur (27/10), l'air suit leur taille,
       sans quoi le rond semblait détaché d'eux */
    var air = window.innerWidth >= 1100 ? Math.round(Math.max(24, Math.min(44, d[1] * PXCM * .45))) : 10;
    var left = room >= size + air ? right + Math.min((room - size) / 2, Math.max(air, currentGap() * PXCM)) : right + room + 6;
    b.style.left = Math.round(left) + 'px';
    b.style.right = 'auto';
    b.style.top = Math.round((f.y + d[1] / 2) * PXCM) + 'px';
  }
  function buildSideAdds() {
    var shell = $('#brpCanvasShell');
    if (!shell || shell.querySelector('.brp-side-add')) return;
    var label = t('ghost_add_title', 'Ajouter un tirage');
    var b = el('button', 'brp-side-add brp-side-add--right');
    b.type = 'button';
    b.setAttribute('aria-label', label);
    b.title = label;
    b.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 3.5v9M3.5 8h9" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
    b.addEventListener('click', function (e) { e.stopPropagation(); openPicker('new'); });
    shell.appendChild(b);
  }

  /* ---------- « Autre suggestion » (remplace « Au hasard », 16/10/2026) ----------
     Sans hasard : le premier tirage du mur reste, les autres avancent dans l'ordre
     des suggestions de son sens (coups de cœur, vus récemment, duos de l'équipe,
     catalogue), sans tirage du panier ; au bout de la liste, on repart du début.
     « Annuler » remet le mur d'avant pendant quelques secondes. */
  var undoFrames = null, undoTimer = null;
  /* « Proposer un autre » (28/10) : le texte et l'icône du bouton de la fiche tirage
     (bisou-duo.js, table L26S) ; pas de clé dans locales/ pour ce lot */
  var OTHER_TXT = ({ fr: 'Proposer un autre', en: 'Suggest another', es: 'Otra sugerencia', ja: '別のおすすめを見る' })[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || 'Suggest another';
  var ANOTHER = '<svg viewBox="0 0 20 20" aria-hidden="true"><rect x="2.5" y="6.5" width="9" height="11" rx="1" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M7.5 3.5h9a1 1 0 0 1 1 1v10" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><path d="M15.5 12.5l2 2 2-2" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function buildSuggest() {
    var stage = $('#brpStage');
    if (!stage || $('#brpNextSuggestion')) return;
    var box = el('div', 'brp-luck');
    var b = el('button', 'brp-luck__btn');
    b.type = 'button'; b.id = 'brpNextSuggestion';
    b.title = t('suggest_next_title', 'Changer les tirages proposés, dans le même sens');
    /* 23/10 (Max : « pas de logo shuffle ») : le mot, puis une flèche fine */
    /* 27/10 (Max : « on dirait qu'on va changer de page ») : à l'ordinateur, deux
       flèches en cercle avant le mot (pas le logo shuffle refusé le 23/10), qui
       tournent quand la composition change ; la flèche vers la droite s'efface. */
    /* 28/10 (Max : « autre suggestion, c'est mieux de mettre proposer un autre ») : le mot et
       l'icône du bouton de la fiche tirage (deux cadres qui se relaient, bisou-duo.js) */
    b.innerHTML = ANOTHER.replace('<svg ', '<svg class="brp-luck__turn" ') +
      '<span>' + esc(OTHER_TXT) + '</span><svg class="brp-luck__arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 7l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    b.addEventListener('click', function (e) { e.stopPropagation(); nextSuggestion(); });
    var u = el('button', 'brp-luck__undo');
    u.type = 'button'; u.id = 'brpShuffleUndo'; u.hidden = true;
    u.textContent = t('shuffle_undo', 'Annuler');
    u.addEventListener('click', function (e) { e.stopPropagation(); undoShuffle(); });
    box.appendChild(b); box.appendChild(u);
    stage.appendChild(box);
    /* Pourquoi ces tirages (20/10, R3 de Max) : une ligne sous le mur */
    var why = el('p', 'brp-why');
    why.id = 'brpWhy'; why.hidden = true;
    why.setAttribute('aria-live', 'polite');
    /* 23/10 (Max : « un seul info suffit ») : plus de « Pourquoi », une seule raison */
    why.innerHTML = '<span class="brp-why__v"></span>';
    var vp = $('#brpViewport');
    if (vp && vp.parentNode === stage) stage.insertBefore(why, vp.nextSibling); else stage.appendChild(why);
  }
  /* La raison de chaque tirage posé à côté du premier : celle du calcul
     d'Associez-le (window.BisouAccords, chargé par bisou-duo.js) ; sans lui, les
     mêmes règles de base. Les raisons se suivent sans doublon. */
  function renderWhy() {
    var p = $('#brpWhy');
    if (!p) return;
    var first = state.frames[0], ref = first && catById[first.id], seen = {}, out = [];
    if (ref) {
      var sig = signals(ref);
      state.frames.slice(1).forEach(function (f) {
        var w = whyFor(ref, catById[f.id], sig);
        if (w && !seen[w]) { seen[w] = true; out.push(w); }
      });
    }
    p.hidden = !out.length;
    /* Réécrite seulement si elle change : la ligne est annoncée aux lecteurs d'écran */
    var v = p.querySelector('.brp-why__v'), txt = bestWhy(out);
    if (v.textContent !== txt) v.textContent = txt;
  }
  /* La raison la plus personnelle l'emporte : ce que le visiteur a aimé, puis ce
     qu'il a regardé, puis l'accord des couleurs, puis la première venue. */
  function bestWhy(list) {
    var wish = t('suggest_why_wish', 'Dans vos coups de cœur'), recent = t('suggest_why_recent', 'Vu récemment');
    var order = [function (x) { return x === wish || /c(oe|œ)ur|favou?rite/i.test(x); },
      function (x) { return x === recent || /vu récemment|recently/i.test(x); },
      function (x) { return /couleur|colou?r/i.test(x); }];
    for (var i = 0; i < order.length; i++) {
      for (var j = 0; j < list.length; j++) if (order[i](list[j])) return list[j];
    }
    return list[0] || '';
  }
  /* 27/10 (Max : « Autre suggestion donne toujours pas envie ») : à l'ordinateur,
     les cadres s'effacent, les suivants entrent l'un après l'autre et les titres
     de la nouvelle composition passent au milieu du mur, comme « Proposer un
     autre » de la fiche. Au téléphone et en mouvement réduit : le changement
     d'avant, immédiat. (bisou-planner.css, bloc « a26-cac-achat ») */
  var swapT = 0, compoT = 0;
  function nextSuggestion() {
    var mm = window.matchMedia;
    var big = !!(mm && mm('(min-width: 1100px)').matches);
    var fx = big && !mm('(prefers-reduced-motion: reduce)').matches;
    var wrap = $('#brpFrames'), btn = $('#brpNextSuggestion');
    if (btn && fx) { btn.classList.remove('is-turn'); void btn.offsetWidth; btn.classList.add('is-turn'); }
    if (!fx || !wrap || !state.frames.length) { applySuggestion(); if (big) showCompo(); return; }
    if (wrap.classList.contains('brp-swap-out')) return;
    /* Le premier tirage reste au mur : lui ne bouge pas, seuls les autres changent */
    var keep = state.frames[0].uid;
    var mark = function () { Array.prototype.forEach.call(wrap.querySelectorAll('[data-uid="' + keep + '"]'), function (n) { n.classList.add('brp-reste'); }); };
    mark();
    wrap.classList.remove('brp-swap-in'); wrap.classList.add('brp-swap-out');
    setTimeout(function () {
      wrap.classList.remove('brp-swap-out');
      applySuggestion();
      mark();
      Array.prototype.forEach.call(wrap.querySelectorAll('.br-frame:not(.brp-reste)'), function (n, i) { n.style.animationDelay = (i * 80) + 'ms'; });
      wrap.classList.add('brp-swap-in');
      clearTimeout(swapT); swapT = setTimeout(function () { wrap.classList.remove('brp-swap-in'); }, 1100);
      showCompo();
    }, 190);
  }
  /* Les titres et les artistes du mur, au milieu de la scène, puis ils s'effacent */
  function showCompo() {
    var stage = $('#brpStage');
    if (!stage || !state.frames.length) return;
    var box = $('#brpCompo');
    if (!box) { box = el('p', 'brp-compo'); box.id = 'brpCompo'; box.setAttribute('aria-live', 'polite'); stage.appendChild(box); }
    var titles = [], who = [];
    state.frames.forEach(function (f) {
      var c = catById[f.id]; if (!c) return;
      titles.push(c.title);
      if (c.artist && who.indexOf(c.artist) < 0) who.push(c.artist);
    });
    box.innerHTML = '<b>' + titles.map(esc).join('<i aria-hidden="true"> · </i>') + '</b>' + (who.length ? '<span>' + who.map(esc).join(', ') + '</span>' : '');
    box.classList.remove('is-on'); void box.offsetWidth; box.classList.add('is-on');
    clearTimeout(compoT); compoT = setTimeout(function () { box.classList.remove('is-on'); }, 2600);
  }
  function applySuggestion() {
    var n = Math.max(2, state.frames.length);
    var first = state.frames[0];
    var picks;
    if (first) {
      /* Les suivants dans la liste, après le dernier tirage proposé déjà au mur */
      var list = suggestions(catById[first.id]), last = -1;
      state.frames.slice(1).forEach(function (f) { last = Math.max(last, list.indexOf(catById[f.id])); });
      picks = [];
      for (var i = 1; i <= list.length && picks.length < n - 1; i++) picks.push(list[(last + i) % list.length]);
      if (!picks.length) return;
    } else {
      picks = firstPair();
      if (!picks.length) return;
    }
    undoFrames = state.frames.map(function (f) { return { uid: f.uid, id: f.id, fmt: f.fmt, frame: f.frame, x: f.x, y: f.y }; });
    if (first) {
      state.frames = [first];
      /* 23/10 (Max) : la taille et le cadre réglés par le visiteur restent à leur
         place ; un tirage d'un autre sens reprend la hauteur de son voisin. */
      picks.forEach(function (c, j) {
        var was = undoFrames[j + 1], wc = was && catById[was.id];
        pushFrame(c, wc && sameSense(wc.orient, c.orient) ? was.fmt : null, (was && was.frame) || first.frame, 'right');
      });
    } else {
      state.frames = [];
      picks.forEach(function (c, j) { pushFrame(c, j === 0 ? 'A3' : null, 'noir', 'right'); });
    }
    state.sel = null;
    state.touched = true;
    state.targetCount = state.frames.length;
    relayout(); renderAll();
    var u = $('#brpShuffleUndo');
    if (u) {
      u.hidden = false;
      clearTimeout(undoTimer);
      undoTimer = setTimeout(function () { u.hidden = true; undoFrames = null; }, 7000);
    }
  }
  function undoShuffle() {
    if (!undoFrames) return;
    state.frames = undoFrames; undoFrames = null;
    state.targetCount = state.frames.length;
    state.sel = null;
    var u = $('#brpShuffleUndo'); if (u) u.hidden = true;
    relayout(); renderAll();
  }
  /* Pose un tirage sur le mur. Le format suit la hauteur du voisin (comme avant) ;
     fmt impose un format quand il existe pour ce tirage ; frame, une finition. */
  function pushFrame(c, fmt, frame, where) {
    var ref = where === 'left' ? state.frames[0] : state.frames[state.frames.length - 1];
    var f2 = fmt && fmtsAvail(c.id).indexOf(fmt) > -1 ? fmt
      : (ref ? matchFormat(c.id, c.orient, dimsCm(ref.fmt, catById[ref.id].orient)[1]) : (c.fmts.indexOf('A3') > -1 ? 'A3' : c.fmts[0]));
    var fr = frame || (ref ? ref.frame : 'noir');
    if (frameAvail(c.id, f2).indexOf(fr) < 0) fr = frameAvail(c.id, f2)[0];
    var nf = { uid: uidSeq++, id: c.id, fmt: f2, frame: fr, x: 0, y: 0 };
    if (where === 'left') state.frames.unshift(nf); else state.frames.push(nf);
    return nf;
  }
  /* Les coups de cœur présents dans le catalogue, du plus récent au plus ancien */
  function wishCat() {
    var seen = {};
    return WL.read().slice().sort(function (a, b) { return (b.at || 0) - (a.at || 0); })
      .map(function (i) { return i && catById[i.h]; })
      .filter(function (c) { if (!c || seen[c.id]) return false; seen[c.id] = true; return true; });
  }
  /* ---------- suggestions (décision de Max, 16/10/2026) ----------
     Jamais de hasard. Toujours le même sens (un carré irait avec les deux ; un sens
     inconnu n'est pas proposé). Jamais un tirage déjà au panier. Ordre : coups de
     cœur, vus récemment, duos de l'équipe, puis le catalogue dans son ordre. */
  /* Les tirages vus récemment (section « Vus récemment », clé bisou-vus), du plus récent au plus ancien */
  function recentCat() {
    var a = [], seen = {};
    try { a = JSON.parse(localStorage.getItem('bisou-vus') || '[]'); } catch (e) { a = []; }
    return (Array.isArray(a) ? a : []).map(function (h) { return typeof h === 'string' ? catById[h] : null; })
      .filter(function (c) { if (!c || seen[c.id]) return false; seen[c.id] = true; return true; });
  }
  /* Duos choisis par l'équipe : BRPlanner.cfg.teamDuos = [[handleA, handleB], …].
     Aucune source de données aujourd'hui : la liste est vide, sa place dans l'ordre est gardée. */
  var TEAM_DUOS = ((BOOT.cfg && BOOT.cfg.teamDuos) || []).filter(Array.isArray);
  /* Les tirages déjà au panier (handle → true) : lus au chargement, relus quand le panier change */
  var CART = {};
  function readCart(done) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (cart) {
        var s = {};
        ((cart && cart.items) || []).forEach(function (i) { if (i && i.handle) s[i.handle] = true; });
        CART = s;
        if (done) done();
      })
      .catch(function () {});
  }
  function sameSense(a, b) { return !!a && !!b && (a === b || a === 'c' || b === 'c'); }
  /* Proposable : sens connu, pas déjà au panier */
  function free(c) { return !!c && !!c.orient && !CART[c.id]; }
  /* Les tirages à proposer, dans l'ordre, sans doublon. Avec un tirage de référence :
     seulement son sens, sans lui, et seulement les duos de l'équipe qui le contiennent. */
  function suggestions(ref) {
    var seen = {}, out = [];
    if (ref) seen[ref.id] = true;
    function add(c) {
      if (!free(c) || seen[c.id] || (ref && !sameSense(ref.orient, c.orient))) return;
      seen[c.id] = true; out.push(c);
    }
    wishCat().forEach(add);
    recentCat().forEach(add);
    TEAM_DUOS.forEach(function (d) {
      if (!ref || d.indexOf(ref.id) > -1) d.forEach(function (h) { add(catById[h]); });
    });
    CAT.forEach(add);
    /* Le calcul d'Associez-le, s'il est chargé, classe ces tirages (goûts, équipe,
       ambiance, couleurs) ; à égalité de points, l'ordre ci-dessus reste */
    var r = ref && ranked(ref, out, signals(ref));
    if (r) out = r.map(function (x) { return catById[x.handle]; }).filter(Boolean);
    return out;
  }
  /* ---------- le calcul d'Associez-le (20/10) ----------
     window.BisouAccords.classer(principal, candidats, signaux) : mêmes points et
     mêmes raisons que sur la fiche. Les tirages du mur lui sont passés comme des
     produits (handle, balises). */
  function asProduct(c) { return { handle: c.id, tags: c.tags || [] }; }
  function signals(ref) {
    var wish = wishCat(), team = [];
    TEAM_DUOS.forEach(function (d) { if (d.indexOf(ref.id) > -1) d.forEach(function (h) { if (h !== ref.id) team.push(h); }); });
    return {
      wish: wish.map(function (c) { return c.id; }),
      recent: recentCat().map(function (c) { return c.id; }),
      team: team,
      gouts: wish.map(asProduct)
    };
  }
  function ranked(ref, list, sig) {
    var A = window.BisouAccords;
    if (!ref || !A || typeof A.classer !== 'function') return null;
    try { return A.classer(asProduct(ref), list.map(asProduct), sig); } catch (e) { return null; }
  }
  /* « Même format, même finition » (la raison de base de la fiche) n'est pas vraie
     sur le mur : la raison de base y est le sens, quand il est le même */
  function whyFor(ref, c, sig) {
    if (!c) return '';
    var base = sameSense(ref.orient, c.orient) ? t('suggest_why_base', 'Même sens que votre tirage') : '';
    var r = ranked(ref, [c], sig);
    /* La raison vient de bisou-duo.js, écrite en français : sa clé passe par le pont lang */
    if (r && r[0]) return r[0].raison === 'base' ? base : t('suggest_why_' + r[0].raison, r[0].texte);
    if (sig.wish.indexOf(c.id) > -1) return t('suggest_why_wish', 'Dans vos coups de cœur');
    if (sig.team.indexOf(c.id) > -1) return t('suggest_why_team', 'Choisi par l’équipe');
    if (sig.recent.indexOf(c.id) > -1) return t('suggest_why_recent', 'Vu récemment');
    return base;
  }
  /* La première paire du même sens : a dans A, b dans B, dans l'ordre des listes */
  function pairFrom(A, B) {
    for (var i = 0; i < A.length; i++) {
      for (var j = 0; j < B.length; j++) {
        if (A[i] !== B[j] && sameSense(A[i].orient, B[j].orient)) return [A[i], B[j]];
      }
    }
    return null;
  }
  /* Le diptyque proposé : deux coups de cœur du même sens, sinon un coup de cœur et
     un tirage vu récemment, sinon deux tirages vus, sinon un duo de l'équipe, sinon
     les premiers tirages du même sens dans l'ordre des suggestions. */
  function firstPair() {
    var wish = wishCat().filter(free), recent = recentCat().filter(free), team = null;
    TEAM_DUOS.some(function (d) {
      var a = catById[d[0]], b = catById[d[1]];
      if (free(a) && free(b) && a !== b && sameSense(a.orient, b.orient)) team = [a, b];
      return !!team;
    });
    var all = suggestions(null);
    return pairFrom(wish, wish) || pairFrom(wish, recent) || pairFrom(recent, recent) || team || pairFrom(all, all) || all.slice(0, 1);
  }
  /* Un compagnon pour c : le premier tirage proposé de son sens */
  function companionFor(c, exclude) {
    exclude = exclude || {};
    return suggestions(c).filter(function (s) { return !exclude[s.id]; })[0] || null;
  }
  /* Le diptyque de départ suit le même ordre (16/10) */
  function seedDiptych() {
    state.frames = [];
    firstPair().forEach(function (c) { pushFrame(c, null, null, 'right'); });
  }

  /* Les formats et les finitions disponibles pour un cadre. Le popover
     flottant et le panneau de droite affichent exactement la même chose : une
     seule source, deux emplacements. */
  function frameControlsHTML(f) {
    var fmts = fmtsAvail(f.id).map(function (k) {
      return '<button type="button" data-fmt="' + k + '" class="' + (f.fmt === k ? 'on' : '') + '">' + k + '</button>';
    }).join('');
    var avail = frameAvail(f.id, f.fmt);
    var frames = CFG.frames.map(function (fr) {
      return '<button type="button" class="br-dot ' + (f.frame === fr.key ? 'on' : '') + '" data-frame="' + fr.key + '" ' +
        (avail.indexOf(fr.key) > -1 ? '' : 'disabled') + ' title="' + esc(fr.label) + '" aria-label="' + esc(fr.label) + '" style="background:' + fr.sw + '"></button>';
    }).join('');
    return { fmts: fmts, frames: frames };
  }

  /* Le popover est le seul éditeur du cadre cliqué : il se pose sous le cadre,
     à la Apple — contextuel, discret, il disparaît quand on clique ailleurs.
     Quand rien n'est sélectionné, une ligne sous le mur dit le geste. */
  /* L'éditeur du cadre vit dans le dock, sous le mur, toujours au même
     endroit. Il porte d'abord le cartel — le nom de l'œuvre, puis l'artiste
     avec sa photo en cercle — et seulement ensuite les réglages : on sait ce
     qu'on modifie avant de le modifier. */
  function renderPop() {
    var pop = $('#brpPop');
    var f = null;
    for (var i = 0; i < state.frames.length; i++) if (state.frames[i].uid === state.sel) f = state.frames[i];
    var hint = $('#brpSelHint');
    var showPop = !!f && !state.rotated;
    if (hint) hint.hidden = showPop;
    if (!pop) return;
    if (!showPop) { pop.hidden = true; return; }
    /* Le panneau dit le format du tirage (30 × 40…), pas la cote du cadre */
    var c = catById[f.id], p = CFG.print[f.fmt] || CFG.dims[f.fmt], d = c.orient === 'h' ? [p[1], p[0]] : [p[0], p[1]];
    var ctl2 = frameControlsHTML(f);
    $('#brpPopFmt').innerHTML = ctl2.fmts;
    $('#brpPopFrames').innerHTML = ctl2.frames;
    /* Le titre mène à la fiche, et « Voir le tirage » le dit en toutes lettres */
    var url = ficheUrl(f);
    $('#brpPopTitle').innerHTML = url ? '<a href="' + esc(url) + '" target="_blank" rel="noopener">' + esc(c.title) + '</a>' : esc(c.title);
    var view = $('#brpPopView');
    if (view) { view.hidden = !url; if (url) { view.href = url; view.target = '_blank'; view.rel = 'noopener'; } }
    var del = $('#brpPopDel');
    if (del) {
      del.disabled = state.frames.length <= 1;
      del.title = del.disabled ? t('remove_last_hint', 'Il faut au moins un tirage — utilisez « Remplacer »') : '';
    }
    var meta = $('#brpPopArtist');
    if (meta) {
      var line = tfill('inspector_meta', '{w} × {h} cm · {price}',
        { w: d[0], h: d[1], price: money(priceOf(f)) });
      var who = '';
      if (c.artist) {
        who = (c.artistPic
          ? '<img class="br-pop__pic" src="' + esc(c.artistPic) + '" alt="" loading="lazy" decoding="async">'
          : '<span class="br-pop__pic br-pop__pic--empty" aria-hidden="true"></span>') +
          '<span class="br-pop__who">' + esc(c.artist) + '</span>';
      }
      meta.innerHTML = who + '<span class="br-pop__meta">' + esc(line) + '</span>';
    }
    /* 28/10 (Max : « à droite de là où il y a Gobi et le titre et l'artiste, avoir un bouton
       en mode proposer un autre ») */
    var idBox = pop.querySelector('.br-pop__id'), oth = $('#brpPopOther');
    if (idBox && !oth) {
      oth = el('button', 'cac-pop-other');
      oth.type = 'button'; oth.id = 'brpPopOther';
      oth.innerHTML = ANOTHER + '<span>' + esc(OTHER_TXT) + '</span>';
      oth.addEventListener('click', function (e) { e.stopPropagation(); proposeOther(); });
      idBox.appendChild(oth);
    }
    if (oth) { oth.hidden = !suggestions(c).some(function (s) { return !onWall(s.id); }); oth.setAttribute('aria-label', OTHER_TXT + ' · ' + c.title); }
    pop.hidden = false;
  }
  /* Le tirage choisi cède sa place au suivant de ses suggestions (son sens, hors mur et hors
     panier), sans repasser par ceux qu'il a déjà proposés ; au bout, on repart du début.
     Format et cadre gardés quand le nouveau tirage les a. */
  var otherSeen = {}, otherT = 0;
  function proposeOther() {
    var f = selFrame(), c = f && catById[f.id];
    if (!c) return;
    /* un second clic pendant le fondu attend la fin du premier */
    var busy = $('#brpPopOther');
    if (busy && busy.getAttribute('aria-busy')) return;
    var seen = otherSeen[f.uid] || (otherSeen[f.uid] = {});
    seen[f.id] = true;
    var list = suggestions(c).filter(function (s) { return !onWall(s.id); });
    var n = list.filter(function (s) { return !seen[s.id]; })[0];
    if (!n) { otherSeen[f.uid] = {}; otherSeen[f.uid][f.id] = true; n = list[0]; }
    if (!n) return;
    var btn = $('#brpPopOther'), uid = f.uid;
    var go = function () {
      f.id = n.id;
      state.touched = true;
      if (fmtsAvail(n.id).indexOf(f.fmt) < 0) f.fmt = fmtsAvail(n.id)[0];
      if (frameAvail(n.id, f.fmt).indexOf(f.frame) < 0) f.frame = frameAvail(n.id, f.fmt)[0];
      relayout(); renderAll();
      var wrap = $('#brpFrames');
      if (wrap) Array.prototype.forEach.call(wrap.querySelectorAll('.cac-part'), function (x) { x.classList.remove('cac-part'); });
      if (wrap) Array.prototype.forEach.call(wrap.querySelectorAll('[data-uid="' + uid + '"]'), function (x) { x.classList.add('cac-entre'); });
      clearTimeout(otherT); otherT = setTimeout(function () {
        if (btn) btn.removeAttribute('aria-busy');
        if (wrap) Array.prototype.forEach.call(wrap.querySelectorAll('.cac-entre'), function (x) { x.classList.remove('cac-entre'); });
      }, 520);
    };
    var mm = window.matchMedia;
    if (mm && mm('(prefers-reduced-motion: reduce)').matches) { go(); return; }
    if (btn) btn.setAttribute('aria-busy', 'true');
    var wrap0 = $('#brpFrames');
    if (wrap0) Array.prototype.forEach.call(wrap0.querySelectorAll('[data-uid="' + uid + '"]'), function (x) { x.classList.add('cac-part'); });
    setTimeout(go, 200);
  }

  /* `hidden` n'existe que sur HTMLElement. Un <svg> hérite d'Element : lui
     poser `.hidden = false` crée une propriété JavaScript sans jamais retirer
     l'attribut, et la règle [hidden]{display:none} continue de s'appliquer.
     On passe donc par l'attribut. */
  function showEl(el, on) {
    if (!el) return;
    if (on) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }
  /* La tige. Elle relie le milieu du bord bas de l'œuvre sélectionnée au haut
     de sa carte de réglages, par un chemin à angles droits : on descend, on se
     décale une fois, on redescend. Quand la carte tombe pile sous l'œuvre, il
     ne reste qu'un trait droit — le chemin se simplifie tout seul.
     Tout est mesuré à l'écran plutôt que recalculé en centimètres : la carte
     est centrée par le flux, sa position ne se déduit d'aucun état. */
  var placeT = 0;
  function renderLeader(again) {
    var svg = $('#brpLeader'), stage = $('#brpStage'), pop = $('#brpPop');
    if (!svg || !stage) return;
    placePop(pop);
    /* la scène finit de se resserrer (dock, cadrage) après ce passage : on
       replace la carte et la tige une fois, quand tout est posé */
    if (!again && window.innerWidth >= 1100) {
      clearTimeout(placeT);
      placeT = setTimeout(function () { renderLeader(true); }, 340);
    }
    var f = selFrame();
    if (!f || state.rotated || !pop || pop.hidden || (drag && drag.moved)) { showEl(svg, false); return; }
    var frameEl = null;
    Array.prototype.forEach.call($$('.br-frame'), function (d) {
      if (+d.dataset.uid === f.uid) frameEl = d;
    });
    if (!frameEl) { showEl(svg, false); return; }
    var sr = stage.getBoundingClientRect();
    var fr = frameEl.getBoundingClientRect();
    var pr = pop.getBoundingClientRect();
    /* La tige part sous le cartel du cadre, pour ne pas barrer son nom */
    var capEl = null;
    Array.prototype.forEach.call($$('.br-frame-cap'), function (a) {
      if (+a.dataset.uid === f.uid) capEl = a;
    });
    var x1 = fr.left + fr.width / 2 - sr.left;
    var y1 = (capEl ? capEl.getBoundingClientRect().bottom + 3 : fr.bottom) - sr.top;
    var x2 = pr.left + pr.width / 2 - sr.left;
    var y2 = pr.top - sr.top;
    if (!(y2 > y1)) { showEl(svg, false); return; }
    svg.setAttribute('width', Math.max(1, Math.round(sr.width)));
    svg.setAttribute('height', Math.max(1, Math.round(sr.height)));
    svg.setAttribute('viewBox', '0 0 ' + Math.max(1, Math.round(sr.width)) + ' ' + Math.max(1, Math.round(sr.height)));
    var d;
    if (Math.abs(x2 - x1) < 2) {
      d = 'M' + x1 + ' ' + y1 + ' L' + x1 + ' ' + y2;
    } else {
      var mid = y1 + (y2 - y1) / 2;
      d = 'M' + x1 + ' ' + y1 + ' L' + x1 + ' ' + mid + ' L' + x2 + ' ' + mid + ' L' + x2 + ' ' + y2;
    }
    svg.innerHTML =
      '<path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.25" ' +
      'stroke-linecap="round" stroke-linejoin="round"/>' +
      '<circle cx="' + x1 + '" cy="' + y1 + '" r="2.5" fill="currentColor"/>';
    showEl(svg, true);
  }

  /* 26/10 (Max) : « la cellule d'info, pas besoin de la coller tout en bas,
     tu peux la remonter un peu » ; « le bloc des détails masque une partie ».
     À l'ordinateur, la carte du cadre choisi quitte le bas de la scène et vient
     se poser à 28 px sous les cartels, en glissant (propriété translate, que
     l'animation d'entrée de la carte ne touche pas). Si elle couvre un cadre
     malgré tout, elle glisse de côté, là où il y a de la place. Rien sous
     1 100 px : le téléphone et l'iPad gardent leur carte. */
  var barHome = null;
  function placePop(pop) {
    if (!pop) return;
    var was = pop.dataset.brpPlace ? pop.dataset.brpPlace.split(',').map(Number) : [0, 0];
    if (window.innerWidth < 1100 || pop.hidden || state.rotated) {
      root.classList.remove('brp-pop-libre');
      if (pop.dataset.brpPlace) { pop.style.translate = ''; delete pop.dataset.brpPlace; }
      return;
    }
    var pr = pop.getBoundingClientRect();
    if (!pr.width) return;
    var top = pr.top - was[1], left = pr.left - was[0];
    var low = -Infinity, boxes = [];
    Array.prototype.forEach.call($$('#brpFrames .br-frame, #brpFrames .br-frame-cap'), function (n) {
      var r = n.getBoundingClientRect();
      if (!r.width) return;
      boxes.push(r);
      if (r.bottom > low) low = r.bottom;
    });
    if (!boxes.length) return;
    var dy = 0, dx = 0, want = low + 28;
    if (want < top) dy = Math.round(want - top);
    var t2 = top + dy, b2 = t2 + pr.height;
    var hit = boxes.some(function (r) { return r.right > left && r.left < left + pr.width && r.bottom > t2 && r.top < b2; });
    if (hit) {
      var stage = $('#brpStage'), sr = stage ? stage.getBoundingClientRect() : null;
      var minL = Infinity, maxR = -Infinity;
      boxes.forEach(function (r) { if (r.bottom > t2 && r.top < b2) { minL = Math.min(minL, r.left); maxR = Math.max(maxR, r.right); } });
      if (sr) {
        var roomR = sr.right - maxR, roomL = minL - sr.left;
        if (roomR >= pr.width + 24 && roomR >= roomL) dx = Math.round(maxR + 24 - left);
        else if (roomL >= pr.width + 24) dx = Math.round(minL - 24 - pr.width - left);
      }
    }
    /* En plein écran, la barre d'achat est posée au milieu, en bas : elle
       couvrait les réglages de la carte. Tant qu'un cadre est réglé, elle
       glisse dans le coin bas droit (CSS, .brp-pop-libre) et la carte se
       décale à gauche s'il le faut. */
    var bar = $('#brpBuyBar'), libre = false;
    if (root.classList.contains('br-fs') && bar && !bar.hidden && bar.offsetWidth) {
      var br = bar.getBoundingClientRect();
      /* sa place d'origine, mesurée tant qu'elle n'a pas glissé */
      if (!root.classList.contains('brp-pop-libre')) barHome = br.left;
      var bl = barHome == null ? br.left : barHome;
      if (t2 + pr.height > br.top - 12 && left + dx < bl + br.width && left + dx + pr.width > bl) {
        libre = true;
        var barL = window.innerWidth - 24 - br.width;
        if (left + dx + pr.width > barL - 16) dx = Math.max(24 - left, Math.round(barL - 16 - pr.width - left));
      }
    }
    root.classList.toggle('brp-pop-libre', libre);
    pop.dataset.brpPlace = dx + ',' + dy;
    pop.style.translate = (dx || dy) ? dx + 'px ' + dy + 'px' : '';
  }

  /* ---------- les calques (29/10) ----------
     Max, 28/10 : « tout à gauche, dans le réglage de la composition, comme des layers :
     layer 1 = cadre 1, layer 2 = cadre 2, comme sur Photoshop ». Une ligne par cadre, dans
     l'ordre du mur (de gauche à droite) : un tirage ajouté se pose à droite et arrive en bas,
     juste au-dessus de « Ajouter un tirage ». Toucher la ligne sélectionne le cadre (le dock
     sous le mur s'ouvre, comme au clic sur le cadre) ; « Remplacer » et « Retirer » sont sur
     la ligne. */
  var LAYER_SWAP = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 8.5h14l-3.5-3.5M19.5 15.5h-14l3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var LAYER_DEL = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  function renderLayers() {
    var box = $('#brpLayers');
    if (!box) {
      var add = $('#brpAdd'); if (!add || !add.parentNode) return;
      box = el('div', 'brp-layers'); box.id = 'brpLayers';
      add.parentNode.insertBefore(box, add);
      box.addEventListener('click', onLayerClick);
      box.addEventListener('pointerover', onLayerHover);
      box.addEventListener('pointerleave', function () { hoverFrame(null); });
    }
    var one = state.frames.length <= 1, rep2 = t('replace', 'Remplacer'), del = t('remove', 'Retirer');
    /* à cinq cadres, « Ajouter un tirage » ne pouvait plus rien ajouter : il laisse sa place aux calques */
    var add2 = $('#brpAdd'); if (add2) add2.hidden = state.frames.length >= CFG.maxFrames;
    box.innerHTML = '<p class="br-lbl brp-layers__t">' + esc(t('layers_title', 'Vos tirages')) + '</p><ul class="brp-layers__list">' +
      state.frames.map(function (f) {
        var c = catById[f.id]; if (!c) return '';
        var on = f.uid === state.sel, ti = esc(c.title || '');
        return '<li class="brp-layer' + (on ? ' is-sel' : '') + '" data-uid="' + f.uid + '">' +
          '<button type="button" class="brp-layer__pick" data-layer-pick="' + f.uid + '" aria-pressed="' + on + '">' +
            '<span class="brp-layer__img"><img src="' + imgUrl(imgOf(f), 120) + '" alt="" loading="lazy" decoding="async" draggable="false"></span>' +
            '<span class="brp-layer__txt"><b>' + ti + '</b>' + (c.artist ? '<i>' + esc(c.artist) + '</i>' : '') + '</span>' +
          '</button>' +
          '<button type="button" class="brp-layer__act" data-layer-swap="' + f.uid + '" title="' + esc(rep2) + '" aria-label="' + esc(rep2) + ' · ' + ti + '">' + LAYER_SWAP + '</button>' +
          '<button type="button" class="brp-layer__act" data-layer-del="' + f.uid + '" title="' + esc(one ? t('remove_last_hint', 'Il faut au moins un tirage — utilisez « Remplacer »') : del) + '" aria-label="' + esc(del) + ' · ' + ti + '"' + (one ? ' disabled' : '') + '>' + LAYER_DEL + '</button>' +
        '</li>';
      }).join('') + '</ul>';
  }
  function onLayerClick(e) {
    var b = e.target.closest('button'); if (!b || b.disabled) return;
    /* le choix ne remplace que le cadre sélectionné (choose) : la ligne le sélectionne d'abord */
    if (b.dataset.layerSwap) { state.sel = +b.dataset.layerSwap; refreshStage(); openPicker(state.sel); return; }
    if (b.dataset.layerDel) { hoverFrame(null); removeFrame(+b.dataset.layerDel); return; }
    if (b.dataset.layerPick) {
      var uid = +b.dataset.layerPick;
      if (state.sel === uid) { deselect(); return; }
      state.sel = uid; refreshStage();
    }
  }
  /* au survol d'une ligne, son cadre se montre sur le mur */
  function onLayerHover(e) {
    var li = e.target.closest && e.target.closest('.brp-layer');
    hoverFrame(li ? +li.dataset.uid : null);
  }
  function hoverFrame(uid) {
    Array.prototype.forEach.call($$('#brpFrames .br-frame'), function (d) { d.classList.toggle('is-layer-hover', uid != null && +d.dataset.uid === uid); });
  }

  /* Le mur, ses réglages et la tige, sans reconstruire la galerie : c'est ce
     qu'il faut redessiner quand la sélection change. La carte fait grandir le
     dock, donc la place laissée au mur change — fit() doit repasser. */
  function refreshStage() {
    renderOptions(); renderLayers(); fit(); renderFrames(); renderLeader();
  }

  function renderOptions() {
    var n = state.frames.length, target = n;
    var dispo = DISPO.filter(function (d) { return d.n === target; })[0] || DISPO[1];
    $('#brpDispo').innerHTML =
      '<button type="button" class="br-count-btn" data-count-step="-1" aria-label="' + t('count_remove_frame', 'Retirer un cadre') + '" ' + (target <= 1 ? 'disabled' : '') + '>−</button>' +
      '<strong class="br-count-value">' + target + '</strong>' +
      '<button type="button" class="br-count-btn" data-count-step="1" aria-label="' + t('count_add_frame', 'Ajouter un cadre') + '" ' + (target >= CFG.maxFrames ? 'disabled' : '') + '>+</button>';
    /* Le nombre de cadres (v4, 21/10, Max : le « + » et le « − » de chaque côté « ne
       me semblent pas dingues ») : cinq choix d'un geste, chacun dessiné par ses
       cadres ; le nom de la composition reste dessous. Les tirages qui manquent
       viennent des suggestions, ceux en trop partent (setDuo). Le compteur − n +
       est masqué (bisou-planner.css, bloc v4). */
    var duo = $('#brpDuo');
    if (duo) {
      duo.setAttribute('aria-label', t('frame_count_aria', 'Nombre de cadres'));
      duo.innerHTML = DISPO.map(function (k) {
        var on = n === k.n, pic = '';
        for (var i = 0; i < k.n; i++) pic += '<i></i>';
        return '<button type="button" data-count-set="' + k.n + '" class="brp-nb' + (on ? ' on' : '') + '" aria-pressed="' + on + '" aria-label="' + esc(k.name) + '" title="' + esc(k.name) + '"><span class="brp-nb__pic" aria-hidden="true">' + pic + '</span><b aria-hidden="true">' + k.n + '</b></button>';
      }).join('');
    }
    var caption = $('#brpCountName');
    if (caption) caption.textContent = n ? dispo.name : '';
    var allFmt = n && state.frames.every(function (f) { return f.fmt === state.frames[0].fmt; }) ? state.frames[0].fmt : null;
    $('#brpSize').innerHTML = CFG.formats.map(function (k) {
      return '<button type="button" data-gfmt="' + k + '" class="' + (allFmt === k ? 'on' : '') + '">' + k + '</button>';
    }).join('');
    var allFr = n && state.frames.every(function (f) { return f.frame === state.frames[0].frame; }) ? state.frames[0].frame : null;
    $('#brpFrameG').innerHTML =
      '<button type="button" data-gframe="perso" class="' + (n && !allFr ? 'on' : '') + '">' + t('frame_custom', 'Perso') + '</button>' +
      CFG.frames.map(function (fr) {
        return '<button type="button" class="br-dot ' + (allFr === fr.key ? 'on' : '') + '" data-gframe="' + fr.key + '" data-frame="' + fr.key + '" title="' + fr.label + '" aria-label="' + fr.label + '" style="background:' + fr.sw + '"></button>';
      }).join('');
    $('#brpGap').value = state.gap;
    $('#brpGapValue').textContent = tfill('gap_value', '{value} cm', { value: state.gap });
    /* « Alignement » ne change rien quand tous les cadres ont la même hauteur (v4,
       21/10, Max : « c'est que si on a différentes tailles de cadres que c'est
       pertinent ») : il s'éteint alors, comme la hauteur d'accrochage. */
    var hs = sizes().map(function (d) { return d[1]; });
    var alignOff = hs.every(function (h) { return h === hs[0]; });
    var alignRow = $('#brpAlign').closest('.br-wgroup');
    if (alignRow) alignRow.classList.toggle('is-off', alignOff);
    Array.prototype.forEach.call($$('#brpAlign [data-align]'), function (b) {
      b.classList.toggle('on', b.dataset.align === state.align);
      b.disabled = alignOff;
    });
    var hangIn = $('#brpHang'), hangOut = $('#brpHangValue'), hangRow = $('#brpHangRow');
    if (hangIn) hangIn.value = state.hang;
    if (hangOut) hangOut.textContent = tfill('gap_value', '{value} cm', { value: state.hang });
    /* La hauteur d'accrochage n'a d'effet que sur le vrai mur (et le plan) :
       en mode centré, elle s'éteint au lieu de mentir. */
    if (hangRow) hangRow.classList.toggle('is-off', state.scale !== 'real');
    /* La couleur, comme dans la barre des collections : la pastille montre le
       résultat, le curseur porte sa propre teinte, les deux boutons s'éteignent
       aux extrémités. */
    var hue = $('#brpHue');
    if (hue) {
      hue.value = state.wallColor.h;
      hue.style.setProperty('--brp-hue-color', hslToHex(state.wallColor.h, 45, 88));
    }
    var dot = $('#brpSatDot');
    if (dot) dot.style.background = wallHex();
    var hexIn = $('#brpHex');
    if (hexIn && document.activeElement !== hexIn) {
      hexIn.value = wallHex().toUpperCase();
      hexIn.removeAttribute('aria-invalid');
    }
    var cur = wallHex() === '#ffffff' ? '' : wallHex();
    Array.prototype.forEach.call($$('#brpPalette [data-wall-hex]'), function (b) {
      b.setAttribute('aria-pressed', b.dataset.wallHex === cur ? 'true' : 'false');
    });
    var down = $('#brpSatDown'), up = $('#brpSatUp');
    /* Une couleur de la palette se dé-sature aussi : « − » la rend au curseur. */
    if (down) down.classList.toggle('is-off', state.wallColor.s <= 0 && !state.wallColor.hex);
    if (up) up.classList.toggle('is-off', state.wallColor.s >= CFG.satLevels.length - 1);
    renderPop();
  }

  function artists() {
    var seen = {}, out = [];
    CAT.forEach(function (c) {
      if (c.vendor && !seen[c.vendor]) { seen[c.vendor] = true; out.push(c.vendor); }
    });
    return out.sort(function (a, b) { return a.localeCompare(b); });
  }
  function applyCatalogFilters(list, opts) {
    opts = opts || {};
    var filter = opts.filter || state.filter;
    var collection = opts.collection || state.collection;
    var artist = opts.artist || state.artist;
    if (filter !== 'all') list = list.filter(function (c) { return c.orient === filter; });
    if (collection !== 'all') list = list.filter(function (c) { return c.cols.indexOf(collection) > -1; });
    if (artist !== 'all') list = list.filter(function (c) { return c.vendor === artist; });
    return list;
  }
  function renderArtistFilters() {
    var wrap = $('#brpArtistFilters');
    wrap.innerHTML = '<button type="button" data-artist="all" class="' + (state.artist === 'all' ? 'on' : '') + '">' + t('artist_all', 'Tous les artistes') + '</button>' +
      artists().map(function (artist) {
        return '<button type="button" data-artist="' + artist.replace(/"/g, '&quot;') + '" class="' + (state.artist === artist ? 'on' : '') + '">' + artist + '</button>';
      }).join('');
  }
  var tabSwitched = false;
  function renderGallery() {
    var wishItems = WL.read().filter(function (i) { return catById[i.h]; });
    Array.prototype.forEach.call($$('#brpTabs [data-tab]'), function (b) { b.classList.toggle('on', b.dataset.tab === state.tab); });
    $('#brpWishCount').textContent = wishItems.length;
    $('#brpLimitedCount').textContent = CAT.filter(function (c) { return !c.open; }).length;
    $('#brpOpenCount').textContent = CAT.filter(function (c) { return c.open; }).length;
    Array.prototype.forEach.call($$('#brpCols [data-c]'), function (b) {
      var c = b.dataset.c;
      b.classList.toggle('on', c === 'm' + state.colsM || +c === state.colsD);
    });
    /* Un onglet vide au chargement, c'est une page qui n'offre rien à choisir.
       Si l'onglet courant ne contient aucune œuvre alors qu'un autre en a, on
       bascule une fois, silencieusement. */
    if (!tabSwitched) {
      var counts = {
        wishlist: wishItems.length,
        limited: CAT.filter(function (c) { return !c.open; }).length,
        open: CAT.filter(function (c) { return c.open; }).length
      };
      if (!counts[state.tab]) {
        var fallback = ['limited', 'open', 'wishlist'].filter(function (k) { return counts[k]; })[0];
        if (fallback) { state.tab = fallback; tabSwitched = true; }
      }
    }

    var grid = $('#brpCatalog');
    grid.className = 'br-grid cols-' + state.colsD + ' mcols-' + state.colsM;
    var list;
    if (state.tab === 'wishlist') {
      list = wishItems.map(function (i) { return catById[i.h]; });
      if (!list.length) { grid.innerHTML = '<div class="br-empty">' + t('wishlist_empty', 'Touchez le ♥ d’un tirage pour le garder ici — pas besoin de compte.') + '</div>'; return; }
    } else if (state.tab === 'open') {
      list = CAT.filter(function (c) { return c.open; });
    } else {
      list = CAT.filter(function (c) { return !c.open; });
    }
    list = applyCatalogFilters(list);
    renderArtistFilters();
    grid.innerHTML = list.map(function (c) {
      var liked = WL.has(c.id), used = onWall(c.id);
      return '<figure class="br-card ' + (used ? 'is-used' : '') + '" data-add="' + c.id + '">' +
        '<button type="button" class="ph-like ' + (liked ? 'on' : '') + '" data-like="' + c.id + '" aria-label="' + t('wishlist_aria', 'Wishlist') + '">' +
        '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.7-10-9.2C.6 9 1.6 5.5 4.8 4.8 7 4.3 9 5.6 12 8.5c3-2.9 5-4.2 7.2-3.7 3.2.7 4.2 4.2 2.8 7C19.5 16.3 12 21 12 21z"/></svg></button>' +
        '<div class="br-card__img"><img src="' + imgUrl(c.thumb, 480) + '" alt="' + (c.title || '').replace(/"/g, '&quot;') + '" loading="lazy" draggable="false">' +
        (used ? '<i class="br-card__used">' + t('on_wall_badge', 'Sur le mur') + '</i>' : '') + '</div>' +
        '<figcaption>' + c.title + '</figcaption></figure>';
    }).join('') || '<div class="br-empty">' + t('gallery_empty', 'Aucun tirage pour ce filtre.') + '</div>';
  }

  /* La jauge : les crans sont les places du mur. Le curseur avance entre le
     premier cadre et le dernier cran, et chaque cran s'allume quand il est
     atteint. Une place vide sur la scène et un cran sur la barre sont le même
     objet — c'est ce qui fait que le lot se joue au lieu de se lire. */
  function renderGauge(ts) {
    var wrap = $('#brpGauge'), say = $('#brpSay');
    if (!wrap) return;
    if (!ts.on || !TIERS.steps.length) {
      /* Les crans sont éteints : la jauge disparaît, mais la phrase reste — elle
         porte alors la consigne, et la barre garde un contenu à gauche. */
      wrap.innerHTML = ''; wrap.hidden = true;
      if (say) { say.innerHTML = gaugeSay(ts); say.hidden = !say.innerHTML; }
      renderTiers(ts);
      return;
    }
    wrap.hidden = false;
    var n = ts.n;
    var last = TIERS.steps[TIERS.steps.length - 1];
    var span = last.qty > 1 ? last.qty - 1 : 1;
    var pos = function (q) { return ((Math.min(q, last.qty) - 1) / span) * 100; };
    var pct = Math.max(0, Math.min(100, pos(Math.max(n, 1))));
    var dots = '', labels = '';
    TIERS.steps.forEach(function (s) {
      var on = n >= s.qty;
      dots += '<i class="br-gauge__dot' + (on ? ' on' : '') + (n === s.qty ? ' here' : '') +
        '" style="left:' + pos(s.qty).toFixed(2) + '%"></i>';
      /* Le bénéfice part dans un <i> : sur téléphone il est masqué, parce que la
         phrase juste au-dessus le dit déjà et que trois libellés complets
         mangeaient un quart de l'écran. */
      labels += '<span class="' + (on ? 'on' : '') + '"><b>' +
        esc(tfill('tier_qty', '{n} cadres', { n: s.qty })) + '</b><i>' + esc(tierLabel(s)) + '</i></span>';
    });
    wrap.innerHTML =
      '<div class="br-gauge__track"><i class="br-gauge__fill" style="width:' + pct.toFixed(2) + '%"></i>' + dots + '</div>' +
      '<div class="br-gauge__labels">' + labels + '</div>';
    if (say) { say.innerHTML = gaugeSay(ts); say.hidden = !say.innerHTML; }
    renderTiers(ts);
  }

  /* 23/10 (Max : « les promos c'est pas du tout clair […] c'est mieux fait dans le
     panier », « en haut au centre ») : sur ordinateur, les paliers se lisent au-dessus
     de la composition, l'un après l'autre. Atteint : allumé ; à venir : gris doux.
     Le chiffre d'abord, le nombre de cadres dessous. (bisou-planner.css, 23/10) */
  function tierShort(s) {
    if (s.kind === 'ensemble' || s.kind === 'discount') return tfill('tier_short', '−{pct} %', { pct: s.pct });
    return tierLabel(s);
  }
  /* Les mots de la barre des Favoris (bisou-alt-simple.js), dans les quatre langues */
  var TIER_TXT = (function (lg) {
    if (lg === 'en') return { more: function (k, p) { return k === 1 ? 'One more print for ' + p : k + ' more prints for ' + p; }, top: 'Top tier reached: {p}', min: '{n}+ prints' };
    if (lg === 'es') return { more: function (k, p) { return (k === 1 ? 'Te falta 1 lámina' : 'Te faltan ' + k + ' láminas') + ' para ' + p; }, top: 'Nivel máximo alcanzado: {p}', min: 'desde {n} láminas' };
    if (lg === 'ja') return { more: function (k, p) { return 'あと' + k + '点で' + p; }, top: '最大の割引：{p}', min: '{n}点から' };
    return { more: function (k, p) { return 'Encore ' + k + ' tirage' + (k > 1 ? 's' : '') + ' pour ' + p; }, top: 'Plus haut palier atteint : {p}', min: 'dès {n} tirages' };
  })((document.documentElement.lang || 'fr').slice(0, 2).toLowerCase());
  function renderTiers(ts) {
    var stage = $('#brpStage');
    if (!stage) return;
    var box = $('#brpTiers');
    if (!box) {
      box = el('div', 'brp-tiers'); box.id = 'brpTiers';
      box.setAttribute('aria-label', t('tiers_aria', 'Remises selon le nombre de cadres'));
      stage.appendChild(box);
      /* 25/10, 7e tour : un palier se touche et pose ce nombre de cadres, comme la
         rangée « 1 2 3 4 5 ». Il avait l'air d'un bouton et ne faisait rien. */
      box.addEventListener('click', function (e) { var b = e.target.closest('[data-count-set]'); if (b) setDuo(+b.dataset.countSet); });
    }
    if (!ts.on || !TIERS.steps.length) { box.innerHTML = ''; box.hidden = true; return; }
    /* c28b (29/10, Max : « pour les 10 %, 15 %, travailler quelque chose comme dans Favoris, une espèce de barre ») :
       la barre de la page Favoris (bisou-alt-simple.js, mêmes mots). La phrase dit ce qu'il manque pour le palier
       suivant ; chaque palier a sa part d'une ligne qui se remplit cadre après cadre, son chiffre en gros (le cran
       atteint en plein) et son seuil dessous. Une remise en pourcentage remplace la précédente : celles d'avant
       restent « passées », pas allumées. Un palier se touche toujours et pose ce nombre de cadres. */
    var n = ts.n, html = '', lo = 0;
    TIERS.steps.forEach(function (s) {
      var stack = s.kind !== 'ensemble' && s.kind !== 'discount';
      var cls = n < s.qty ? (ts.next === s ? ' next' : '') : (s === ts.reached || stack ? ' on' : ' past');
      var fill = n >= s.qty ? 1 : Math.max(0, (n - lo) / (s.qty - lo));
      lo = s.qty;
      var min = TIER_TXT.min.replace('{n}', s.qty);
      var tag = s.qty <= CFG.maxFrames ? 'button' : 'span';
      html += '<' + tag + (tag === 'button' ? ' type="button" data-count-set="' + s.qty + '" aria-label="' + esc(tierLabel(s) + ' · ' + min) + '"' : '') +
        ' class="brp-tiers__step' + cls + '" style="--f:' + fill.toFixed(3) + '" title="' + esc(tierLabel(s)) + '">' +
        '<span class="brp-tiers__seg" aria-hidden="true"><span></span></span><b>' + esc(tierShort(s)) + '</b><small>' + esc(min) + '</small></' + tag + '>';
    });
    var msg = ts.next ? TIER_TXT.more(ts.next.qty - n, tierShort(ts.next)) : ts.reached ? TIER_TXT.top.replace('{p}', tierShort(ts.reached)) : '';
    box.classList.add('is-bar');
    box.innerHTML = '<span class="brp-tiers__head"><span class="brp-tiers__msg">' + esc(msg) + '</span>' +
      (TIERS.preview ? '<em class="brp-tiers__note">' + esc(t('tier_preview', 'aperçu')) + '</em>' : '') + '</span>' +
      '<span class="brp-tiers__row">' + html + '</span>';
    box.hidden = false;
  }

  /* Le texte de l'étape, seul endroit où il est écrit. renderStep() le pose
     dans l'intro ; la barre d'achat le reprend quand elle n'a rien de
     commercial à dire — sans quoi elle n'était qu'un bandeau blanc, ce qui est
     exactement ce que Max a vu tant que les crans sont éteints. */
  function stepText() {
    var n = state.frames.length;
    if (!n) return t('step_start_plus', 'Choisissez un premier tirage avec le « + ».');
    if (n === 1) return t('step_one', 'Ajoutez un deuxième tirage avec les « + », à gauche ou à droite du mur.');
    return t('step_ready', 'Votre mur est prêt. Ajustez les formats et les cadres, ou ajoutez-le au panier.');
  }

  function gaugeSay(ts) {
    /* Tant que le mur n'est pas complet, la consigne prime sur l'argument :
       on finit le mur avant de parler du palier suivant. */
    var incomplete = ts.n < Math.max(state.targetCount, ts.n);
    if (!ts.on || !ts.n || incomplete) return esc(stepText());
    var parts = [];
    if (ts.reached) parts.push('<b>' + esc(tierLabel(ts.reached)) + '</b>');
    if (ts.next && ts.next.kind === 'ensemble') {
      var gap = ts.next.qty - ts.n;
      parts.push(esc(tfill(gap > 1 ? 'gauge_ens_next_n' : 'gauge_ens_next_1',
        gap > 1 ? 'encore {miss} tirages pour −{pct} %' : 'encore un tirage pour −{pct} %',
        { miss: gap, pct: ts.next.pct })));
    } else if (ts.next) {
      var miss = ts.next.qty - ts.n;
      parts.push(esc(tfill(miss > 1 ? 'gauge_next_n' : 'gauge_next_1',
        miss > 1 ? 'encore {miss} cadres : {benefit}' : 'encore un cadre : {benefit}',
        { miss: miss, benefit: tierLabel(ts.next) })));
    } else if (ts.reached) {
      parts.push(esc(t('gauge_max', 'vous avez tout débloqué')));
    }
    var tag = TIERS.preview ? '<em class="br-apercu">' + esc(t('tier_preview', 'aperçu')) + '</em> ' : '';
    return tag + parts.join(' — ');
  }

  /* La barre est fixée : elle recouvre le bas de la page. On rend au document
     exactement la hauteur qu'elle occupe, plutôt qu'une constante CSS qui serait
     fausse dès que la phrase passe sur deux lignes. */
  function syncBarSpace() {
    var bar = $('#brpBuyBar');
    if (!bar || bar.hidden) return;
    /* En mode « un seul écran » la barre est dans le flux : elle ne recouvre
       rien, et lui réserver de la place volerait de la hauteur à la scène. */
    if (root.classList.contains('brp-app')) { root.style.paddingBottom = ''; return; }
    var h = bar.offsetHeight;
    if (h > 0) root.style.paddingBottom = (h + 22) + 'px';
  }

  /* L'état des deux volets suit la largeur : repliés sous 1100 px, où ils
     passent sous le mur et lui prendraient toute la place ; toujours ouverts
     au-dessus, où ce sont des colonnes. Sans ce rappel, un volet replié sur
     téléphone restait fermé après rotation de l'écran, sans moyen visible de
     le rouvrir sur une mise en page qui n'a plus de chevron. */
  /* 23/10 (Max : « réglage du mur ça doit être ouvert ») : ouvert d'emblée sur ordinateur */
  var wallOpen = true;
  function syncPanels() {
    var mobile = window.innerWidth < 1100;
    var first = true, anyOpen = false;
    Array.prototype.forEach.call($$('[data-panel-toggle]'), function (btn) {
      var body = document.getElementById(btn.dataset.panelToggle);
      if (!body) return;
      /* v6 (22/10) : sur ordinateur, les réglages du mur restent repliés tant
         qu'on ne les ouvre pas — la caisse prend leur place en haut à droite. */
      var open = mobile ? (first && !state.frames.length)
        : (btn.dataset.panelToggle !== 'brpWallBody' || wallOpen);
      body.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && mobile) anyOpen = true;
      first = false;
    });
    root.classList.toggle('has-panel', anyOpen);
  }

  /* La hauteur réellement disponible sous l'en-tête du site. On la mesure une
     fois posée, plutôt que de supposer une hauteur d'en-tête. */
  function syncViewport() {
    if (!root.classList.contains('brp-app')) return;
    var top = root.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    var h = Math.max(480, Math.round(window.innerHeight - top));
    root.style.setProperty('--brp-vh', h + 'px');
  }

  /* 23/10 (Max : « completement bugé ») : sous 1100 px, la page défile d'un seul
     tenant et la scène reste collée sous l'en-tête du site (bisou-planner.css,
     bloc du 23/10). L'en-tête se cache et revient : la scène suit son bas. */
  var stickHead = null, stickRaf = 0, stickUntil = 0, stickLast = -1, stickSame = 0;
  /* Descendu, le bloc collé se resserre sur la scène (bisou-planner.css, reprise
     du 23/10, 19 h). Deux seuils, pour qu'il ne batte pas sur la limite. */
  function syncCondense() {
    var on = root.classList.contains('is-scrolled');
    var y = window.scrollY || window.pageYOffset || 0;
    if (window.innerWidth >= 1100 || root.classList.contains('br-fs')) { if (on) root.classList.remove('is-scrolled'); return; }
    if (!on && y > 80) root.classList.add('is-scrolled');
    else if (on && y < 30) root.classList.remove('is-scrolled');
  }
  /* 25/10 (6e tour) : le temps d'un réglage, la scène ne colle plus
     (bisou-planner.css). Touchée en bas de page, elle reprenait sa place et le
     cadre choisi sortait par le haut : la page remonte juste assez pour remettre
     la scène sous l'en-tête, sans faire passer le volet sous la caisse. */
  function keepSelInView() {
    if (window.innerWidth >= 1100 || root.classList.contains('br-fs') || !$('.br-frame.sel')) return;
    var blk = $('.br-block:nth-of-type(1)'), bar = $('#brpBuyBar');
    if (!blk) return;
    var b = blk.getBoundingClientRect();
    var up = b.top - (parseFloat(root.style.getPropertyValue('--brp-stick')) || 0);
    if (bar) up = Math.max(up, b.bottom - (window.innerHeight - bar.offsetHeight));
    if (up < -1) window.scrollBy(0, Math.round(up));
  }
  function syncStick() {
    stickRaf = 0;
    syncCondense();
    if (!stickHead) stickHead = document.querySelector('.shopify-section-header-sticky, .section-header');
    var y = 0;
    /* À l'ordinateur aussi (c28b, 29/10) : la page y défile d'un seul tenant, mur et composition collés */
    if (stickHead && !root.classList.contains('br-fs')) {
      var pos = getComputedStyle(stickHead).position;
      if (pos === 'sticky' || pos === 'fixed') y = Math.max(0, Math.round(stickHead.getBoundingClientRect().bottom));
    }
    root.style.setProperty('--brp-stick', y + 'px');
    /* l'en-tête glisse en une seconde environ : on le suit image par image tant
       qu'il bouge (relu une seule fois à 400 ms, il laissait un trou de 28 px) */
    if (y === stickLast) stickSame++; else { stickSame = 0; stickLast = y; }
    if (stickSame < 12 && Date.now() < stickUntil) stickRaf = requestAnimationFrame(syncStick);
  }
  function queueStick() {
    stickUntil = Date.now() + 1600; stickSame = 0;
    if (!stickRaf) stickRaf = requestAnimationFrame(syncStick);
  }

  function renderFoot() {
    var n = state.frames.length;
    var subtotal = state.frames.reduce(function (s, f) { return s + priceOf(f); }, 0);
    var ts = tierState();
    var grand = subtotal - ts.save;

    /* Le prix barré n'apparaît QUE s'il y a une remise que Shopify appliquera
       vraiment. Tant que les crans sont éteints, le bouton porte le prix plein
       — celui que le client paiera. */
    $('#brpSub').innerHTML = ts.save ? '<s>' + esc(money(subtotal)) + '</s>' : '';
    $('#brpTotal').textContent = n ? money(grand) : '';
    $('#brpBonus').textContent = ts.save ? tfill('you_save', '−{amount}', { amount: money(ts.save) }) +
      (TIERS.preview ? ' · ' + t('tier_preview', 'aperçu') : '') : '';
    /* « 1 cadres » au singulier : la clé de traduction n'a qu'une forme */
    var cnt = n ? tfill('bar_count', '{n} cadres', { n: n }) : '';
    if (n === 1) cnt = cnt.replace(/\b(cadre|frame)s\b/, '$1');
    $('#brpCount').textContent = cnt;

    /* La livraison, dans la caisse (perfection site-vendeur, 25/10) : le seuil et les
       mots de la fiche tirage (réglage bisou_free_shipping_threshold). Comparée au
       total remisé, ce que le client paiera, et dite seulement en euros vers la
       France, le seul cas où le seuil du bandeau vaut. */
    var ship = $('#brpShip'), price = $('#brpBuyBar .br-price');
    if (!ship && price) { ship = el('span', 'br-price__ship'); ship.id = 'brpShip'; price.appendChild(ship); }
    if (ship) {
      var seuil = parseInt(BOOT.cfg && BOOT.cfg.ship_threshold, 10);
      var fr = !!(window.Shopify && Shopify.country === 'FR' && (!Shopify.currency || Shopify.currency.active === 'EUR'));
      var free = n > 0 && seuil > 0 && grand >= seuil * 100;
      ship.textContent = !n || !fr || !(seuil > 0) ? '' : (free ? t('ship_free', 'Livraison offerte')
        : tfill('ship_from', 'Livraison offerte dès {amount}', { amount: money(seuil * 100) }));
      ship.classList.toggle('is-free', free);
    }

    renderGauge(ts);

    var btn = $('#brpAddCart'); btn.disabled = n < 1 || busy;
    btn.textContent = n < 1 ? t('cta_empty', 'Ajoutez un cadre') : (busy ? t('cta_busy', 'Ajout…') : t('cta_add_to_cart_short', 'Ajouter au panier'));

    var bar = $('#brpBuyBar');
    if (bar) { bar.hidden = false; syncBarSpace(); }

    $('#brpMyWall').textContent = state.wallConfigured
      ? tfill('wall_summary', 'Mur : {width} × {height} cm · modifier', { width: Math.round(state.wall.w), height: Math.round(state.wall.h) })
      : t('configure_wall', 'Configurer mon mur');
    /* Un seul mode (29/10, Max : « je comprends pas trop la différence entre centré et mon
       mur ») : sans mesures, la composition est centrée ; avec, elle est à l'échelle du mur.
       Plus de bascule : « Retirer mes mesures » ramène au mur centré. */
    var forget = $('#brpWallForget'), mine = $('#brpMyWall');
    if (!forget && state.wallConfigured && mine) {
      forget = el('button', 'brp-wallforget'); forget.type = 'button'; forget.id = 'brpWallForget';
      forget.addEventListener('click', forgetWall);
      mine.parentNode.insertBefore(forget, mine.nextSibling);
    }
    if (forget) { forget.hidden = !state.wallConfigured; forget.textContent = t('wall_forget', 'Retirer mes mesures'); }
    var fit = $('#brpWallFit'), msg = state.wallConfigured ? wallFitText() : '';
    fit.hidden = !msg; fit.textContent = msg;
  }

  /* La composition tient-elle sur le mur configuré ? Comptée aux cotes
     extérieures des cadres, avec l'écart choisi, sur une seule rangée. */
  function wallFit() {
    var S = sizes(), gap = currentGap();
    var w = S.reduce(function (s, d) { return s + d[0]; }, 0) + gap * Math.max(0, S.length - 1);
    var h = S.length ? Math.max.apply(null, S.map(function (d) { return d[1]; })) : 0;
    return { w: w, h: h, wide: w > state.wall.w, tall: h > state.wall.h };
  }
  function wallFitText() {
    if (!state.frames.length) return '';
    var f = wallFit(), v = { width: Math.round(f.w), height: Math.round(f.h), wall_w: Math.round(state.wall.w), wall_h: Math.round(state.wall.h) };
    if (f.tall) return tfill('wall_fit_tall', 'Trop haut pour ce mur : la composition fait {height} cm, le mur {wall_h} cm.', v);
    if (f.wide) return tfill('wall_fit_wide', 'Trop large pour une rangée : {width} cm pour un mur de {wall_w} cm. Les cadres passent sur plusieurs rangées.', v);
    return '';
  }

  /* La consigne. Une seule phrase, en haut, qui dit ce qu'il reste à faire —
     la page ne l'a jamais dit, et c'est le premier reproche de Max : « on
     comprend pas ce qu'on doit faire ». Elle remplace le texte d'introduction
     générique, au même endroit. */
  function renderStep() {
    var el2 = $('#brpStep');
    if (el2) el2.textContent = stepText();
  }

  /* L'ordre compte : le dock (consigne ou éditeur du cadre) est rendu par
     renderOptions, et sa hauteur change selon qu'un cadre est sélectionné.
     fit() mesure la place qui reste au mur — il doit donc passer APRÈS, sinon
     le premier clic sur un cadre laissait le mur à son ancienne taille et le
     poussait sous l'éditeur. */
  /* « Pourquoi » se montre ou se cache avant la mesure du mur : apparue après, la
     ligne passait sous le mur (mur vide, puis Diptyque ou Triptyque) */
  function renderAll() { renderOptions(); renderLayers(); renderWhy(); fit(); renderFrames(); renderGallery(); renderFoot(); renderStep(); renderLeader(); }

  /* ---------- drag = réordonner · clic = sélection ---------- */
  var drag = null;
  function onPointerDown(e) {
    if (window.innerWidth < 900 && state.previewMode === 'large' && e.pointerType === 'touch') return;
    var d = e.currentTarget, uid = +d.dataset.uid, f = null;
    state.frames.forEach(function (x) { if (x.uid === uid) f = x; });
    if (!f) return;
    try { if (d.setPointerCapture) d.setPointerCapture(e.pointerId); } catch (_) {}
    drag = { uid: uid, el: d, startX: e.clientX, startY: e.clientY, origX: f.x, origY: f.y, moved: false };
    d.classList.add('is-drag');
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp, { once: true });
    e.preventDefault();
  }
  function onPointerMove(e) {
    if (!drag) return;
    var dx = (e.clientX - drag.startX) / PXCM;
    if (Math.abs(e.clientX - drag.startX) > 4 || Math.abs(e.clientY - drag.startY) > 4) {
      if (!drag.moved) {
        var p = $('#brpPop'); if (p) p.hidden = true;
        showEl($('#brpLeader'), false);
        /* le cartel du cadre qu'on déplace s'efface pendant le geste ; il revient au lâcher */
        Array.prototype.forEach.call($$('.br-frame-cap'), function (a) { if (+a.dataset.uid === drag.uid) a.style.visibility = 'hidden'; });
      }
      drag.moved = true;
    }
    var f = null; state.frames.forEach(function (x) { if (x.uid === drag.uid) f = x; });
    f.x = drag.origX + dx;
    if (PG) { var dd = dimsCm(f.fmt, catById[f.id].orient); drag.el.style.transform = pieceMatrix(f.x, f.y, dd[0], dd[1], pieceKey(f)); if (drag.moved) pieceDrag(drag.uid); }
    else drag.el.style.transform = 'translate(' + (f.x * PXCM) + 'px,' + (f.y * PXCM) + 'px)';
  }
  function onPointerUp(e) {
    if (!drag) return;
    drag.el.classList.remove('is-drag');
    if (!drag.moved) {
      var now = Date.now();
      /* Deux touches rapides ouvraient « Remplacer » : qui tapait deux fois pour
         ouvrir le tirage se retrouvait à le remplacer (v3, 21/10). Le cadre reste
         simplement choisi ; « Remplacer » est dans son panneau. */
      if (onPointerUp._uid === drag.uid && now - (onPointerUp._t || 0) < 350) { if (state.sel !== drag.uid) { state.sel = drag.uid; refreshStage(); } }
      else if (state.sel === drag.uid) { deselect(); }
      else {
        state.sel = drag.uid;
        refreshStage();
      }
      onPointerUp._t = now; onPointerUp._uid = drag.uid;
    } else { reorderFromPositions(); state.touched = true; relayout(); renderAll(); }
    document.removeEventListener('pointermove', onPointerMove);
    drag = null;
  }
  /* drag depuis la galerie (clic simple = ajouter) */
  var shelfDrag = null;
  function onShelfDown(e) {
    var it = e.target.closest('[data-add]'); if (!it) return;
    if (e.target.closest('.ph-like')) return;
    shelfDrag = { id: it.dataset.add, x: e.clientX, y: e.clientY, started: false, clone: null };
    document.addEventListener('pointermove', onShelfMove);
    document.addEventListener('pointerup', onShelfUp, { once: true });
  }
  function onShelfMove(e) {
    if (!shelfDrag) return;
    if (!shelfDrag.started && Math.hypot(e.clientX - shelfDrag.x, e.clientY - shelfDrag.y) > 6) {
      shelfDrag.started = true;
      var c = catById[shelfDrag.id];
      var cl = el('img', 'br-dragclone'); cl.src = imgUrl(c.thumb, 240); document.body.appendChild(cl);
      shelfDrag.clone = cl;
    }
    if (shelfDrag.clone) {
      shelfDrag.clone.style.left = e.clientX + 'px'; shelfDrag.clone.style.top = e.clientY + 'px';
      var r = $('#brpCanvas').getBoundingClientRect();
      shelfDrag.clone.classList.toggle('ok', e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom);
    }
  }
  function onShelfUp(e) {
    if (!shelfDrag) return;
    var wasStarted = shelfDrag.started;
    if (shelfDrag.clone) shelfDrag.clone.remove();
    var id = shelfDrag.id; shelfDrag = null;
    document.removeEventListener('pointermove', onShelfMove);
    if (wasStarted) {
      var r = $('#brpCanvas').getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) addFrame(id);
    } else addFrame(id);
  }

  /* ---------- actions ---------- */
  function deselect() {
    state.sel = null;
    Array.prototype.forEach.call($$('.br-frame'), function (d) { d.classList.remove('sel'); });
    refreshStage();
  }
  function addFrame(id, where) {
    if (state.frames.length >= CFG.maxFrames) { toast(tfill('toast_max_frames', 'Maximum {max} cadres', { max: CFG.maxFrames })); return; }
    if (onWall(id)) { toast(t('toast_already_on_wall', 'Déjà sur le mur')); return; }
    var c = catById[id]; if (!c) return;
    pushFrame(c, null, null, where === 'left' ? 'left' : 'right');
    state.targetCount = state.frames.length;
    state.touched = true;
    relayout(); state.sel = null; renderAll();
  }
  /* Retirer un cadre : le nombre de cadres suit (3 → 2), sans place vide. */
  function removeFrame(uid) {
    if (state.frames.length <= 1) { toast(t('remove_last_hint', 'Il faut au moins un tirage — utilisez « Remplacer »')); return; }
    state.frames = state.frames.filter(function (f) { return f.uid !== uid; });
    if (state.sel === uid) state.sel = null;
    state.targetCount = state.frames.length;
    state.touched = true;
    relayout(); renderAll();
  }
  /* Le compteur : « − » retire le cadre choisi, sinon le dernier ; « + » ouvre le choix.
     Les cadres qu'il retire sont gardés (24/10) : remonter le nombre les rend, réglés
     comme avant, au lieu de les remplacer par des suggestions (4 → 1 → 2 perdait le
     deuxième tirage choisi). */
  var gone = [];
  function setCount(n) {
    n = Math.max(1, Math.min(CFG.maxFrames, n));
    while (state.frames.length > n) {
      var sel = selFrame();
      var out = sel || state.frames[state.frames.length - 1];
      gone.push({ id: out.id, fmt: out.fmt, frame: out.frame });
      if (sel) { state.frames = state.frames.filter(function (f) { return f !== sel; }); state.sel = null; }
      else state.frames.pop();
    }
    state.targetCount = state.frames.length;
    var still = false; state.frames.forEach(function (f) { if (f.uid === state.sel) still = true; });
    if (!still) state.sel = null;
    state.touched = true;
    relayout(); renderAll();
  }
  /* Diptyque ou triptyque, d'un geste (v3, 21/10) : les tirages qui manquent
     viennent des suggestions, dans l'ordre d'« Autre suggestion » ; ceux en trop
     partent comme avec le « − ». Sans suggestion, la fenêtre de choix s'ouvre. */
  function setDuo(k) {
    if (state.frames.length > k) { setCount(k); return; }
    while (state.frames.length < k && gone.length) {
      var g = gone.pop();
      if (catById[g.id] && !onWall(g.id)) pushFrame(catById[g.id], g.fmt, g.frame, 'right');
    }
    var first = state.frames[0];
    var list = first ? suggestions(catById[first.id]) : firstPair();
    while (state.frames.length < k) {
      var c = list.filter(function (x) { return !onWall(x.id); })[0];
      /* Sur un mur vide, firstPair() ne donne que deux tirages : le troisième vient
         des suggestions du premier posé */
      if (!c && state.frames[0]) c = suggestions(catById[state.frames[0].id]).filter(function (x) { return !onWall(x.id); })[0];
      if (!c) { openPicker('new'); break; }
      pushFrame(c, null, null, 'right');
    }
    state.targetCount = state.frames.length;
    state.touched = true; state.sel = null;
    relayout(); renderAll();
  }
  function setGlobalFormat(k) {
    state.touched = true;
    state.frames.forEach(function (f) {
      var target = k === 'random'
        ? fmtsAvail(f.id)[(Math.random() * fmtsAvail(f.id).length) | 0]
        : (fmtsAvail(f.id).indexOf(k) > -1 ? k : f.fmt);
      f.fmt = target;
      if (frameAvail(f.id, f.fmt).indexOf(f.frame) < 0) f.frame = frameAvail(f.id, f.fmt)[0];
    });
    relayout(); renderAll();
  }
  function setGlobalFrame(k) {
    if (k === 'perso') { toast(t('toast_custom_hint', 'Cliquez un cadre sur le mur pour le personnaliser')); return; }
    state.touched = true;
    state.frames.forEach(function (f) {
      var av = frameAvail(f.id, f.fmt);
      f.frame = k === 'random' ? av[(Math.random() * av.length) | 0] : (av.indexOf(k) > -1 ? k : f.frame);
    });
    renderAll();
  }
  function selFrame() { var f = null; state.frames.forEach(function (x) { if (x.uid === state.sel) f = x; }); return f; }
  function setSelFormat(k) {
    var f = selFrame(); if (!f) return;
    state.touched = true;
    f.fmt = k;
    if (frameAvail(f.id, k).indexOf(f.frame) < 0) f.frame = frameAvail(f.id, k)[0];
    relayout(); renderAll();
  }
  function setSelFrame(k) {
    var f = selFrame(); if (!f) return;
    state.touched = true;
    if (frameAvail(f.id, f.fmt).indexOf(k) > -1) f.frame = k;
    renderAll();
  }
  function toggleLike(id) {
    var c = catById[id]; if (!c) return;
    var f0 = { fmt: c.fmts[0], frame: frameAvail(id, c.fmts[0])[0], id: id };
    var e = entry(f0);
    var added = WL.toggle({ h: id, id: e ? e.vid : '', t: c.title, u: c.url, img: c.thumb, p: e ? money(e.price) : '', at: Date.now() });
    if (added) toast(t('toast_wishlist_added', '🤍 Gardé dans votre wishlist'));
    renderGallery();
  }

  /* ---------- picker ---------- */
  function openPicker(target) { state.pickerTarget = target; $('#brpPicker').hidden = false; renderPicker(); }
  function closePicker() { $('#brpPicker').hidden = true; state.pickerTarget = null; }
  function renderPicker() {
    var cur = null;
    if (typeof state.pickerTarget === 'number') {
      state.frames.forEach(function (f) { if (f.uid === state.pickerTarget) cur = f.id; });
    }
    var grid = $('#brpPickerGrid');
    grid.className = 'br-modal__grid picker-cols-' + state.pickerCols;
    Array.prototype.forEach.call($$('#brpPickerDensity [data-picker-cols]'), function (b) {
      b.classList.toggle('on', +b.dataset.pickerCols === state.pickerCols);
    });
    Array.prototype.forEach.call($$('#brpPickerOrientation [data-picker-filter]'), function (b) {
      b.classList.toggle('on', b.dataset.pickerFilter === state.pickerFilter);
    });
    var colSelect = $('#brpPickerCollection');
    colSelect.innerHTML = '<option value="all">' + t('all_collections', 'Toutes les collections') + '</option>' +
      Array.prototype.map.call($$('#brpCollectionFilters [data-collection]:not([data-collection="all"])'), function (b) {
        return '<option value="' + b.dataset.collection + '">' + b.textContent.trim() + '</option>';
      }).join('');
    colSelect.value = state.pickerCollection;
    /* Sans collection réglée dans la section, la liste n'offrait que « Toutes les collections » : rien à choisir (25/10) */
    colSelect.hidden = colSelect.options.length < 2;
    var artistSelect = $('#brpPickerArtist');
    artistSelect.innerHTML = '<option value="all">' + t('artist_all', 'Tous les artistes') + '</option>' +
      artists().map(function (artist) { return '<option value="' + artist.replace(/"/g, '&quot;') + '">' + artist + '</option>'; }).join('');
    artistSelect.value = state.pickerArtist;
    var pickerList = CAT.slice();
    if (state.pickerEdition === 'limited') pickerList = pickerList.filter(function (c) { return !c.open; });
    if (state.pickerEdition === 'open') pickerList = pickerList.filter(function (c) { return c.open; });
    if (state.pickerEdition === 'wishlist') {
      var wished = {};
      WL.read().forEach(function (i) { wished[i.h] = true; });
      pickerList = pickerList.filter(function (c) { return wished[c.id]; });
    }
    $('#brpPickerEdition').value = state.pickerEdition;
    pickerList = applyCatalogFilters(pickerList, {
      filter: state.pickerFilter,
      collection: state.pickerCollection,
      artist: state.pickerArtist
    });
    /* Les coups de cœur d'abord, puis les tirages vus récemment, chacun du plus
       récent au plus ancien (16/10) ; un tirage des deux listes reste avec les coups
       de cœur. Les autres gardent l'ordre du catalogue. */
    var rank = {}, nRank = 0;
    wishCat().concat(recentCat()).forEach(function (c) { if (!rank[c.id]) rank[c.id] = ++nRank; });
    pickerList = pickerList.filter(function (c) { return rank[c.id]; })
      .sort(function (a, b) { return rank[a.id] - rank[b.id]; })
      .concat(pickerList.filter(function (c) { return !rank[c.id]; }));
    grid.innerHTML = pickerList.map(function (c) {
      var liked = WL.has(c.id);
      /* Un tirage déjà au mur se voit dans la fenêtre (24/10) : au doigt, le toucher
         fermait la fenêtre sur « Déjà sur le mur » et le client recommençait. */
      var used = cur !== c.id && onWall(c.id);
      return '<figure class="br-card ' + (cur === c.id ? 'on' : (used ? 'is-used' : '')) + '" data-pick="' + c.id + '">' +
        '<button type="button" class="ph-like ' + (liked ? 'on' : '') + '" data-like="' + c.id + '" aria-label="' + t('wishlist_aria', 'Wishlist') + '">' +
        '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.7-10-9.2C.6 9 1.6 5.5 4.8 4.8 7 4.3 9 5.6 12 8.5c3-2.9 5-4.2 7.2-3.7 3.2.7 4.2 4.2 2.8 7C19.5 16.3 12 21 12 21z"/></svg></button>' +
        /* 27/10 : 480 au téléphone, 720 sur un grand écran net ou en vue large (la taille vient de la grille, « Vue » comprise) */
        '<div class="br-card__img"><img src="' + imgUrl(c.thumb, 480) + '" srcset="' + imgUrl(c.thumb, 480) + ' 480w, ' + imgUrl(c.thumb, 720) + ' 720w" sizes="auto, (min-width: 750px) 310px, 34vw" alt="" loading="lazy"></div>' +
        '<figcaption>' + c.title + pickMeta(c) + (used ? '<small class="br-card__used">' + esc(t('toast_already_on_wall', 'Déjà sur le mur')) + '</small>' : '') + '</figcaption></figure>';
    }).join('') || '<div class="br-empty">' + t('picker_empty', 'Aucun tirage pour ces filtres.') + '</div>';
    /* 27/10 (relecture) : Safari ne lit pas « auto » et prenait 34vw, soit 480 pour la vue à une colonne de l'iPhone
       (812 px réels). La largeur réelle d'une vignette, vue comprise, remplace la suite avant que les photos partent. */
    var pickImg = grid.querySelector('.br-card__img img'), pickW = pickImg ? Math.ceil(pickImg.getBoundingClientRect().width) : 0;
    if (pickW) Array.prototype.forEach.call(grid.querySelectorAll('.br-card__img img'), function (i) { i.sizes = 'auto, ' + pickW + 'px'; });
  }
  /* 26/10 (Max) : la fenêtre présente les tirages comme Tous nos tirages :
     le titre, puis l'artiste et le prix de départ (affichés à l'ordinateur). */
  function pickMeta(c) {
    var low = 0;
    Object.keys(c.map || {}).forEach(function (k) {
      Object.keys(c.map[k] || {}).forEach(function (fr) {
        var p = (c.map[k][fr] || {}).price;
        if (p && (!low || p < low)) low = p;
      });
    });
    if (!c.artist && !low) return '';
    return '<span class="br-card__meta">' + (c.artist ? '<span class="br-card__by">' + esc(c.artist) + '</span>' : '') +
      (low ? '<span class="br-card__from">' + esc(tfill('from_price', 'dès {price}', { price: money(low) })) + '</span>' : '') + '</span>';
  }
  function choose(id) {
    if (state.pickerTarget === 'new' || state.pickerTarget === 'new-left') {
      /* déjà au mur : la fenêtre reste ouverte, le client en choisit un autre */
      if (onWall(id)) { toast(t('toast_already_on_wall', 'Déjà sur le mur')); return; }
      var where = state.pickerTarget === 'new-left' ? 'left' : 'right';
      closePicker(); addFrame(id, where); return;
    }
    var f = selFrame();
    if (f && state.pickerTarget === f.uid) {
      if (onWall(id) && f.id !== id) { toast(t('toast_already_on_wall', 'Déjà sur le mur')); return; }
      f.id = id;
      state.touched = true;
      if (fmtsAvail(id).indexOf(f.fmt) < 0) f.fmt = fmtsAvail(id)[0];
      if (frameAvail(id, f.fmt).indexOf(f.frame) < 0) f.frame = frameAvail(id, f.fmt)[0];
      relayout(); renderAll();
    }
    closePicker();
  }

  /* ---------- mon mur + plan ---------- */
  function clampNum(v, min, max, def) { v = parseFloat(v); if (!isFinite(v)) return def; return Math.max(min, Math.min(max, v)); }
  function applyWall() {
    state.wall.w = clampNum($('#brpWallW').value, 60, 800, 200);
    state.wall.h = clampNum($('#brpWallH').value, 60, 500, 250);
    state.wallConfigured = true;
    state.scale = 'real';
    relayout(); renderAll();
    $('#brpWallModal').hidden = true;
    /* Venu de « plan d'accrochage » sans mur : le plan suit, sans second clic */
    if (state.planAfterWall) { state.planAfterWall = false; openPlan(); return; }
    toast(t('toast_wall_applied', '📏 Composition positionnée à 1,60 m — la hauteur d’accrochage standard'));
  }
  function forgetWall() {
    state.wallConfigured = false; state.planAfterWall = false;
    state.scale = 'auto';
    relayout(); renderAll();
  }
  function printPlan() {
    if (state.scale !== 'real') { state.scale = 'real'; relayout(); renderAll(); }
    buildPrint();
    /* Le plan est enfoui dans main > section > div : aucune regle @media print
       ne peut couper la mise en page de ses ancetres. On le remonte une fois
       sous <body>, la feuille de style fait le reste. A l'ecran il reste
       invisible (.brp-print{display:none}). */
    var area = document.getElementById('brpPrintArea');
    if (area && area.parentNode !== document.body) document.body.appendChild(area);
    document.documentElement.classList.add('brp-printing');
    window.print();
  }
  /* Le plan d'accrochage (Max, 23/10 : « canon et bien calculé avec nos cadres »).
     Tout se compte sur la cote EXTÉRIEURE du RÖDALM (CFG.dims) ; le format du
     tirage (CFG.print) ne sert qu'à le nommer et à dessiner le tirage dans le
     cadre. Le clou tombe au milieu du cadre, CFG.drillDrop sous son bord
     supérieur extérieur. Les cotes sont données depuis le bord gauche, depuis
     l'axe du mur et depuis le sol, au demi-centimètre : ce qu'on lit au mètre. */
  function cmTxt(v) { var r = Math.round(v * 2) / 2; return String(r).replace('.', ',') + ' cm'; }
  /* 27/10 (Max : « en paysage […] beaucoup plus grand et beaucoup plus détaillé,
     comme dans les plans d'accrochage d'exposition ») : une seule feuille A4
     paysage, dessinée en SVG au millimètre (viewBox 297 × 210). La même feuille
     s'affiche dans l'aperçu, s'imprime et se télécharge. À gauche, l'élévation du
     mur à grande échelle et ses chaînes de cotes : en haut, du bord gauche au bord
     droit par les bords des cadres (marges, largeurs, écarts) ; à gauche, du haut
     du mur au sol ; à droite, du sol au centre de la composition. À droite, la
     légende : chaque cadre, son titre, son format, son clou ; puis la pose. Noir,
     gris, et un rouge sombre qui reste lisible en noir et blanc. */
  function planSheet() {
    var W = state.wall.w, H = state.wall.h, drop = CFG.drillDrop;
    var ink = '#1c1916', soft = '#5f584d', rule = '#8a8276', faint = '#cfc8bc', red = '#a63a22';
    var Z = { x0: 28, x1: 192, y0: 42, y1: 188 };
    var sc = Math.min((Z.x1 - Z.x0) / W, (Z.y1 - Z.y0) / H);
    var ox = Z.x0 + (Z.x1 - Z.x0 - W * sc) / 2, oy = Z.y1 - H * sc;
    function f2(v) { return +(+v).toFixed(2); }
    function X(cm) { return f2(ox + cm * sc); }
    function Y(cm) { return f2(oy + cm * sc); }
    function num(v) { return cmTxt(v).replace(' cm', ''); }
    function tx(x, y, s, o) {
      o = o || {};
      return '<text x="' + f2(x) + '" y="' + f2(y) + '" font-size="' + (o.s || 2.6) + '"' +
        (o.a ? ' text-anchor="' + o.a + '"' : '') + (o.w ? ' font-weight="' + o.w + '"' : '') +
        ' fill="' + (o.c || ink) + '"' + (o.r ? ' transform="rotate(-90 ' + f2(x) + ' ' + f2(y) + ')"' : '') + '>' + esc(s) + '</text>';
    }
    function wrap(s, n) {
      var out = [], cur = '';
      /* japonais : pas d'espace entre les mots, la ligne se coupe entre deux signes ; un signe pleine chasse compte pour
         deux lettres latines, un nombre (avec son « cm ») ou un mot latin ne se coupe pas, et rien ne commence par 、。」 ou un petit kana */
      if (/[぀-ヿ一-鿿]/.test(s)) {
        var w = 0, NO = /^[、。，．・ー）」』】！？：；ぁぃぅぇぉっゃゅょァィゥェォッャュョ]/;
        (String(s).replace(/​/g, '').match(/\d[\d,.]* cm|[A-Za-z0-9À-ÿ.,%×\-]+|[\s\S]/g) || []).forEach(function (k) {
          var kw = /[⺀-￯]/.test(k) ? 2 : k.length;
          if (cur && w + kw > n && !NO.test(k)) { out.push(cur.trim()); cur = ''; w = 0; }
          if (cur || k !== ' ') { cur += k; w += kw; }
        });
        if (cur.trim()) out.push(cur.trim());
        return out;
      }
      String(s).split(' ').forEach(function (w) { if (cur && (cur + ' ' + w).length > n) { out.push(cur); cur = w; } else cur = cur ? cur + ' ' + w : w; });
      if (cur) out.push(cur);
      return out;
    }
    var F = state.frames.map(function (f, i) {
      var c = catById[f.id], d = dimsCm(f.fmt, c.orient), p = CFG.print[f.fmt], pr = c.orient === 'h' ? [p[1], p[0]] : p;
      var frName = (CFG.frames.filter(function (fr) { return fr.key === f.frame; })[0] || { label: f.frame }).label;
      return { n: i + 1, x: f.x, y: f.y, w: d[0], h: d[1], pw: pr[0], ph: pr[1], fmt: f.fmt, title: c.title, frame: frName, nx: f.x + d[0] / 2, ny: f.y + drop };
    });
    /* Une chaîne de cotes : traits de rappel jusqu'aux objets, ligne, barbules
       obliques d'architecte, et chaque valeur posée sur son segment ; deux valeurs
       trop serrées se décalent l'une de l'autre. */
    function chain(marks, horiz, at) {
      marks.sort(function (a, b) { return a.v - b.v; });
      var M = [];
      marks.forEach(function (m) { var last = M[M.length - 1]; if (last && m.v - last.v < 0.25) { last.to = Math.min(last.to, m.to); return; } M.push({ v: m.v, to: m.to }); });
      var P = function (v) { return horiz ? X(v) : Y(v); };
      var o = '<g fill="none" stroke-width=".18" stroke="' + faint + '">';
      M.forEach(function (m) { o += horiz ? '<path d="M' + P(m.v) + ' ' + f2(at - 1.5) + 'V' + f2(m.to - .8) + '"/>' : '<path d="M' + f2(at - 1.5) + ' ' + P(m.v) + 'H' + f2(m.to - .8) + '"/>'; });
      o += '</g><g fill="none" stroke="' + rule + '" stroke-width=".25">';
      o += horiz ? '<path d="M' + P(M[0].v) + ' ' + at + 'H' + P(M[M.length - 1].v) + '"/>' : '<path d="M' + at + ' ' + P(M[0].v) + 'V' + P(M[M.length - 1].v) + '"/>';
      M.forEach(function (m) { var p = P(m.v); o += horiz ? '<path d="M' + f2(p - 1) + ' ' + f2(at + 1) + 'l2 -2"/>' : '<path d="M' + f2(at - 1) + ' ' + f2(p + 1) + 'l2 -2"/>'; });
      o += '</g>';
      var alt = false;
      for (var k = 1; k < M.length; k++) {
        var seg = M[k].v - M[k - 1].v, mid = P((M[k].v + M[k - 1].v) / 2), s = num(seg);
        var tight = seg * sc < s.length * 1.35 + 1.2;
        alt = tight ? !alt : false;
        var off = alt ? 4 : 0;
        o += horiz ? tx(mid, at - 1.1 - off, s, { a: 'middle', s: 2.5 }) : tx(at - 1.1 - off, mid, s, { a: 'middle', s: 2.5, r: true });
      }
      return o;
    }
    var top = Infinity, bot = -Infinity, right = 0;
    F.forEach(function (f) { top = Math.min(top, f.y); bot = Math.max(bot, f.y + f.h); right = Math.max(right, f.x + f.w); });
    var hx = [{ v: 0, to: oy }, { v: W, to: oy }], vy = [{ v: 0, to: ox }, { v: H, to: ox }];
    F.forEach(function (f) {
      hx.push({ v: f.x, to: Y(f.y) }, { v: f.x + f.w, to: Y(f.y) });
      vy.push({ v: f.y, to: X(f.x) }, { v: f.y + f.h, to: X(f.x) });
    });
    var o = '';
    /* le mur, le sol hachuré, l'axe */
    o += '<rect x="' + X(0) + '" y="' + Y(0) + '" width="' + f2(W * sc) + '" height="' + f2(H * sc) + '" fill="#fbfaf7" stroke="' + ink + '" stroke-width=".35"/>';
    o += '<path d="M' + f2(X(0) - 5) + ' ' + Y(H) + 'H' + f2(X(W) + 5) + '" stroke="' + ink + '" stroke-width=".8"/>';
    var hatch = '';
    for (var hxp = X(0) - 4; hxp < X(W) + 4; hxp += 2.2) hatch += 'M' + f2(hxp) + ' ' + f2(Y(H) + 2.4) + 'l2.2 -2.2';
    o += '<path d="' + hatch + '" stroke="' + rule + '" stroke-width=".18" fill="none"/>';
    o += '<path d="M' + X(W / 2) + ' ' + Y(0) + 'V' + Y(H) + '" stroke="' + rule + '" stroke-width=".2" stroke-dasharray="3 1 .6 1" fill="none"/>';
    o += tx(X(0), Y(H) + 6.2, t('print_svg_floor', 'Sol'), { s: 2.5, c: soft });
    o += tx(X(W / 2), Y(H) + 6.2, tfill('print_svg_axis', 'Axe du mur · {x} du bord gauche', { x: cmTxt(W / 2) }), { a: 'middle', s: 2.5, c: soft });
    /* les chaînes de cotes */
    if (F.length) {
      o += chain(hx, true, f2(Y(0) - 7));
      o += chain(vy, false, f2(X(0) - 7));
    }
    /* les cadres : contour, tirage, numéro, cotes extérieures, clou */
    var nailTags = F.every(function (f) { return f.w * sc >= 13; });
    F.forEach(function (f) {
      var x = X(f.x), y = Y(f.y), w = f2(f.w * sc), h = f2(f.h * sc), cx = X(f.x + f.w / 2), cy = Y(f.y + f.h / 2);
      o += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="#fff" stroke="' + ink + '" stroke-width=".45"/>';
      o += '<rect x="' + X(f.x + (f.w - f.pw) / 2) + '" y="' + Y(f.y + (f.h - f.ph) / 2) + '" width="' + f2(f.pw * sc) + '" height="' + f2(f.ph * sc) + '" fill="#efebe4"/>';
      var big = h > 16 && w > 13, r = Math.min(3.4, w / 4, h / 5), ry = f2(cy - (big ? 1.6 : 0));
      o += '<circle cx="' + cx + '" cy="' + ry + '" r="' + f2(r) + '" fill="#fff" stroke="' + ink + '" stroke-width=".3"/>';
      o += tx(cx, ry + r * .38, String(f.n), { a: 'middle', s: f2(r * 1.05), w: 600 });
      if (big) o += tx(cx, ry + r + 3, Math.round(f.w) + ' × ' + Math.round(f.h), { a: 'middle', s: 2.3, c: soft });
      var nx = X(f.nx), ny = Y(f.ny);
      o += '<path d="M' + f2(nx - 1.6) + ' ' + ny + 'h3.2M' + nx + ' ' + f2(ny - 1.6) + 'v3.2" stroke="' + red + '" stroke-width=".4"/>';
      /* la hauteur du clou à côté de sa croix, sur tous les cadres ou sur aucun : si l'un d'eux est trop étroit pour la porter, la légende la donne */
      if (nailTags) o += tx(nx + 2, ny + .9, '↑ ' + num(H - f.ny), { s: 2.2, c: red, w: 600 });
    });
    /* à droite, la hauteur du centre : la ligne du centre en tirets, la cote, la grande valeur */
    if (F.length) {
      var cyCm = (top + bot) / 2, cyy = Y(cyCm), cx2 = f2(X(W) + 9);
      o += '<path d="M' + X(right) + ' ' + cyy + 'H' + f2(cx2 + 2) + '" stroke="' + ink + '" stroke-width=".25" stroke-dasharray="1.6 1" fill="none"/>';
      o += '<path d="M' + cx2 + ' ' + cyy + 'V' + Y(H) + 'M' + f2(cx2 - 2) + ' ' + cyy + 'h4" stroke="' + ink + '" stroke-width=".45" fill="none"/>';
      o += '<path d="M' + cx2 + ' ' + f2(cyy + .3) + 'l-1.1 2.6h2.2z" fill="' + ink + '"/>';
      var py = f2(Math.max(cyy + 6, (cyy + Y(H)) / 2));
      o += '<rect x="' + f2(cx2 - 8.5) + '" y="' + f2(py - 4.6) + '" width="17" height="9.2" rx="1.6" fill="' + ink + '"/>';
      o += tx(cx2, py + .2, num(H - cyCm), { a: 'middle', s: 3.9, w: 600, c: '#fff' });
      o += tx(cx2, py + 3.3, t('print_hang_unit', 'cm du sol'), { a: 'middle', s: 1.8, c: '#fff' });
      o += tx(cx2, f2(cyy - 2.2), t('print_hang_center', 'centre'), { a: 'middle', s: 2.2, c: soft });
    }
    /* l'en-tête */
    var head = tx(12, 15, t('print_title_html', 'Bisou Rivage — Plan d\'accrochage'), { s: 5.4, w: 500 }) +
      tx(285, 15, tfill('print_wall_line', 'Mur {width} × {height} cm · {date}', { width: Math.round(W), height: Math.round(H), date: new Date().toLocaleDateString(document.documentElement.lang || 'fr-FR') }), { a: 'end', s: 2.8, c: soft }) +
      '<path d="M12 19H285" stroke="' + ink + '" stroke-width=".5"/>' +
      tx(12, 25, tfill('print_scale', 'Échelle 1:{n} · cotes en centimètres, prises sur l’extérieur des cadres', { n: Math.round(10 / sc) }), { s: 2.4, c: soft });
    var warn = F.length ? wallFitText() : '';
    if (warn) head += tx(12, 30, warn, { s: 2.6, c: red, w: 600 });
    /* la légende */
    var LX = 216, ly = 32, leg = '<path d="M' + (LX - 5) + ' 28V198" stroke="' + faint + '" stroke-width=".25"/>';
    leg += tx(LX, ly, t('print_legend_title', 'Les cadres'), { s: 3.2, w: 600 }); ly += 6;
    F.forEach(function (f) {
      leg += '<circle cx="' + (LX + 2.4) + '" cy="' + f2(ly - 1) + '" r="2.4" fill="none" stroke="' + ink + '" stroke-width=".3"/>' + tx(LX + 2.4, ly, String(f.n), { a: 'middle', s: 2.6, w: 600 });
      var title = f.title.length > 34 ? f.title.slice(0, 33) + '…' : f.title;
      leg += tx(LX + 7, ly, title, { s: 2.8, w: 600 });
      leg += tx(LX + 7, ly + 3.8, tfill('print_cell_format', '{fmt} · {frame}', { fmt: f.fmt + ' ' + f.pw + ' × ' + f.ph, frame: f.frame }) + ' · ' + tfill('print_leg_outer', 'cadre {w} × {h} cm', { w: Math.round(f.w), h: Math.round(f.h) }), { s: 2.4, c: soft });
      leg += tx(LX + 7, ly + 7.4, tfill('print_leg_nail', 'Clou : {x} du bord gauche · {h} du sol', { x: cmTxt(f.nx), h: cmTxt(H - f.ny) }), { s: 2.4, c: red, w: 600 });
      ly += 12.4;
    });
    var byX = F.slice().sort(function (a, b) { return a.nx - b.nx; });
    if (byX.length > 1) {
      ly += 1.5; leg += tx(LX, ly, t('print_gaps_title', 'Entre les clous'), { s: 2.8, w: 600 }); ly += 4.2;
      for (var g = 1; g < byX.length; g++) {
        var dx = byX[g].nx - byX[g - 1].nx, dy = byX[g].ny - byX[g - 1].ny;
        leg += tx(LX, ly, tfill('print_gap_line', 'Clou {a} → clou {b} : {dx} à l’horizontale', { a: byX[g - 1].n, b: byX[g].n, dx: cmTxt(dx) }) +
          (Math.abs(dy) >= 0.25 ? tfill('print_gap_dy', ', {dy} plus {dir}', { dy: cmTxt(Math.abs(dy)), dir: dy > 0 ? t('print_lower', 'bas') : t('print_higher', 'haut') }) : t('print_gap_level', ', même hauteur')), { s: 2.4 });
        ly += 3.5;
      }
    }
    ly += 2.5; leg += tx(LX, ly, t('print_steps_title', 'La pose'), { s: 2.8, w: 600 }); ly += 4.2;
    [
      tfill('print_step_axis', 'Tracez au crayon l’axe du mur, à {x} du bord gauche, et la ligne des {h} du sol.', { x: cmTxt(W / 2), h: cmTxt(state.hang || CFG.hangLine) }),
      t('print_step_mark', 'Pour chaque clou, reportez sa distance au bord gauche, puis sa hauteur depuis le sol : une croix par clou.'),
      t('print_step_level', 'Vérifiez au niveau les croix d’une même hauteur avant de percer.'),
      tfill('print_step_hang', 'Accrochez chaque cadre : son attache tombe au milieu, {drop} sous le haut du cadre. Réglez le niveau sur le bord supérieur.', { drop: cmTxt(drop) })
    ].forEach(function (s, i) {
      wrap(s, 50).forEach(function (l, j) { leg += tx(LX + 3.6, ly, l, { s: 2.3 }) + (j ? '' : tx(LX, ly, (i + 1) + '.', { s: 2.3, w: 600 })); ly += 3.2; });
      ly += .8;
    });
    wrap(t('print_note_outer', 'Cotes comptées sur l’extérieur des cadres RÖDALM, baguette comprise. Le gris clair, dans chaque cadre, est le tirage.'), 56).forEach(function (l, j, A) {
      leg += tx(LX, 201 - (A.length - 1 - j) * 2.9, l, { s: 2.1, c: soft });
    });
    return '<svg xmlns="http://www.w3.org/2000/svg" class="brp-sheet" width="297mm" height="210mm" viewBox="0 0 297 210" font-family="Archivo,Helvetica,Arial,sans-serif">' +
      '<rect width="297" height="210" fill="#fff"/>' + head + o + leg + '</svg>';
  }
  function buildPrint() {
    var area = document.getElementById('brpPrintArea');
    if (area) area.innerHTML = planSheet();
  }
  /* L'aperçu avant d'imprimer (Max, 27/10 : « avant de l'imprimer, je devrais
     avoir un visuel de ce plan ») : la feuille même, à l'écran, avec « Imprimer »,
     « Télécharger » et la place d'une vidéo pour bien accrocher un cadre. */
  function openPlan() {
    if (state.scale !== 'real') { state.scale = 'real'; relayout(); renderAll(); }
    var m = document.getElementById('brpPlanModal');
    if (!m) {
      m = document.createElement('div');
      m.className = 'br-modal br-planmodal';
      m.id = 'brpPlanModal';
      m.hidden = true;
      m.innerHTML =
        '<div class="br-modal__backdrop" data-close></div>' +
        '<div class="br-modal__box br-planmodal__box" role="dialog" aria-modal="true" aria-labelledby="brpPlanTitle">' +
          '<div class="br-modal__h"><h3 id="brpPlanTitle">' + esc(t('plan_preview_title', 'Votre plan d’accrochage')) + '</h3>' +
          '<button type="button" class="br-modal__x" data-close aria-label="' + esc(t('plan_close', 'Fermer')) + '">×</button></div>' +
          '<div class="br-planmodal__body">' +
            '<div class="br-planmodal__paper"><div class="br-planmodal__sheet" id="brpPlanSheet"></div></div>' +
            '<div class="br-planmodal__side">' +
              '<p class="br-planmodal__lead">' + esc(t('plan_preview_lead', 'Une feuille A4 paysage, à imprimer à 100 %. Toutes les cotes sont celles de votre mur.')) + '</p>' +
              '<button type="button" class="br-cta br-cta--full" id="brpPlanPrint">' + esc(t('plan_print', 'Imprimer')) + '</button>' +
              '<button type="button" class="br-planmodal__dl" id="brpPlanDownload">' + esc(t('plan_download', 'Télécharger l’image (PNG)')) + '</button>' +
              '<div class="br-planmodal__video" id="brpPlanVideo">' +
                '<span class="br-planmodal__play" aria-hidden="true"></span>' +
                '<span class="br-planmodal__vt">' + esc(t('plan_video_title', 'Comment bien accrocher un cadre')) + '</span>' +
                '<span class="br-planmodal__vs">' + esc(t('plan_video_soon', 'Vidéo · bientôt ici')) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      root.appendChild(m);
      m.addEventListener('click', function (e) {
        if (e.target.closest('[data-close]')) { closePlan(); return; }
        if (e.target.closest('#brpPlanPrint')) { printPlan(); return; }
        if (e.target.closest('#brpPlanDownload')) downloadPlan();
      });
    }
    document.getElementById('brpPlanSheet').innerHTML = planSheet();
    m.hidden = false;
    var pb = document.getElementById('brpPlanPrint'); if (pb) pb.focus({ preventScroll: true });
  }
  function closePlan() {
    var m = document.getElementById('brpPlanModal'); if (m) m.hidden = true;
    var b = document.getElementById('brpPrint'); if (b) b.focus({ preventScroll: true });
  }
  /* « Télécharger » : la même feuille en PNG de 3 508 × 2 480 px (A4 à 300 dpi),
     peinte par le navigateur lui-même ; sans bibliothèque. */
  function downloadPlan() {
    var src = planSheet(), img = new Image();
    var url = URL.createObjectURL(new Blob([src], { type: 'image/svg+xml;charset=utf-8' }));
    img.onload = function () {
      var cv = document.createElement('canvas'); cv.width = 3508; cv.height = 2480;
      var g = cv.getContext('2d'); g.fillStyle = '#fff'; g.fillRect(0, 0, cv.width, cv.height);
      g.drawImage(img, 0, 0, cv.width, cv.height);
      URL.revokeObjectURL(url);
      cv.toBlob(function (b) {
        if (!b) return;
        var a = document.createElement('a'), u = URL.createObjectURL(b);
        a.href = u; a.download = t('plan_file', 'plan-accrochage-bisou-rivage') + '.png';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(u); }, 4000);
      }, 'image/png');
    };
    img.src = url;
  }

  /* ---------- panier réel ---------- */
  var busy = false;
  function addCart() {
    var n = state.frames.length; if (n < 1 || busy) return;
    var items = [];
    var compoId = 'compo-' + Date.now();
    var name = compoCartName();
    for (var i = 0; i < state.frames.length; i++) {
      var e = entry(state.frames[i]);
      if (!e) { toast(t('toast_variant_missing', 'Variante introuvable — réessayez')); return; }
      if (!e.av) { toast(tfill('toast_sold_out', '« {title} » est épuisé dans ce format', { title: catById[state.frames[i].id].title })); return; }
      items.push({ id: e.vid, quantity: 1, properties: { '_compo': compoId, 'Composition': name } });
    }
    busy = true; renderFoot();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      /* Plus de détour par /discount/. Les crans sont des remises automatiques :
         Shopify les applique seul, et le panier affiche le montant réel.
         Le mur est gardé pour le retour (24/10) : revenu du panier par la flèche, le
         client retrouvait les deux tirages de l'adresse (?ids=), pas son mur. */
      keepForBack();
      window.location.href = CFG.cartUrl;
    }).catch(function () {
      busy = false; renderFoot();
      toast(t('toast_cart_error', 'Impossible d’ajouter au panier — réessayez'));
    });
  }

  /* ---------- toast ---------- */
  var toastTimer = null;
  function toast(msg) {
    var t = $('#brpToast'); t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------- modes d'aperçu ---------- */
  function renderPreviewModes() {
    Array.prototype.forEach.call($$('#brpPreviewModes [data-preview]'), function (b) {
      b.classList.toggle('on', b.dataset.preview === state.previewMode);
    });
    var rotate = $('#brpPreviewModes [data-rotate]');
    if (rotate) rotate.classList.toggle('on', state.rotated);
    $('#brpPreviewZoom').classList.toggle('show', state.previewMode === 'large');
  }
  function setFullscreen(active) {
    if (active && state.scale === 'real') {
      state.fsRestoreScale = 'real';
      state.scale = 'auto';
      relayout();
    } else if (!active && state.fsRestoreScale) {
      state.scale = state.fsRestoreScale;
      state.fsRestoreScale = null;
      relayout();
    }
    root.classList.toggle('br-fs', active);
    root.classList.remove('br-preview-large');
    state.previewMode = active ? 'fullscreen' : 'normal';
    $('#brpFs').setAttribute('aria-expanded', active ? 'true' : 'false');
    $('#brpFs').setAttribute('aria-label', active ? t('fullscreen_close', 'Fermer le plein écran') : t('fullscreen', 'Plein écran'));
    renderPreviewModes(); fit(); renderFrames(); renderLeader();
  }
  function setPreviewMode(mode) {
    if (mode === 'fullscreen') { setFullscreen(!root.classList.contains('br-fs')); return; }
    if (root.classList.contains('br-fs')) setFullscreen(false);
    root.classList.toggle('br-preview-large', mode === 'large');
    state.previewMode = mode === 'large' ? 'large' : 'normal';
    $('#brpFs').setAttribute('aria-expanded', 'false');
    $('#brpFs').setAttribute('aria-label', t('fullscreen', 'Plein écran'));
    renderPreviewModes(); fit(); renderFrames();
  }

  /* La pastille devient un bouton qui ouvre la palette, posée dans le volet sous
     la ligne − ● + : elle pousse le reste au lieu de couvrir le mur. */
  function wirePalette() {
    var old = $('#brpSatDot'), row = old && old.closest('.brp-sat');
    if (!row) return;
    var dot = document.createElement('button');
    dot.type = 'button'; dot.id = 'brpSatDot'; dot.className = 'brp-sat__dot';
    dot.setAttribute('aria-label', t('planner.wall_palette_open', 'Choisir la couleur du mur'));
    dot.setAttribute('aria-expanded', 'false');
    dot.setAttribute('aria-controls', 'brpPalette');
    old.parentNode.replaceChild(dot, old);
    var pal = document.createElement('div');
    pal.id = 'brpPalette'; pal.className = 'brp-palette'; pal.hidden = true;
    pal.setAttribute('role', 'group');
    pal.setAttribute('aria-label', t('planner.wall_palette', 'Couleur du mur'));
    pal.innerHTML =
      '<div class="brp-palette__grid">' + WALL_SWATCHES.map(function (w) {
        return '<button type="button" class="brp-palette__sw" data-wall-hex="' + w[1] + '" aria-pressed="false" title="' + esc(w[0]) + '" aria-label="' + esc(w[0]) + '">' +
          '<span style="background:' + (w[1] || '#ffffff') + '"></span></button>';
      }).join('') + '</div>' +
      '<form class="brp-palette__own" novalidate>' +
        '<label class="brp-palette__lbl" for="brpWallCode">' + esc(t('planner.wall_own', 'Votre couleur')) + '</label>' +
        '<div class="brp-palette__row">' +
          '<input type="text" id="brpWallCode" class="brp-palette__in" autocomplete="off" spellcheck="false" maxlength="16" placeholder="' + esc(t('planner.wall_own_ph', '#E8DCCB ou RAL 9010')) + '">' +
          '<button type="submit" class="brp-palette__ok">' + esc(t('planner.wall_own_apply', 'Appliquer')) + '</button>' +
        '</div>' +
        '<p class="brp-palette__msg" id="brpWallMsg" aria-live="polite"></p>' +
      '</form>' +
      '<p class="brp-palette__note">' + esc(t('planner.wall_note', 'Couleurs approchées à l’écran. Pantone : entrez son code hexadécimal.')) + '</p>';
    row.parentNode.insertBefore(pal, row.nextSibling);
    var msg = pal.querySelector('#brpWallMsg');
    function setHex(hex) {
      state.wallColor.hex = hex || null;
      if (!hex) state.wallColor.s = 0;
      state.wallColorSet = true;
      fit(); renderOptions();
    }
    function toggle(open) {
      pal.hidden = !open;
      dot.setAttribute('aria-expanded', open ? 'true' : 'false');
      syncViewport(); fit(); renderFrames(); renderLeader();
      /* Ouverte en bas d'un volet borné (iPad, téléphone), elle tombait sous la
         caisse : on fait défiler le volet seul, jamais la page. */
      var body = open && pal.closest('.brp-panel-body');
      if (!body || body.scrollHeight <= body.clientHeight) return;
      var pr = pal.getBoundingClientRect(), br = body.getBoundingClientRect();
      var bottom = Math.min(br.bottom, window.innerHeight);
      var bar = document.getElementById('brpBuyBar');
      if (bar) { var bt = bar.getBoundingClientRect().top; if (bt > br.top && bt < bottom) bottom = bt; }
      var over = pr.bottom + 8 - bottom;
      if (over > 0) body.scrollTop += Math.min(over, Math.max(0, pr.top - br.top - 8));
    }
    dot.addEventListener('click', function () { toggle(pal.hidden); });
    pal.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wall-hex]');
      if (!b) return;
      msg.textContent = '';
      setHex(b.dataset.wallHex);
    });
    pal.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var r = parseWallCode(pal.querySelector('#brpWallCode').value);
      if (r && r.hex) {
        setHex(r.hex);
        msg.textContent = tfill('planner.wall_own_done', '{code} posé sur le mur.', { code: r.label });
      } else if (r && r.pantone) {
        msg.textContent = t('planner.wall_own_pantone', 'Pantone n’a pas de table libre : entrez son code hexadécimal (#RRVVBB).');
      } else {
        msg.textContent = t('planner.wall_own_bad', 'Code non reconnu. Exemples : #E8DCCB, RAL 9010.');
      }
    });
    pal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); toggle(false); dot.focus(); }
    });
  }

  /* a26 (Max, 26/10 : « espacement, couleur du mur et les autres réglages, refais
     en mieux comme sur la page Tous nos tirages ») : la teinte et − ● + passent
     dans un rail, comme la barre de Tous nos tirages ; au premier geste sur la
     couleur, le champ #RRVVBB s'ouvre à côté du titre. Il suit le mur ; un code
     tapé teint le mur tel quel et met le curseur sur sa teinte. */
  function wireWallHex() {
    var hue = $('#brpHue'), grp = hue && hue.closest('.br-wgroup');
    if (!grp || $('#brpHex')) return;
    var sat = grp.querySelector('.brp-sat'), lbl = grp.querySelector('.br-lbl');
    var rail = document.createElement('div');
    rail.className = 'brp-rail brp-rail--wall';
    grp.insertBefore(rail, hue);
    rail.appendChild(hue);
    if (sat) rail.appendChild(sat);
    var head = document.createElement('div');
    head.className = 'brp-whead';
    grp.insertBefore(head, rail);
    if (lbl) head.appendChild(lbl);
    var hex = document.createElement('input');
    hex.type = 'text'; hex.id = 'brpHex'; hex.className = 'brp-hex';
    /* RVB en français, RGB ailleurs (27/10, langues : « #RRVVBB » sortait en en, es, ja) */
    var hexModele = /^fr/i.test(document.documentElement.lang || 'fr') ? '#RRVVBB' : '#RRGGBB';
    hex.maxLength = 7; hex.placeholder = hexModele; hex.spellcheck = false;
    hex.setAttribute('autocomplete', 'off');
    hex.setAttribute('aria-label', (lbl ? lbl.textContent.trim() + ' ' : '') + '(' + hexModele + ')');
    head.appendChild(hex);
    var pal = $('#brpPalette');
    if (pal && pal.parentNode !== grp) grp.insertBefore(pal, rail.nextSibling);
    function show() { grp.classList.add('is-hex'); }
    hue.addEventListener('pointerdown', show);
    hue.addEventListener('input', show);
    ['#brpSatDown', '#brpSatUp', '#brpSatDot'].forEach(function (s) { var b = $(s); if (b) b.addEventListener('click', show); });
    hex.addEventListener('input', function () {
      var v = (hex.value || '').trim().replace(/^#?/, '#').toLowerCase();
      if (/^#[0-9a-f]{3}$/.test(v)) v = '#' + v[1] + v[1] + v[2] + v[2] + v[3] + v[3];
      var ok = /^#[0-9a-f]{6}$/.test(v);
      hex.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (!ok) return;
      var r = parseInt(v.substr(1, 2), 16), g = parseInt(v.substr(3, 2), 16), b = parseInt(v.substr(5, 2), 16);
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn, h = 0;
      if (d) h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
      h = Math.round(h * 60); if (h < 0) h += 360;
      state.wallColor.hex = v === '#ffffff' ? null : v;
      if (v === '#ffffff') state.wallColor.s = 0;
      if (d) state.wallColor.h = h;
      state.wallColorSet = true;
      fit(); renderOptions();
    });
    hex.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); hex.blur(); } });
    hex.addEventListener('blur', function () { renderOptions(); });
  }

  /* ---------- wiring ---------- */
  function wire() {
    $('#brpDispo').addEventListener('click', function (e) {
      var b = e.target.closest('[data-count-step]');
      if (!b || b.disabled) return;
      var step = +b.dataset.countStep;
      /* Le « + » ouvre la fenêtre de choix au lieu de poser une place vide :
         ajouter un cadre, c'est choisir une œuvre. La place vide était un
         détour — on cliquait « + », puis il fallait comprendre qu'il restait
         un trou à remplir. */
      if (step > 0) {
        if (state.frames.length >= CFG.maxFrames) { toast(tfill('toast_max_frames', 'Maximum {max} cadres', { max: CFG.maxFrames })); return; }
        openPicker('new');
        return;
      }
      setCount(state.frames.length + step);
    });
    var duoBox = $('#brpDuo');
    if (duoBox) duoBox.addEventListener('click', function (e) { var b = e.target.closest('[data-count-set]'); if (b) setDuo(+b.dataset.countSet); });
    $('#brpSize').addEventListener('click', function (e) { var b = e.target.closest('[data-gfmt]'); if (b) setGlobalFormat(b.dataset.gfmt); });
    $('#brpFrameG').addEventListener('click', function (e) { var b = e.target.closest('[data-gframe]'); if (b) setGlobalFrame(b.dataset.gframe); });
    $('#brpShuffleSize').addEventListener('click', function () { setGlobalFormat('random'); });
    $('#brpShuffleFrames').addEventListener('click', function () { setGlobalFrame('random'); });
    $('#brpGap').addEventListener('input', function (e) {
      state.gap = Math.max(2, Math.min(25, +e.target.value || 7));
      relayout(); renderAll();
    });
    $('#brpHue').addEventListener('input', function (e) {
      state.wallColor.hex = null;
      state.wallColorSet = true;
      state.wallColor.h = +e.target.value;
      if (state.wallColor.s === 0) state.wallColor.s = 2;
      fit(); renderOptions();
    });
    /* Les deux volets se replient sous 1100 px, où ils passent sous le mur.
       Sur ordinateur l'en-tête n'est qu'un titre : on ne replie pas une colonne
       qui a la place de rester ouverte. */
    Array.prototype.forEach.call($$('[data-panel-toggle]'), function (btn) {
      btn.addEventListener('click', function () {
        /* v6 (22/10) : sur ordinateur, seul le volet du mur se replie */
        var desk = window.innerWidth >= 1100;
        if (desk && btn.dataset.panelToggle !== 'brpWallBody') return;
        var body = document.getElementById(btn.dataset.panelToggle);
        if (!body) return;
        var open = btn.getAttribute('aria-expanded') !== 'true';
        if (desk) {
          wallOpen = open;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          body.hidden = !open;
          return;
        }
        /* Un seul volet ouvert à la fois : sur un téléphone, deux volets
           dépliés ne laissent plus rien au mur. */
        if (open) {
          Array.prototype.forEach.call($$('[data-panel-toggle]'), function (other) {
            if (other === btn) return;
            var ob = document.getElementById(other.dataset.panelToggle);
            if (ob) { ob.hidden = true; other.setAttribute('aria-expanded', 'false'); }
          });
        }
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.hidden = !open;
        root.classList.toggle('has-panel', open);
        /* Pas de scrollIntoView : il faisait défiler la page entière, le mur
           sortait par le haut et le pied de page apparaissait sous la caisse.
           Le volet est borné en hauteur — il tient sous son en-tête, et défile
           dans lui-même s'il est long. */
        syncViewport(); fit(); renderFrames(); renderLeader();
      });
    });
    $('#brpSatUp').addEventListener('click', function () { state.wallColor.hex = null; state.wallColorSet = true; state.wallColor.s = Math.min(CFG.satLevels.length - 1, state.wallColor.s + 1); fit(); renderOptions(); });
    $('#brpSatDown').addEventListener('click', function () { state.wallColor.hex = null; state.wallColorSet = true; state.wallColor.s = Math.max(0, state.wallColor.s - 1); fit(); renderOptions(); });
    wirePalette();
    wireWallHex();
    $('#brpPopFmt').addEventListener('click', function (e) { var b = e.target.closest('[data-fmt]'); if (b) setSelFormat(b.dataset.fmt); });
    $('#brpPopFrames').addEventListener('click', function (e) { var b = e.target.closest('[data-frame]'); if (b && !b.disabled) setSelFrame(b.dataset.frame); });
    $('#brpPopSwap').addEventListener('click', function () { if (state.sel) openPicker(state.sel); });
    $('#brpPopDel').addEventListener('click', function () { if (state.sel) removeFrame(state.sel); });
    $('#brpAlign').addEventListener('click', function (e) {
      var b = e.target.closest('[data-align]'); if (!b) return;
      state.align = b.dataset.align;
      relayout(); renderAll();
    });
    $('#brpHang').addEventListener('input', function (e) {
      state.hang = Math.max(120, Math.min(200, +e.target.value || CFG.hangLine));
      $('#brpHangValue').textContent = tfill('gap_value', '{value} cm', { value: state.hang });
      if (state.scale === 'real') { relayout(); renderAll(); }
    });
    $('#brpAdd').addEventListener('click', function () { openPicker('new'); });
    $('#brpFs').addEventListener('click', function () { setFullscreen(!root.classList.contains('br-fs')); });
    /* La rotation : elle n'existait que dans la barre de modes, que le mode
       « un seul écran » masque. Elle devient un bouton du plein écran. */
    var rotBtn = $('#brpRotate');
    if (rotBtn) rotBtn.addEventListener('click', function () {
      state.rotated = !state.rotated;
      rotBtn.classList.toggle('on', state.rotated);
      deselect(); renderPreviewModes(); fit(); renderFrames(); renderLeader();
    });
    $('#brpPreviewModes').addEventListener('click', function (e) {
      var mode = e.target.closest('[data-preview]');
      var rotate = e.target.closest('[data-rotate]');
      if (mode) setPreviewMode(mode.dataset.preview);
      if (rotate) {
        state.rotated = !state.rotated;
        deselect(); renderPreviewModes(); fit(); renderFrames();
      }
      var zoom = e.target.closest('[data-preview-zoom]');
      if (zoom) {
        state.largeZoom = Math.max(1.25, Math.min(2.8, state.largeZoom + (+zoom.dataset.previewZoom * .2)));
        fit(); renderFrames();
      }
    });
    $('#brpStage').addEventListener('pointerdown', function (e) {
      if (!e.target.closest('.br-frame') && !e.target.closest('.br-frame-cap') && !e.target.closest('.br-ghost') && !e.target.closest('#brpFs') && !e.target.closest('#brpPreviewModes') && !e.target.closest('.br-pop') && !e.target.closest('.brp-side-add') && !e.target.closest('.brp-luck')) deselect();
    });
    /* Le titre et « Voir le tirage » du panneau mènent à la fiche : le mur est gardé */
    $('#brpPop').addEventListener('click', function (e) { if (e.target.closest('a[href]')) keepForBack(); });
    $('#brpTabs').addEventListener('click', function (e) { var b = e.target.closest('[data-tab]'); if (b) { state.tab = b.dataset.tab; renderGallery(); } });
    $('#brpCollectionFilters').addEventListener('click', function (e) {
      var b = e.target.closest('[data-collection]'); if (!b) return;
      state.collection = b.dataset.collection;
      Array.prototype.forEach.call($$('#brpCollectionFilters [data-collection]'), function (x) { x.classList.toggle('on', x === b); });
      renderGallery();
    });
    $('#brpArtistFilters').addEventListener('click', function (e) {
      var b = e.target.closest('[data-artist]'); if (!b) return;
      state.artist = b.dataset.artist;
      renderGallery();
    });
    Array.prototype.forEach.call($$('[data-collection-scroll]'), function (b) {
      b.addEventListener('click', function () {
        /* mouvement réduit : un saut, pas un glissé */
        var reduit = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        $('#brpCollectionFilters').scrollBy({ left: (+b.dataset.collectionScroll) * 280, behavior: reduit ? 'auto' : 'smooth' });
      });
    });
    (function () {
      var track = $('#brpCollectionFilters'), drag = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        drag = { x: e.clientX, left: track.scrollLeft };
        track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', function (e) {
        if (!drag) return;
        track.scrollLeft = drag.left - (e.clientX - drag.x);
      });
      track.addEventListener('pointerup', function () { drag = null; });
      track.addEventListener('pointercancel', function () { drag = null; });
    })();
    $('#brpFilters').addEventListener('click', function (e) {
      var b = e.target.closest('[data-f]');
      if (b) {
        state.filter = b.dataset.f;
        Array.prototype.forEach.call($$('#brpFilters [data-f]'), function (x) { x.classList.toggle('on', x === b); });
        renderGallery();
      }
    });
    $('#brpCols').addEventListener('click', function (e) {
      var b = e.target.closest('[data-c]'); if (!b) return;
      var c = b.dataset.c;
      if (c.charAt(0) === 'm') state.colsM = +c.slice(1); else state.colsD = +c;
      renderGallery();
    });
    $('#brpCatalog').addEventListener('click', function (e) {
      var lk = e.target.closest('[data-like]'); if (lk) { toggleLike(lk.dataset.like); }
    });
    $('#brpCatalog').addEventListener('pointerdown', onShelfDown);
    $('#brpAddCart').addEventListener('click', addCart);
    $('#brpMyWall').addEventListener('click', function () {
      state.planAfterWall = false;
      $('#brpWallModal').hidden = false;
      $('#brpWallW').value = Math.round(state.wall.w); $('#brpWallH').value = Math.round(state.wall.h);
    });
    $('#brpWallApply').addEventListener('click', applyWall);
    $('#brpPrint').addEventListener('click', function () {
      /* Le plan a besoin d'un vrai mur pour donner des cotes depuis le sol.
         S'il n'est pas encore configuré, on le demande au lieu de cacher le
         bouton — le visiteur découvrait le plan par accident. */
      if (!state.wallConfigured) {
        state.planAfterWall = true;
        $('#brpWallModal').hidden = false;
        $('#brpWallW').value = Math.round(state.wall.w); $('#brpWallH').value = Math.round(state.wall.h);
        return;
      }
      openPlan();
    });
    window.addEventListener('afterprint', function () {
      document.documentElement.classList.remove('brp-printing');
    });
    function wirePanelToggle(buttonSel, panelSel) {
      $(buttonSel).addEventListener('click', function () {
        var panel = $(panelSel);
        var open = panel.hidden;
        panel.hidden = !open;
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.querySelector('span').textContent = open ? t('hide', 'Masquer') : t('panel_show', 'Afficher');
      });
    }
    wirePanelToggle('#brpSettingsToggle', '#brpSettingsPanel');
    /* Les replis secondaires : leur libellé ne change pas — le bouton dit ce
       qu'il ouvre, pas son état, l'état est porté par la flèche. */
    function wireMore(buttonSel, panelSel) {
      var btn = $(buttonSel);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var panel = $(panelSel);
        var open = panel.hidden;
        panel.hidden = !open;
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    wireMore('#brpFiltersToggle', '#brpMoreFilters');
    wirePanelToggle('#brpGalleryToggle', '#brpGalleryPanel');
    $('#brpPickerOrientation').addEventListener('click', function (e) {
      var b = e.target.closest('[data-picker-filter]'); if (!b) return;
      state.pickerFilter = b.dataset.pickerFilter; renderPicker();
    });
    $('#brpPickerCollection').addEventListener('change', function (e) { state.pickerCollection = e.target.value; renderPicker(); });
    $('#brpPickerEdition').addEventListener('change', function (e) { state.pickerEdition = e.target.value; renderPicker(); });
    $('#brpPickerArtist').addEventListener('change', function (e) { state.pickerArtist = e.target.value; renderPicker(); });
    $('#brpPickerDensity').addEventListener('click', function (e) {
      var b = e.target.closest('[data-picker-cols]'); if (!b) return;
      state.pickerCols = +b.dataset.pickerCols;
      renderPicker();
    });
    ['#brpWallModal', '#brpPicker'].forEach(function (sel) {
      $(sel).addEventListener('click', function (e) {
        if (e.target.dataset.close !== undefined || e.target.closest('[data-close]')) { $(sel).hidden = true; state.pickerTarget = null; state.planAfterWall = false; return; }
        if (sel === '#brpPicker') {
          var lk = e.target.closest('[data-like]'); if (lk) { toggleLike(lk.dataset.like); renderPicker(); return; }
          var pk = e.target.closest('[data-pick]'); if (pk) choose(pk.dataset.pick);
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      /* l'aperçu du plan ouvert : Échap le ferme, même après un clic sur la feuille ; aucune touche n'agit sur le mur derrière */
      var pm = document.getElementById('brpPlanModal');
      if (pm && !pm.hidden) { if (e.key === 'Escape') closePlan(); return; }
      if (e.key === 'Escape') {
        if (!$('#brpPicker').hidden) { closePicker(); return; }
        if (!$('#brpWallModal').hidden) { $('#brpWallModal').hidden = true; state.planAfterWall = false; return; }
        if (root.classList.contains('br-fs')) { setFullscreen(false); return; }
        deselect(); return;
      }
      if (/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName) || !$('#brpPicker').hidden) return;
      var f = selFrame(); if (!f) return;
      if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); removeFrame(state.sel); return; }
      var i = state.frames.indexOf(f);
      if (e.key === 'ArrowLeft' && i > 0) { state.frames.splice(i, 1); state.frames.splice(i - 1, 0, f); }
      else if (e.key === 'ArrowRight' && i < state.frames.length - 1) { state.frames.splice(i, 1); state.frames.splice(i + 1, 0, f); }
      else return;
      state.touched = true;
      e.preventDefault(); relayout(); renderAll();
    });
    var rt, lastMobile = window.innerWidth < 1100;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var mobile = window.innerWidth < 1100;
        if (mobile !== lastMobile) { lastMobile = mobile; syncPanels(); }
        syncViewport(); fit(); renderFrames(); syncBarSpace(); renderLeader(); queueStick();
      }, 120);
    });
    window.addEventListener('scroll', queueStick, { passive: true });
    /* Reprise du 6e tour : choisir un cadre décolle la scène, qui saute vers sa
       place dans la page. Chromium (Android) vise le clic du toucher après coup,
       au même point de l'écran : il tombait à côté du cadre et le « clic à côté »
       le désélectionnait. La page compense le saut avant ce clic, seulement quand
       un cadre vient d'être choisi (refermer recolle la scène, rien à compenser),
       et sous 1100 px seulement, là où la scène colle. */
    root.addEventListener('pointerup', function (e) {
      if (!(e.target.closest && e.target.closest('.br-frame'))) return;
      var blk = $('.br-block:nth-of-type(1)'), t0 = null;
      if (blk && !$('.br-frame.sel') && window.innerWidth < 1100 && !root.classList.contains('br-fs')) t0 = blk.getBoundingClientRect().top;
      document.addEventListener('pointerup', function (ev) {
        if (ev !== e) return;
        if (t0 !== null && $('.br-frame.sel')) { var d = blk.getBoundingClientRect().top - t0; if (Math.abs(d) > 1) window.scrollBy(0, Math.round(d)); }
        requestAnimationFrame(keepSelInView);
      }, { once: true });
    });
    queueStick();
    document.addEventListener('bisou:wishlist', function () { renderGallery(); });
    document.addEventListener('click', function (e) {
      if (!state.sel) return;
      /* Un format ou une couleur touché dans le panneau le redessine avant que le clic arrive ici : le bouton n'est
         plus dans la page, mais le chemin du clic, fixé à son départ, passe toujours par le panneau (24/10 : le panneau
         se fermait à chaque réglage). Un réglage redessiné hors du panneau reste un clic à côté. */
      var inside = '#BRPlanner .br-frame, #BRPlanner .br-pop, #BRPlanner .br-frame-cap, #BRPlanner .brp-layers';
      if (e.composedPath ? e.composedPath().some(function (n) { return n.nodeType === 1 && n.matches(inside); }) : e.target.closest(inside)) return;
      deselect();
    });
  }

  /* ---------- start ---------- */
  function start() {
    if (root.dataset.brpInit) return;
    root.dataset.brpInit = '1';
    wire();
    buildSideAdds();
    buildPieces();
    buildSuggest();
    var q = new URLSearchParams(window.location.search);
    var pid = (q.get('id') || '').trim().toLowerCase();
    var idsParam = q.get('ids');
    var qFmt = (q.get('fmt') || '').toUpperCase();
    if (CFG.formats.indexOf(qFmt) < 0) qFmt = '';
    var qFrame = norm(q.get('frame') || '');
    if (FRAME_KEYS.indexOf(qFrame) < 0) qFrame = '';
    var seeded = [];
    /* Ce que la page a proposé elle-même : 'mate' (le compagnon d'un tirage seul) ou 'pair' (le diptyque) */
    var proposed = '';
    if (idsParam) {
      /* Depuis la fiche produit : le tirage et son compagnon, dans cet ordre */
      idsParam.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean)
        .forEach(function (h) { if (catById[h] && seeded.indexOf(catById[h]) < 0) seeded.push(catById[h]); });
    } else if (pid && catById[pid]) {
      seeded.push(catById[pid]);
    }
    /* De retour d'une fiche ouverte depuis le mur : le mur tel qu'on l'a laissé */
    var back = takeBack();
    /* Rendue depuis le cache du navigateur au retour (Safari), la page garde son mur
       sans repasser ici : la clé du retour ne doit pas servir à la visite suivante */
    window.addEventListener('pageshow', function (e) { if (e.persisted) { try { sessionStorage.removeItem(BACK); } catch (_) {} } });
    if (back) {
      state.frames = back.frames.map(function (f) { return { uid: uidSeq++, id: f.id, fmt: f.fmt, frame: f.frame, x: 0, y: 0 }; });
      state.touched = back.touched;
    } else if (seeded.length) {
      state.frames = [];
      /* Le cadre et le format choisis pour un tirage dans la liste d'envies (bisou-alt-simple.js, clé bvf_wl1_sel,
         le temps de la visite) le suivent sur le mur, si le lien n'en impose pas (25/10). « Sans cadre » n'existe pas
         ici (tout encadré) : seul son format suit. */
      var kept = {};
      try { kept = JSON.parse(sessionStorage.getItem('bvf_wl1_sel')) || {}; } catch (e) { kept = {}; }
      seeded.slice(0, CFG.maxFrames).forEach(function (c) {
        var k = kept[c.id] || {}, kFrame = norm(k.f || '');
        pushFrame(c, qFmt || fmtOf(k.z || '') || '', qFrame || (FRAME_KEYS.indexOf(kFrame) > -1 ? kFrame : ''), 'right');
      });
      /* Toujours un diptyque : un tirage seul reçoit un compagnon (ordre des suggestions) */
      if (state.frames.length === 1) {
        var mate = companionFor(seeded[0], {});
        if (mate) pushFrame(mate, qFmt, qFrame, 'right');
        proposed = 'mate';
      }
      state.touched = false;
    } else if (q.has('vide')) {
      state.frames = [];
      state.touched = false;
    } else {
      seedDiptych();
      proposed = 'pair';
      state.touched = false;
    }
    state.targetCount = state.frames.length;
    /* La fenêtre de choix sert à piocher : sur grand écran on veut voir des
       œuvres, pas deux vignettes géantes. */
    if (window.innerWidth >= 1100) state.pickerCols = 4;
    syncPanels();
    syncViewport();
    relayout(); renderPreviewModes(); renderAll();
    /* Un second passage après la mise en page : au premier, la scène n'a pas
       encore sa hauteur et fit() se rabat sur son repli. */
    requestAnimationFrame(function () { syncViewport(); fit(); renderFrames(); });
    /* Le panier arrive après le premier rendu : un tirage proposé qui y est déjà est
       remplacé, tant que le visiteur n'a pas touché au mur (16/10). */
    readCart(function () {
      if (!proposed || state.touched) return;
      var from = proposed === 'mate' ? 1 : 0;
      if (!state.frames.slice(from).some(function (f) { return CART[f.id]; })) return;
      if (proposed === 'mate') {
        state.frames = state.frames.slice(0, 1);
        var mate2 = companionFor(catById[state.frames[0].id], {});
        if (mate2) pushFrame(mate2, qFmt, qFrame, 'right');
      } else {
        seedDiptych();
      }
      state.targetCount = state.frames.length;
      state.sel = null;
      relayout(); renderAll();
    });
    if (typeof window.subscribe === 'function') {
      try { window.subscribe('cart-update', function () { readCart(); }); } catch (e) { /* bus absent */ }
    }
    /* Sur téléphone, seuls les RÉGLAGES se replient. La galerie est devenue
       l'étape 1 : la replier revenait à dire « choisissez un tirage plus bas »
       en cachant les tirages derrière un bouton. */
    /* En mode « un seul écran » rien ne se replie : il n'y a plus de défilement
       à économiser, et replier les réglages privait le visiteur du format et de
       la finition sans lui laisser de moyen de les rouvrir sous les yeux. */
    if (window.innerWidth < 900 && !root.classList.contains('brp-app')) {
      $('#brpSettingsPanel').hidden = true;
      $('#brpSettingsToggle').setAttribute('aria-expanded', 'false');
      $('#brpSettingsToggle span').textContent = t('panel_show', 'Afficher');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---------- Le mur cadré d'un geste, à l'ordinateur (a26-cac-vue, 26/10) ----------
   Max, 26/10 : « un léger scroll peut faire comme sur la page produit et cadrer
   sans les éléments header / ariane / annonce ». Même mécanique que la fiche
   tirage (bisou-mockup.js) : un coup de molette vers le bas depuis le haut de la
   page pose le mur en haut de l'écran ; un coup vers le haut depuis là ramène le
   sommet. Plus bas, la molette reste libre ; en plein écran, rien ne change. */
(function () {
  if (window.__brpCadrage) return;
  window.__brpCadrage = true;
  var mq = window.matchMedia('(min-width: 1100px)');
  var acc = 0, accDir = 0, accTimer = null, locked = false, lockTimer = null, animId = 0;
  function root() { return document.getElementById('BRPlanner'); }
  function cible() {
    var r = root(), stage = document.getElementById('brpStage');
    var bloc = stage && stage.closest('.br-block');
    if (!r || !bloc || !bloc.offsetParent) return null;
    /* La scène colle sous l'en-tête (c28b, 29/10) : sa place se lit sous le bandeau de Côte à côte, pas là où elle colle */
    var head = r.querySelector('.brp-masthead');
    return Math.round(r.getBoundingClientRect().top + window.scrollY + (head ? head.offsetHeight : 0));
  }
  function peutDefilerDedans(el, dir) {
    for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      var oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) {
        if (dir > 0 ? n.scrollTop + n.clientHeight < n.scrollHeight - 1 : n.scrollTop > 0) return true;
      }
    }
    return false;
  }
  function relacher() {
    clearTimeout(lockTimer);
    lockTimer = setTimeout(function () { locked = false; acc = 0; accDir = 0; }, 140);
  }
  function aller(y) {
    var id = ++animId, from = window.scrollY, dist = y - from;
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var duree = reduit ? 0 : Math.min(520, Math.max(360, Math.abs(dist) * 1.6));
    var t0 = performance.now();
    locked = true;
    setTimeout(function () { if (id === animId) relacher(); }, duree + 400);
    function pas(now) {
      if (id !== animId) return;
      var p = duree ? Math.min(1, (now - t0) / duree) : 1;
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      window.scrollTo(0, from + dist * e);
      if (p < 1) requestAnimationFrame(pas); else relacher();
    }
    requestAnimationFrame(pas);
  }
  /* L'en-tête collant ne s'efface pas seul à l'ordinateur : tant que le mur est
     cadré, html.brp-cadre le pousse hors de l'écran (bisou-planner.css, fin) */
  function marquer() {
    var r = root(), y = mq.matches && r && !r.classList.contains('br-fs') ? cible() : null;
    var bloc = y !== null && document.getElementById('brpStage').closest('.br-block');
    var dedans = y !== null && y >= 24 && window.scrollY >= y - 8 && window.scrollY < y + bloc.offsetHeight - window.innerHeight / 2;
    var avant = document.documentElement.classList.contains('brp-cadre');
    document.documentElement.classList.toggle('brp-cadre', !!dedans);
    /* cadré, la scène prend tout l'écran (bisou-planner.css, c28b) : le mur se recadre comme à un changement de fenêtre */
    if (avant !== !!dedans) window.dispatchEvent(new Event('resize'));
  }
  window.addEventListener('scroll', marquer, { passive: true });
  window.addEventListener('resize', marquer);
  window.addEventListener('wheel', function (ev) {
    var r = root();
    if (!r || !mq.matches || ev.ctrlKey || r.classList.contains('br-fs')) return;
    if (document.documentElement.classList.contains('bisou-product-scroll-free')) return;
    var dir = ev.deltaY > 0 ? 1 : ev.deltaY < 0 ? -1 : 0;
    if (!dir || peutDefilerDedans(ev.target, dir)) return;
    if (locked) { ev.preventDefault(); relacher(); return; }
    var y = cible(), cur = window.scrollY, dest = null;
    if (y === null || y < 24) return;
    if (dir > 0 && cur < y - 8) dest = y;
    else if (dir < 0 && cur > 8 && cur <= y + 8) dest = 0;
    if (dest === null) return;
    ev.preventDefault();
    if (accDir !== dir) { acc = 0; accDir = dir; }
    acc += Math.abs(ev.deltaY) * (ev.deltaMode === 1 ? 16 : 1);
    clearTimeout(accTimer);
    accTimer = setTimeout(function () { acc = 0; }, 160);
    if (acc < 40) return;
    acc = 0;
    aller(dest);
  }, { passive: false });
})();


/* ============================================================
   Côte à côte au téléphone : l'atelier (b27-cac-telephone-a, 27/10).
   Max, 27/10 : « je préfère la version A… beaucoup plus de visuels… le moins de texte possible ».
   Piste A du Labo (r26-cote-a-cote-telephone), portée sur l'ALT. Au téléphone debout (< 750 px),
   le mur en haut, toujours entier ; un tiroir en bas, trois onglets (Cadres, Mur, Plan), une icône
   et un mot chacun, la caisse dessous. Tous les réglages ouverts, la page ne défile plus : seul le
   tiroir défile. Le moteur ci-dessus ne change pas ; ce bloc range ses réglages. La feuille :
   la fin de bisou-planner.css.
   ============================================================ */
(function () {
  'use strict';

  var P = document.getElementById('BRPlanner');
  if (!P) return;
  /* Debout seulement. Couché sous 750 px, le mur n'aurait pas de place : la page normale. Le
     téléphone tourné recharge la page ; la composition revient (le moteur la garde). */
  var Q = window.matchMedia && window.matchMedia('(max-width: 749px) and (orientation: portrait)');
  if (!Q) return;
  var was = Q.matches;
  var turned = function () {
    if (Q.matches === was) return;
    /* Le clavier de certains Android raccourcit la fenêtre (elle passe « couchée ») : pas un
       téléphone tourné. Recharger là effaçait la mesure en cours (relecture, 28/10). */
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return;
    location.reload();
  };
  if (Q.addEventListener) Q.addEventListener('change', turned); else if (Q.addListener) Q.addListener(turned);
  if (!Q.matches) return;

  var en = /^en/i.test(document.documentElement.getAttribute('lang') || '');
  var T = en ? { tabs: ['Frames', 'Wall', 'Plan'], aria: 'Settings' }
             : { tabs: ['Cadres', 'Mur', 'Plan'], aria: 'Réglages' };
  /* es, ja : les textes viennent du pont de la section (BRPlanner.lang), le repli reste fr/en */
  var TL = (window.BRPlanner && window.BRPlanner.lang) || {};
  var tl = function (k, f) { return (typeof TL[k] === 'string' && TL[k]) ? TL[k] : f; };
  T = { tabs: [tl('tel_tab_frames', T.tabs[0]), tl('tel_tab_wall', T.tabs[1]), tl('tel_tab_plan', T.tabs[2])], aria: tl('tel_tabs_aria', T.aria) };
  /* les icônes des onglets : trois cadres, un mur et son niveau, un plan coté */
  var ICONS = [
    '<rect x="3" y="5" width="7" height="9" rx="1"/><rect x="13" y="3" width="8" height="11" rx="1"/><rect x="6" y="16.5" width="12" height="4.5" rx="1"/>',
    '<path d="M3 20h18"/><path d="M5 20V5h14v15"/><path d="M9 9h6v5H9z"/><path d="M12 5V3"/>',
    '<rect x="4" y="3" width="16" height="18" rx="1.5"/><path d="M8 8h3v3H8zM13 13h3v3h-3z"/><path d="M8 16h3M13 8h3"/>'
  ];

  function $(s) { return P.querySelector(s); }
  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    return n;
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function refit() { window.dispatchEvent(new Event('resize')); }

  var block = P.querySelector('.br-block');
  var dock = $('#brpDock');
  var rail = $('#brpRailBody');
  var wall = $('#brpWallBody');
  var bar = $('#brpBuyBar');
  var pop = $('#brpPop');
  if (!block || !dock || !rail || !wall || !bar) return;

  document.documentElement.classList.add('cac-tel-on');
  P.classList.add('cac-tel', 'cac-tel--a');
  /* Tous les réglages, tout le temps : le mode complet (bisou-alt-simple.js n'ôte jamais cette
     classe seul) et les deux volets ouverts, leurs en-têtes cachés par la feuille. */
  P.classList.add('bvf-pl-all');
  each(P.querySelectorAll('[data-panel-toggle]'), function (b) {
    var body = document.getElementById(b.getAttribute('data-panel-toggle'));
    if (body) body.hidden = false;
    b.setAttribute('aria-expanded', 'true');
  });

  var display = wall.querySelector('.br-wgroup--display');
  /* « Autre suggestion », rangée dans le tiroir (créée par le moteur, déplacée seulement : il la
     retrouve par son id) ; la phrase qui explique le choix des tirages reste cachée */
  var sugg = el('div', 'cac-sugg');
  var why = $('#brpWhy'), next = $('#brpNextSuggestion'), luck = next && next.parentNode;
  if (why) sugg.appendChild(why);
  if (luck && luck.classList.contains('brp-luck')) sugg.appendChild(luck);

  var shell = el('div', 'cac-shell cac-shell--a');
  var nav = el('div', 'cac-nav cac-nav--a');
  nav.setAttribute('role', 'tablist');
  nav.setAttribute('aria-label', T.aria);
  var panes = el('div', 'cac-panes');
  var keys = ['cadres', 'mur', 'plan'];
  var pane = {};
  keys.forEach(function (k, i) {
    var b = el('button', 'cac-tab');
    b.type = 'button';
    b.id = 'cacTab-' + k;
    b.setAttribute('role', 'tab');
    b.setAttribute('aria-controls', 'cacPane-' + k);
    b.setAttribute('data-cac-go', k);
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true">' + ICONS[i] + '</svg>';
    var t = el('span', 'cac-tab__t');
    t.textContent = T.tabs[i];
    b.appendChild(t);
    nav.appendChild(b);
    var s = el('section', 'cac-pane');
    s.id = 'cacPane-' + k;
    s.setAttribute('role', 'tabpanel');
    s.setAttribute('aria-labelledby', b.id);
    s.setAttribute('data-cac-pane', k);
    panes.appendChild(s);
    pane[k] = s;
  });

  /* Cadres = le cadre touché, ce qui vaut pour tous, puis « Ajouter » et « Autre suggestion » ; Mur =
     l'alignement, l'écart, la hauteur, la couleur ; Plan = les mesures du mur et le plan. */
  pane.cadres.appendChild(dock);
  pane.cadres.appendChild(rail);
  /* les pastilles d'abord (combien, quel format, quel cadre) ; « Ajouter un tirage » (remis
     en bas du volet par la feuille) et « Autre suggestion » ensuite */
  if (sugg.children.length) pane.cadres.appendChild(sugg);
  pane.mur.appendChild(wall);
  if (display) pane.plan.appendChild(display);
  shell.appendChild(nav);
  shell.appendChild(panes);
  shell.appendChild(bar);
  block.parentNode.insertBefore(shell, block.nextSibling);

  var current = keys[0];
  function go(k) {
    if (keys.indexOf(k) < 0) return;
    current = k;
    each(nav.children, function (b) {
      var on = b.getAttribute('data-cac-go') === k;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    each(panes.children, function (s) { s.hidden = s.getAttribute('data-cac-pane') !== k; });
    panes.scrollTop = 0;
  }
  nav.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cac-go]');
    if (b) go(b.getAttribute('data-cac-go'));
  });
  nav.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var at = keys.indexOf(current) + (e.key === 'ArrowRight' ? 1 : -1);
    if (at < 0 || at >= keys.length) return;
    go(keys[at]);
    nav.children[at].focus();
  });

  /* Toucher un cadre du mur ouvre son réglage en tête de l'onglet Cadres. */
  if (pop && window.MutationObserver) {
    new MutationObserver(function () {
      if (pop.hidden) return;
      go('cadres');
      panes.scrollTop = 0;
    }).observe(pop, { attributes: true, attributeFilter: ['hidden'] });
  }

  go(keys[0]);
  refit();
  setTimeout(refit, 250);
  setTimeout(refit, 1200);
})();
